
export const examQuestionsKoreanBatch1 = [
    {
      id: 1,
      text: "다음 중 AI 효과를 가장 잘 보여주는 것은 무엇입니까? 하나의 옵션을 선택하세요.",
      options: [
        "전문가 시스템이 더 이상 AI로 간주되지 않음",
        "사람들이 AI 시스템을 신뢰하지 않게 됨",
        "AI가 널리 보급되면서 덜 인상적으로 보임",
        "사용자가 AI에서 더 복잡한 동작을 기대함"
      ],
      correct: 0,
      expA: "맞습니다! AI 효과는 기술 발전이 더 이상 인공지능으로 인식되지 않는 현상을 설명합니다.",
      expB: "신뢰 부족은 사용자 경험과 관련되지만 AI 효과 현상 자체는 아닙니다.",
      expC: "이는 인식 적응을 설명하지만 AI 효과의 본질을 드러내지는 않습니다.",
      expD: "증가하는 기대는 결과이지 AI 효과의 정의가 아닙니다.",
      points: 1,
      chapter: "AI 소개",
      difficulty: "K2"
    },
    {
      id: 2,
      text: "다음 중 AI 구현에 가장 일반적으로 사용되는 기술은 무엇입니까? 하나의 옵션을 선택하세요.",
      options: [
        "블록체인 네트워크",
        "신경망",
        "관계형 데이터베이스",
        "웹 서비스"
      ],
      correct: 1,
      expA: "블록체인은 분산 원장에 사용되며 AI 구현에는 사용되지 않습니다.",
      expB: "정확합니다! 신경망은 AI 시스템 구축의 주요 기술입니다.",
      expC: "데이터베이스는 데이터를 저장하지만 AI 기능을 구현하지는 않습니다.",
      expD: "웹 서비스는 통신을 제공하지만 AI 기능은 아닙니다.",
      points: 1,
      chapter: "AI 소개",
      difficulty: "K1"
    },
    {
      id: 3,
      text: "다음 중 좁은 AI와 일반 AI의 차이점을 올바르게 설명하는 것은 무엇입니까? 하나의 옵션을 선택하세요.",
      options: [
        "좁은 AI는 많은 작업을 수행하고 일반 AI는 하나의 작업을 수행함",
        "좁은 AI는 특정 작업을 해결하고 일반 AI는 모든 작업을 해결함",
        "좁은 AI는 더 적은 데이터를 사용하고 일반 AI는 더 많은 데이터를 사용함",
        "좁은 AI는 더 빠르게 작동하고 일반 AI는 더 느리게 작동함"
      ],
      correct: 1,
      expA: "이는 잘못되었습니다 - 좁은 AI는 다중 작업이 아닌 특정 작업에 특화되어 있습니다.",
      expB: "정확합니다! 좁은 AI는 특정 작업에 특화되어 있고 일반 AI는 모든 지적 작업을 해결할 수 있습니다.",
      expC: "사용되는 데이터 양은 이러한 AI 유형 간의 결정적 차이점이 아닙니다.",
      expD: "처리 속도는 좁은 AI와 일반 AI 간의 구별 특징이 아닙니다.",
      points: 1,
      chapter: "AI 소개",
      difficulty: "K2"
    },
    {
      id: 4,
      text: "다음 중 AI 개발에 널리 사용되는 프레임워크는 무엇입니까? 하나의 옵션을 선택하세요.",
      options: [
        "TensorFlow",
        "React",
        "Angular",
        "Vue.js"
      ],
      correct: 0,
      expA: "맞습니다! TensorFlow는 널리 사용되는 AI 및 기계학습 개발 프레임워크입니다.",
      expB: "React는 사용자 인터페이스 구축을 위한 프론트엔드 프레임워크입니다.",
      expC: "Angular는 웹 애플리케이션 개발을 위한 프론트엔드 프레임워크입니다.",
      expD: "Vue.js는 사용자 인터페이스 구축을 위한 프론트엔드 프레임워크입니다.",
      points: 1,
      chapter: "AI 소개",
      difficulty: "K1"
    },
    {
      id: 5,
      text: "다음 중 기계학습에서 지도학습을 가장 잘 설명하는 것은 무엇입니까? 하나의 옵션을 선택하세요.",
      options: [
        "라벨이 있는 데이터를 사용하여 모델을 훈련시킴",
        "라벨이 없는 데이터에서 패턴을 찾음",
        "보상 신호를 통해 학습함",
        "전문가 규칙을 사용하여 결정을 내림"
      ],
      correct: 0,
      expA: "정확합니다! 지도학습은 라벨이 있는 훈련 데이터를 사용하여 모델을 학습시킵니다.",
      expB: "이는 비지도학습을 설명하며 라벨이 없는 데이터를 사용합니다.",
      expC: "이는 강화학습을 설명하며 보상 기반 학습을 사용합니다.",
      expD: "이는 규칙 기반 시스템을 설명하며 기계학습이 아닙니다.",
      points: 1,
      chapter: "AI 소개",
      difficulty: "K2"
    },
    {
      id: 6,
      text: "딥러닝에서 합성곱 신경망(CNN)이 주로 사용되는 분야는 무엇입니까? 하나의 옵션을 선택하세요.",
      options: [
        "컴퓨터 비전",
        "자연어 처리",
        "시계열 예측",
        "추천 시스템"
      ],
      correct: 0,
      expA: "정확합니다! CNN은 이미지 처리와 컴퓨터 비전 작업에 특히 효과적입니다.",
      expB: "자연어 처리에서는 주로 RNN이나 Transformer가 사용됩니다.",
      expC: "시계열 예측에서는 주로 LSTM이나 GRU가 사용됩니다.",
      expD: "추천 시스템에서는 주로 협업 필터링이나 매트릭스 인수분해가 사용됩니다.",
      points: 1,
      chapter: "AI 소개",
      difficulty: "K2"
    },
    {
      id: 7,
      text: "기계학습 모델의 성능 평가에서 F1-점수가 특히 유용한 상황은 언제입니까? 하나의 옵션을 선택하세요.",
      options: [
        "클래스가 불균형한 데이터셋을 다룰 때",
        "회귀 문제를 해결할 때",
        "비지도학습을 평가할 때",
        "강화학습 에이전트를 평가할 때"
      ],
      correct: 0,
      expA: "정확합니다! F1-점수는 불균형 데이터셋에서 정밀도와 재현율의 조화평균으로 유용합니다.",
      expB: "회귀 문제에서는 MAE나 RMSE 같은 메트릭이 더 적합합니다.",
      expC: "비지도학습에서는 실루엣 점수나 클러스터 내 분산 같은 메트릭을 사용합니다.",
      expD: "강화학습에서는 누적 보상이나 에피소드 길이 같은 메트릭을 사용합니다.",
      points: 2,
      chapter: "AI 소개",
      difficulty: "K3"
    },
    {
      id: 8,
      text: "AI 시스템에서 이상 탐지의 주요 목적은 무엇입니까? 하나의 옵션을 선택하세요.",
      options: [
        "모델의 정확도를 향상시키기 위해",
        "정상 패턴에서 벗어난 데이터 포인트를 식별하기 위해",
        "훈련 시간을 단축시키기 위해",
        "메모리 사용량을 줄이기 위해"
      ],
      correct: 1,
      expA: "정확도 향상은 부차적 효과일 수 있지만 이상 탐지의 주요 목적은 아닙니다.",
      expB: "정확합니다! 이상 탐지는 일반적인 패턴에서 벗어난 비정상적인 데이터를 찾는 것입니다.",
      expC: "훈련 시간 단축은 이상 탐지의 목적이 아닌 최적화 기법의 목표입니다.",
      expD: "메모리 사용량 감소는 이상 탐지와 직접적인 관련이 없습니다.",
      points: 1,
      chapter: "AI 소개",
      difficulty: "K2"
    },
    {
      id: 9,
      text: "추천 시스템에서 개인화의 주요 이점은 무엇입니까? 하나의 옵션을 선택하세요.",
      options: [
        "모든 사용자에게 동일한 추천을 제공함",
        "사용자의 선호도와 행동에 맞춘 맞춤형 추천을 제공함",
        "시스템의 복잡성을 줄임",
        "데이터 저장 요구사항을 최소화함"
      ],
      correct: 1,
      expA: "모든 사용자에게 동일한 추천을 제공하는 것은 개인화와 반대되는 개념입니다.",
      expB: "정확합니다! 개인화는 각 사용자의 고유한 선호도와 행동 패턴에 맞춤형 경험을 제공합니다.",
      expC: "개인화는 실제로 시스템의 복잡성을 증가시킵니다.",
      expD: "개인화는 더 많은 사용자 데이터와 프로파일링이 필요합니다.",
      points: 1,
      chapter: "AI 소개",
      difficulty: "K2"
    },
    {
      id: 10,
      text: "챗봇 시스템에서 자연어 처리의 역할은 무엇입니까? 하나의 옵션을 선택하세요.",
      options: [
        "사용자 입력을 이해하고 적절한 응답을 생성하기 위해",
        "데이터베이스 쿼리를 최적화하기 위해",
        "네트워크 지연시간을 줄이기 위해",
        "사용자 인터페이스를 설계하기 위해"
      ],
      correct: 0,
      expA: "정확합니다! NLP는 사용자의 자연어 입력을 해석하고 의미 있는 응답을 생성하는 핵심 기능입니다.",
      expB: "데이터베이스 최적화는 NLP의 역할이 아닌 데이터베이스 관리 기능입니다.",
      expC: "네트워크 지연시간 감소는 네트워킹과 인프라 최적화 영역입니다.",
      expD: "UI 설계는 NLP가 아닌 사용자 경험과 디자인 영역입니다.",
      points: 2,
      chapter: "AI 소개",
      difficulty: "K3"
    },
    {
      id: 11,
      text: "기계학습에서 데이터 드리프트가 모델 성능에 미치는 영향은 무엇입니까? 하나의 옵션을 선택하세요.",
      options: [
        "모델 성능이 항상 향상됨",
        "모델의 메모리 사용량이 증가함",
        "모델의 예측 정확도가 시간이 지남에 따라 감소할 수 있음",
        "모델의 훈련 시간이 자동으로 단축됨"
      ],
      correct: 2,
      expA: "데이터 드리프트는 일반적으로 모델 성능을 저하시키지 향상시키지 않습니다.",
      expB: "메모리 사용량 증가는 데이터 드리프트의 직접적인 결과가 아닙니다.",
      expC: "정확합니다! 데이터 드리프트는 실세계 데이터 패턴 변화로 인해 모델 성능을 저하시킬 수 있습니다.",
      expD: "훈련 시간은 데이터 드리프트와 직접적인 관련이 없습니다.",
      points: 2,
      chapter: "AI 소개",
      difficulty: "K3"
    },
    {
      id: 12,
      text: "AI 시스템에서 편향 감사의 목적은 무엇입니까? 하나의 옵션을 선택하세요.",
      options: [
        "시스템 성능을 최적화하기 위해",
        "불공정한 차별이나 편향을 식별하고 완화하기 위해",
        "데이터 저장 비용을 줄이기 위해",
        "사용자 인터페이스를 개선하기 위해"
      ],
      correct: 1,
      expA: "성능 최적화는 편향 감사의 주요 목적이 아닌 부차적 결과일 수 있습니다.",
      expB: "정확합니다! 편향 감사는 AI 시스템의 공정성을 보장하고 차별적 결과를 방지하는 것입니다.",
      expC: "저장 비용 절감은 편향 감사와 관련이 없는 인프라 최적화 문제입니다.",
      expD: "UI 개선은 편향 감사의 범위가 아닌 사용자 경험 영역입니다.",
      points: 2,
      chapter: "AI 소개",
      difficulty: "K3"
    },
    {
      id: 13,
      text: "설명 가능한 AI의 주요 목표는 무엇입니까? 하나의 옵션을 선택하세요.",
      options: [
        "AI 모델의 의사결정 과정을 투명하고 이해할 수 있게 만들기 위해",
        "AI 모델의 훈련 속도를 향상시키기 위해",
        "AI 모델의 메모리 사용량을 줄이기 위해",
        "AI 모델의 크기를 최소화하기 위해"
      ],
      correct: 0,
      expA: "정확합니다! 설명 가능한 AI는 모델의 의사결정 과정을 인간이 이해할 수 있도록 하는 것입니다.",
      expB: "훈련 속도 향상은 설명 가능성과 별개의 성능 최적화 문제입니다.",
      expC: "메모리 사용량 감소는 설명 가능성의 목표가 아닌 효율성 문제입니다.",
      expD: "모델 크기 최소화는 설명 가능성과 무관한 압축 및 최적화 문제입니다.",
      points: 2,
      chapter: "AI 소개",
      difficulty: "K3"
    },
    {
      id: 14,
      text: "강화학습에서 에이전트가 환경과 상호작용하는 방식은 무엇입니까? 하나의 옵션을 선택하세요.",
      options: [
        "라벨이 있는 데이터셋으로부터 학습함",
        "행동을 취하고 보상이나 벌점을 받으며 학습함",
        "미리 정의된 규칙을 따름",
        "패턴을 찾기 위해 데이터를 클러스터링함"
      ],
      correct: 1,
      expA: "라벨이 있는 데이터셋 학습은 지도학습을 설명합니다.",
      expB: "정확합니다! 강화학습에서 에이전트는 행동을 취하고 환경으로부터 피드백을 받아 학습합니다.",
      expC: "미리 정의된 규칙을 따르는 것은 규칙 기반 시스템을 설명합니다.",
      expD: "데이터 클러스터링은 비지도학습을 설명합니다.",
      points: 2,
      chapter: "AI 소개",
      difficulty: "K3"
    },
    {
      id: 15,
      text: "컴퓨터 비전에서 패턴 인식의 주요 응용 분야는 무엇입니까? 하나의 옵션을 선택하세요.",
      options: [
        "텍스트 분류",
        "음성 인식",
        "객체 탐지 및 이미지 분류",
        "시계열 예측"
      ],
      correct: 2,
      expA: "텍스트 분류는 자연어 처리 영역입니다.",
      expB: "음성 인식은 오디오 신호 처리 영역입니다.",
      expC: "정확합니다! 컴퓨터 비전에서 패턴 인식은 주로 이미지에서 객체를 식별하고 분류하는 데 사용됩니다.",
      expD: "시계열 예측은 시간 기반 데이터 분석 영역입니다.",
      points: 2,
      chapter: "AI 소개",
      difficulty: "K3"
    },
    {
      id: 16,
      text: "금융 서비스 회사가 사기 탐지를 위한 AI 시스템을 구현할 때 가장 중요한 고려사항은 무엇입니까? 하나의 옵션을 선택하세요.",
      options: [
        "정확도와 규정 준수를 균형있게 맞추면서 위험을 관리함",
        "구현 비용을 최소화하는 데만 집중함",
        "가장 복잡한 알고리즘을 사용함",
        "인간의 감독 없이 완전 자동화를 달성함"
      ],
      correct: 0,
      expA: "정확합니다! 금융 서비스에서는 효과성, 규정 준수, 위험 관리의 균형이 중요합니다.",
      expB: "비용만 고려하면 보안과 규정 준수 요구사항을 간과할 수 있습니다.",
      expC: "복잡성 자체가 목표가 아니며 적절한 솔루션이 더 중요합니다.",
      expD: "금융 영역에서는 중요한 결정에 대한 인간의 감독이 필수적입니다.",
      points: 3,
      chapter: "AI 소개",
      difficulty: "K4"
    },
    {
      id: 17,
      text: "의료 진단 AI 시스템을 개발할 때 가장 우선적으로 고려해야 할 사항은 무엇입니까? 하나의 옵션을 선택하세요.",
      options: [
        "환자 안전과 정확성을 우선시하며 임상 검증을 거침",
        "시장 출시 속도를 최대화함",
        "개발 비용을 최소화함",
        "가장 최신 기술만을 사용함"
      ],
      correct: 0,
      expA: "정확합니다! 의료 AI에서는 환자 안전이 최우선이며 철저한 검증이 필요합니다.",
      expB: "의료 영역에서 속도보다 안전성과 정확성이 더 중요합니다.",
      expC: "비용 절약이 환자 안전을 위험에 빠뜨려서는 안 됩니다.",
      expD: "최신 기술이 항상 의료 용도에 가장 적합한 것은 아닙니다.",
      points: 3,
      chapter: "AI 소개",
      difficulty: "K4"
    },
    {
      id: 18,
      text: "자율주행차 AI 시스템을 테스트할 때 가장 중요한 고려사항은 무엇입니까? 하나의 옵션을 선택하세요.",
      options: [
        "연료 효율성만을 최적화함",
        "엔터테인먼트 기능에 집중함",
        "안전 임계 상황에서 포괄적인 테스트와 검증을 수행함",
        "제조 비용을 최소화함"
      ],
      correct: 2,
      expA: "연료 효율성은 중요하지만 안전만큼 우선순위가 높지 않습니다.",
      expB: "엔터테인먼트 기능은 자율주행 시스템의 핵심 안전 기능이 아닙니다.",
      expC: "정확합니다! 자율주행차에서는 생명과 직결된 안전 상황에서의 철저한 테스트가 필수입니다.",
      expD: "제조 비용은 중요하지만 안전성을 타협해서는 안 됩니다.",
      points: 3,
      chapter: "AI 소개",
      difficulty: "K4"
    },
    {
      id: 19,
      text: "AI 기반 추천 시스템에서 편향을 완화하기 위한 가장 효과적인 접근법은 무엇입니까? 하나의 옵션을 선택하세요.",
      options: [
        "단일 데이터 소스만 사용함",
        "알고리즘의 복잡성을 증가시킴",
        "다양한 훈련 데이터와 공정성 메트릭을 사용함",
        "사용자 피드백을 완전히 무시함"
      ],
      correct: 2,
      expA: "단일 데이터 소스는 편향을 증가시킬 수 있습니다.",
      expB: "복잡성 증가 자체로는 편향을 해결하지 못합니다.",
      expC: "정확합니다! 다양한 데이터와 공정성 메트릭은 편향을 체계적으로 식별하고 완화합니다.",
      expD: "사용자 피드백을 무시하면 시스템 개선 기회를 놓칠 수 있습니다.",
      points: 3,
      chapter: "AI 소개",
      difficulty: "K4"
    },
    {
      id: 20,
      text: "금융 서비스에서 AI 혁신과 규제 요구사항의 균형을 맞추는 가장 좋은 전략은 무엇입니까? 하나의 옵션을 선택하세요.",
      options: [
        "위험 관리 고려사항보다 신속한 혁신을 우선시함",
        "규제 위험 때문에 AI 구현을 완전히 피함",
        "위험 평가 프로세스를 혁신 개발 주기에 통합함",
        "불확실성을 최소화하기 위해 검증된 AI 기술만 사용함"
      ],
      correct: 2,
      expA: "금융 서비스에서 위험보다 혁신을 우선시하면 심각한 결과를 초래할 수 있습니다.",
      expB: "AI를 완전히 피하면 경쟁 우위와 정당한 기회를 놓칠 수 있습니다.",
      expC: "완벽합니다! 통합된 위험-혁신 프로세스는 발전과 책임을 모두 보장합니다.",
      expD: "검증된 기술만 사용하면 유익한 기회를 놓칠 수 있습니다.",
      points: 3,
      chapter: "AI 소개",
      difficulty: "K4"
    },
    {
        id: 21,
        text: "다음 중 AI 기반 시스템에서 적응성을 가장 잘 설명하는 것은 무엇입니까? 하나의 옵션을 선택하세요.", 
        options: [
          "새로운 조건에 맞춰 동작을 수정하는 능력",
          "실시간으로 데이터를 빠르게 처리하는 능력", 
          "최소한의 컴퓨팅 자원으로 동작하는 능력",
          "미리 정의된 규칙 트리를 따르는 능력"
        ],
        correct: 0,
        expA: "정확합니다! 적응성은 AI 시스템이 변화하는 환경이나 요구사항에 맞춰 행동을 조정할 수 있는 능력입니다.",
        expB: "빠른 데이터 처리는 성능과 관련된 특성이지 적응성과는 다릅니다.",
        expC: "자원 효율성은 중요하지만 적응성의 핵심 개념은 아닙니다.",
        expD: "미리 정의된 규칙을 따르는 것은 적응성과 반대되는 경직된 동작입니다.",
        points: 1,
        chapter: "AI 기반 시스템의 품질 특성",
        difficulty: "K2"
      },
      {
        id: 22,
        text: "AI 기반 시스템에서 자율성의 주요 특징은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "대용량 컴퓨팅 파워에 의존하는 것",
          "인간의 개입 없이 독립적으로 결정을 내리는 것",
          "복잡한 수학적 알고리즘을 사용하는 것", 
          "방대한 데이터셋에 접근하는 것"
        ],
        correct: 1,
        expA: "컴퓨팅 파워는 성능 요소이지 자율성의 정의가 아닙니다.",
        expB: "맞습니다! 자율성은 AI 시스템이 인간의 지속적인 개입 없이 독립적으로 작동할 수 있는 능력입니다.",
        expC: "복잡한 알고리즘은 구현 방법이지 자율성 자체를 정의하지 않습니다.",
        expD: "데이터 접근은 시스템 기능이지 자율적 동작과는 별개입니다.",
        points: 1,
        chapter: "AI 기반 시스템의 품질 특성",
        difficulty: "K2"
      },
      {
        id: 23,
        text: "자기학습 시스템의 핵심 특징은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "병렬 처리를 구현하는 것",
          "경험을 통해 성능을 개선하는 능력",
          "고급 수학적 알고리즘을 사용하는 것",
          "여러 데이터 소스를 통합하는 것"
        ],
        correct: 1,
        expA: "병렬 처리는 기술적 구현 세부사항으로 자기학습에 특화된 것이 아닙니다.",
        expB: "정확합니다! 자기학습 시스템은 새로운 경험을 바탕으로 성능을 적응하고 개선할 수 있습니다.",
        expC: "고급 알고리즘은 많은 시스템에서 사용되며 자기학습 특유의 것이 아닙니다.",
        expD: "데이터 통합은 일반적인 시스템 기능으로 자기학습의 독특한 특징이 아닙니다.",
        points: 1,
        chapter: "AI 기반 시스템의 품질 특성",
        difficulty: "K1"
      },
      {
        id: 24,
        text: "AI 시스템에서 편향이 발생하는 주요 원인은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "하드웨어 제한으로 인한 처리 지연",
          "보안 프로토콜의 부족한 구현",
          "알고리즘 설계의 복잡성",
          "훈련 데이터의 다양성 부족"
        ],
        correct: 3,
        expA: "하드웨어 지연은 성능 문제이지 편향의 원인이 아닙니다.",
        expB: "보안 문제는 편향과 다른 품질 특성입니다.",
        expC: "알고리즘 복잡성 자체가 편향을 유발하지는 않습니다.",
        expD: "정확합니다! 편향은 주로 대표성이 부족하거나 불균형한 훈련 데이터에서 발생합니다.",
        points: 1,
        chapter: "AI 기반 시스템의 품질 특성",
        difficulty: "K2"
      },
      {
        id: 25,
        text: "설명 가능한 AI의 주요 목적은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "시스템 성능을 최적화하기 위해",
          "AI 모델의 의사결정 과정을 이해 가능하게 만들기 위해",
          "데이터 저장 비용을 절감하기 위해",
          "사용자 인터페이스를 개선하기 위해"
        ],
        correct: 1,
        expA: "성능 최적화는 설명 가능성의 주목적이 아닌 부차적 효과일 수 있습니다.",
        expB: "맞습니다! 설명 가능한 AI는 모델이 어떻게 결정을 내리는지 인간이 이해할 수 있도록 하는 것입니다.",
        expC: "비용 절감은 설명 가능성과 관련 없는 경제적 고려사항입니다.",
        expD: "UI 개선은 설명 가능성이 아닌 사용자 경험 영역입니다.",
        points: 1,
        chapter: "AI 기반 시스템의 품질 특성",
        difficulty: "K2"
      },
      {
        id: 26,
        text: "AI 시스템에서 견고성(robustness)이 중요한 이유는 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "시스템 개발 비용을 줄이기 위해",
          "노이즈나 예상치 못한 입력에 대한 저항력을 제공하기 위해",
          "사용자 인터페이스를 단순화하기 위해",
          "데이터 저장 공간을 효율적으로 사용하기 위해"
        ],
        correct: 1,
        expA: "개발 비용은 견고성의 목적이 아닌 별도의 경제적 고려사항입니다.",
        expB: "정확합니다! 견고성은 시스템이 비정상적이거나 적대적인 입력에도 안정적으로 작동할 수 있게 합니다.",
        expC: "UI 단순화는 견고성과 무관한 사용자 경험 문제입니다.",
        expD: "저장 효율성은 견고성이 아닌 성능 최적화 영역입니다.",
        points: 1,
        chapter: "AI 기반 시스템의 품질 특성",
        difficulty: "K2"
      },
      {
        id: 27,
        text: "AI 시스템에서 공정성(fairness)을 보장하기 위한 핵심 요소는 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "시스템 처리 속도를 최대화하는 것",
          "모든 사용자 그룹에 대해 균등한 대우를 보장하는 것",
          "최신 기술 스택을 사용하는 것",
          "데이터베이스 쿼리를 최적화하는 것"
        ],
        correct: 1,
        expA: "처리 속도는 성능 특성으로 공정성과는 별개의 문제입니다.",
        expB: "맞습니다! 공정성은 다양한 인구 집단이나 사용자 그룹 간에 차별 없는 대우를 보장하는 것입니다.",
        expC: "기술 스택 선택은 공정성과 직접적인 관련이 없는 구현 결정입니다.",
        expD: "데이터베이스 최적화는 공정성이 아닌 성능 개선 영역입니다.",
        points: 1,
        chapter: "AI 기반 시스템의 품질 특성",
        difficulty: "K2"
      },
      {
        id: 28,
        text: "다음 중 AI 개발에 사용되지 않는 프레임워크는 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "scikit-learn",
          "CNTK", 
          "MxNet",
          "EZPy-AI"
        ],
        correct: 3,
        expA: "scikit-learn은 Python용 인기 있는 기계학습 라이브러리입니다.",
        expB: "CNTK는 Microsoft에서 개발한 딥러닝 프레임워크입니다.",
        expC: "MxNet은 Amazon에서 지원하는 딥러닝 프레임워크입니다.",
        expD: "정확합니다! EZPy-AI는 실제 존재하지 않는 가상의 프레임워크입니다.",
        points: 1,
        chapter: "AI 기반 시스템의 품질 특성", 
        difficulty: "K1"
      },
      {
        id: 29,
        text: "다음 중 자기학습 시스템의 특징을 가장 잘 설명하는 것은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "경험을 통해 성능을 개선하는 능력",
          "고급 수학적 알고리즘의 사용",
          "병렬 처리의 구현",
          "여러 데이터 소스의 통합"
        ],
        correct: 0,
        expA: "정확합니다! 자기학습 시스템은 새로운 경험을 바탕으로 성능을 개선하고 적응할 수 있습니다.",
        expB: "고급 알고리즘은 많은 시스템에서 사용되며 자기학습에 특화된 것이 아닙니다.",
        expC: "병렬 처리는 기술적 구현 세부사항으로 자기학습에 특화된 것이 아닙니다.",
        expD: "데이터 통합은 많은 시스템의 공통 기능으로 자기학습의 독특한 특징이 아닙니다.",
        points: 1,
        chapter: "AI 기반 시스템의 품질 특성",
        difficulty: "K1"
      },
      {
        id: 30,
        text: "추천 시스템이 특정 제품 카테고리에 편향을 보일 때 가장 적절한 테스트 접근법은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "응답 시간을 측정하는 성능 테스트",
          "취약점을 식별하는 보안 테스트",
          "사용자 인터페이스 설계를 평가하는 사용성 테스트", 
          "추천 편향을 평가하는 공정성 테스트"
        ],
        correct: 3,
        expA: "성능 테스트는 속도를 측정하지만 설명된 편향 문제를 다루지 않습니다.",
        expB: "보안 테스트는 취약점을 식별하지만 알고리즘 편향 문제를 다루지 않습니다.",
        expC: "사용성 테스트는 인터페이스를 평가하지만 근본적인 편향 문제를 다루지 않습니다.",
        expD: "정확합니다! 이 시나리오는 잠재적 편향을 나타내므로 특정한 공정성 테스트 방법이 필요합니다.",
        points: 2,
        chapter: "AI 기반 시스템의 품질 특성",
        difficulty: "K3"
      },
      {
        id: 31,
        text: "AI 챗봇이 서로 다른 언어를 사용하는 사용자에게 다른 품질의 응답을 제공할 때 이를 어떻게 해결해야 합니까? 하나의 옵션을 선택하세요.",
        options: [
          "다국어 지원을 위한 자연어 처리 알고리즘을 최적화함",
          "시스템을 단일 주요 언어로만 작동하도록 제한함",
          "일관된 처리를 위한 자동 번역 계층을 구현함",
          "지원되는 모든 언어에서 훈련 데이터 다양성을 증가시킴"
        ],
        correct: 3,
        expA: "알고리즘 최적화는 도움이 될 수 있지만, 근본 원인은 다양한 훈련 데이터 부족일 가능성이 높습니다.",
        expB: "단일 언어로 제한하면 문제를 회피하지만 근본적인 편향 문제를 해결하지 못합니다.",
        expC: "번역 계층은 복잡성을 추가하고 핵심 문제를 해결하기보다 새로운 편향을 도입할 수 있습니다.",
        expD: "맞습니다! 언어별 다양한 훈련 데이터는 불균등한 성능의 근본 원인을 해결합니다.",
        points: 2,
        chapter: "AI 기반 시스템의 품질 특성",
        difficulty: "K3"
      },
      {
        id: 32,
        text: "사기 탐지 시스템이 높은 정확도를 가지지만 거래가 플래그된 이유를 설명할 수 없을 때 우선시해야 할 접근법은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "정확도 유지를 위해 현재 모델을 계속 사용함",
          "설명 가능성을 개선하여 의사결정 투명성을 높임",
          "더 빠른 처리를 위해 시스템을 최적화함",
          "추가적인 보안 기능을 구현함"
        ],
        correct: 1,
        expA: "정확도는 중요하지만 규제가 있는 금융 환경에서는 설명 가능성도 필수적입니다.",
        expB: "정확합니다! 금융 서비스에서는 규제 준수와 신뢰를 위해 의사결정 투명성이 중요합니다.",
        expC: "처리 속도 개선은 설명 가능성 부족 문제를 해결하지 못합니다.",
        expD: "추가 보안 기능은 중요하지만 설명 가능성과는 별개의 문제입니다.",
        points: 2,
        chapter: "AI 기반 시스템의 품질 특성",
        difficulty: "K3"
      },
      {
        id: 33,
        text: "의료 진단 AI가 특정 인구 집단에서 일관되게 낮은 정확도를 보일 때 가장 효과적인 해결책은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "영향받는 집단의 대표적인 훈련 데이터를 증가시킴",
          "전체적으로 더 복잡한 알고리즘을 사용함",
          "하드웨어 처리 능력을 증가시킴",
          "시스템 사용을 고성능 집단으로 제한함"
        ],
        correct: 0,
        expA: "정확합니다! 특정 집단에서 낮은 성능은 일반적으로 해당 집단의 훈련 데이터 부족으로 인한 것입니다.",
        expB: "더 복잡한 알고리즘이 항상 편향 문제를 해결하는 것은 아니며 과적합을 야기할 수 있습니다.",
        expC: "하드웨어 개선은 편향 문제의 근본 원인을 해결하지 못합니다.",
        expD: "특정 집단을 배제하는 것은 비윤리적이며 의료 서비스의 접근성 원칙에 위배됩니다.",
        points: 2,
        chapter: "AI 기반 시스템의 품질 특성",
        difficulty: "K3"
      },
      {
        id: 34,
        text: "자율주행차 AI가 극한 날씨 조건에서 성능 저하를 보일 때 견고성을 개선하기 위한 최선의 전략은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "다양한 날씨 조건의 훈련 데이터를 수집하고 모델을 재훈련함",
          "하드웨어 사양을 업그레이드함",
          "사용자 인터페이스를 단순화함",
          "극한 날씨에서 시스템 사용을 비활성화함"
        ],
        correct: 0,
        expA: "정확합니다! 견고성 개선을 위해서는 다양한 조건의 데이터로 모델을 훈련시켜야 합니다.",
        expB: "하드웨어 업그레이드는 도움이 될 수 있지만 모델의 근본적인 한계를 해결하지는 못합니다.",
        expC: "UI 단순화는 견고성 문제와 직접적인 관련이 없습니다.",
        expD: "극한 조건에서 비활성화하는 것은 시스템의 유용성을 크게 제한합니다.",
        points: 2,
        chapter: "AI 기반 시스템의 품질 특성",
        difficulty: "K3"
      },
      {
        id: 35,
        text: "AI 기반 채용 시스템에서 성별 편향을 탐지하고 완화하기 위한 가장 포괄적인 접근법은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "시스템 처리 속도를 개선함",
          "편향 감사와 공정성 메트릭을 정기적으로 실시함",
          "사용자 인터페이스를 재설계함",
          "더 많은 하드웨어 리소스를 할당함"
        ],
        correct: 1,
        expA: "처리 속도 개선은 편향 문제를 해결하지 못합니다.",
        expB: "맞습니다! 체계적인 편향 감사와 공정성 메트릭이 편향을 식별하고 완화하는 가장 효과적인 방법입니다.",
        expC: "UI 재설계는 근본적인 알고리즘 편향을 해결하지 못합니다.",
        expD: "하드웨어 리소스 증가는 편향 문제와 관련이 없습니다.",
        points: 2,
        chapter: "AI 기반 시스템의 품질 특성",
        difficulty: "K3"
      },
      {
        id: 36,
        text: "금융 대출 승인을 위한 AI 시스템을 개발할 때 가장 중요한 품질 특성 조합은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "속도와 비용 효율성에만 집중함",
          "정확성, 공정성, 설명 가능성을 균형있게 고려함",
          "최신 기술 트렌드 적용에만 집중함",  
          "사용자 인터페이스 미학에만 집중함"
        ],
        correct: 1,
        expA: "속도와 비용만 고려하면 규제 요구사항과 윤리적 책임을 간과할 수 있습니다.",
        expB: "정확합니다! 금융 서비스에서는 성능, 공정성, 투명성의 균형이 규제 준수와 신뢰를 위해 필수적입니다.",
        expC: "기술 트렌드만 따르면 업무 요구사항과 규제 준수를 놓칠 수 있습니다.",
        expD: "UI 미학은 중요하지만 금융 AI 시스템의 핵심 품질 요구사항이 아닙니다.",
        points: 3,
        chapter: "AI 기반 시스템의 품질 특성",
        difficulty: "K4"
      },
      {
        id: 37,
        text: "의료 이미지 분석을 위한 AI 시스템에서 가장 중요한 품질 고려사항은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "처리 속도 최대화에만 집중함",
          "환자 안전을 위한 정확성과 견고성을 우선시함",
          "시스템 비용 절감에만 집중함",
          "최신 AI 기술 사용에만 집중함"
        ],
        correct: 1,
        expA: "속도는 중요하지만 의료 영역에서는 안전성과 정확성이 우선되어야 합니다.",
        expB: "정확합니다! 의료 AI에서는 환자 안전이 최우선이며 높은 정확성과 다양한 조건에서의 견고성이 필수입니다.",
        expC: "비용 절감이 환자 안전과 진단 품질을 위험에 빠뜨려서는 안 됩니다.",
        expD: "최신 기술이 항상 의료 용도에 가장 적합하거나 안전한 것은 아닙니다.",
        points: 3,
        chapter: "AI 기반 시스템의 품질 특성",
        difficulty: "K4"
      },
      {
        id: 38,
        text: "자율주행차 AI 시스템에서 안전 임계 상황을 처리할 때 가장 중요한 품질 특성은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "엔터테인먼트 기능의 다양성",
          "견고성과 안전성을 우선하는 실시간 의사결정",
          "연료 효율성 최적화",
          "제조 비용 최소화"
        ],
        correct: 1,
        expA: "엔터테인먼트 기능은 안전 임계 상황에서 중요하지 않습니다.",
        expB: "정확합니다! 자율주행에서는 예상치 못한 상황에서도 안전한 실시간 결정이 생명과 직결됩니다.",
        expC: "연료 효율성은 중요하지만 안전만큼 우선순위가 높지 않습니다.",
        expD: "제조 비용은 중요하지만 안전성을 타협해서는 안 됩니다.",
        points: 3,
        chapter: "AI 기반 시스템의 품질 특성",
        difficulty: "K4"
      },
      {
        id: 39,
        text: "글로벌 전자상거래 플랫폼의 AI 추천 시스템을 설계할 때 가장 포괄적인 품질 접근법은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "매출 최대화에만 집중함",
          "기술적 성능에만 집중함",
          "정확성, 공정성, 문화적 적응성을 통합적으로 고려함",
          "단일 시장 선호도에만 맞춤"
        ],
        correct: 2,
        expA: "매출만 추구하면 사용자 경험과 공정성을 희생할 수 있습니다.",
        expB: "기술적 성능만으로는 다양한 글로벌 사용자의 요구를 충족할 수 없습니다.",
        expC: "정확합니다! 글로벌 플랫폼에서는 기술적 효과성, 사용자 공정성, 문화적 민감성의 균형이 필요합니다.",
        expD: "단일 시장에만 집중하면 글로벌 사용자 기반을 소외시킬 수 있습니다.",
        points: 3,
        chapter: "AI 기반 시스템의 품질 특성",
        difficulty: "K4"
      },
      {
        id: 40,
        text: "의료 AI 시스템의 품질 보증을 위한 가장 포괄적인 접근법은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "개발 후 테스트에만 의존함",
          "신뢰성 측면에만 집중함",
          "규제 감독하에 모든 품질 특성의 포괄적 테스트를 실시함",
          "배포 후에만 문제를 해결함"
        ],
        correct: 2,
        expA: "배포 후 테스트만으로는 환자 안전을 보장하기에 불충분합니다.",
        expB: "신뢰성은 필수적이지만 의료 AI는 모든 특성의 통합적 검증이 필요합니다.",
        expC: "정확합니다! 의료는 규제 감독하에 모든 특성의 포괄적 테스트가 필요합니다.",
        expD: "의료 AI 테스트는 배포 전에 시작되어야 합니다 - 환자 안전이 사전 예방적 검증을 요구합니다.",
        points: 3,
        chapter: "AI 기반 시스템의 품질 특성",
        difficulty: "K4"
      },
      {
        id: 41,
        text: "다음 중 지도 학습(supervised learning)을 가장 잘 설명하는 것은 무엇입니까?",
        options: [
          "시스템이 명시적인 프로그래밍 없이 학습합니다",
          "시스템이 레이블된 데이터에서 패턴을 학습합니다",
          "시스템이 보상을 통해 행동을 최적화합니다",
          "시스템이 숨겨진 구조를 자동으로 발견합니다"
        ],
        correct: 1,
        expA: "이는 기계학습의 일반적 정의이지만 지도학습 특성은 아닙니다.",
        expB: "정확합니다! 지도학습은 레이블된 예제 데이터로부터 학습하는 것이 핵심입니다.",
        expC: "이는 강화학습(reinforcement learning)의 특징입니다.",
        expD: "이는 비지도학습(unsupervised learning)의 특징입니다.",
        points: 1,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K2"
      },
      {
        id: 42,
        text: "다음 중 분류(classification) 작업이 아닌 것은 무엇입니까?",
        options: [
          "스팸 이메일 필터링 시스템 구축",
          "주택 가격 예측 모델 개발",
          "의료 이미지에서 종양 탐지",
          "고객 행동 패턴 분류"
        ],
        correct: 1,
        expA: "스팸 여부를 판단하는 것은 이진분류 작업입니다.",
        expB: "맞습니다! 주택 가격 예측은 연속값을 예측하는 회귀 작업입니다.",
        expC: "종양의 유무를 판단하는 것은 분류 작업입니다.",
        expD: "고객을 여러 그룹으로 나누는 것은 분류 작업입니다.",
        points: 1,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K1"
      },
      {
        id: 43,
        text: "다음 중 비지도 학습의 예시가 아닌 것은 무엇입니까?",
        options: [
          "고객 세분화를 위한 클러스터링",
          "차원 축소를 통한 데이터 압축",
          "이상 탐지를 위한 패턴 분석",
          "인식 정확도 향상을 위한 특성 선택"
        ],
        correct: 2,
        expA: "클러스터링은 레이블 없이 그룹을 찾는 비지도학습입니다.",
        expB: "차원 축소는 레이블 없이 데이터를 변환하는 비지도학습입니다.",
        expC: "정확합니다! 이상 탐지는 정상 패턴을 학습하는 비지도학습 기법입니다.",
        expD: "특성 선택은 예측 성능 개선을 위한 지도학습 관련 기법입니다.",
        points: 1,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K1"
      },
      {
        id: 44,
        text: "강화학습에서 에이전트의 주요 목표는 무엇입니까?",
        options: [
          "환경과의 상호작용을 통해 보상을 최대화합니다",
          "레이블된 훈련 데이터에서 패턴을 학습합니다",
          "데이터의 숨겨진 구조를 자동으로 발견합니다",
          "사전 정의된 규칙에 따라 결정을 내립니다"
        ],
        correct: 0,
        expA: "정확합니다! 강화학습은 행동에 대한 보상을 최대화하는 것이 목표입니다.",
        expB: "이는 지도학습의 특징입니다.",
        expC: "이는 비지도학습의 특징입니다.",
        expD: "이는 규칙 기반 시스템의 특징입니다.",
        points: 1,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K2"
      },
      {
        id: 45,
        text: "다음 중 과적합(overfitting)을 나타내는 징후는 무엇입니까?",
        options: [
          "훈련 데이터와 검증 데이터 모두에서 낮은 성능",
          "훈련 데이터와 검증 데이터 모두에서 높은 성능",
          "훈련 데이터에서 높은 성능, 검증 데이터에서 낮은 성능",
          "훈련 데이터에서 낮은 성능, 검증 데이터에서 높은 성능"
        ],
        correct: 2,
        expA: "이는 과소적합(underfitting)의 징후입니다.",
        expB: "이는 적절한 학습이 이루어진 상황입니다.",
        expC: "정확합니다! 과적합은 훈련 데이터에만 특화되어 새로운 데이터에서 성능이 떨어지는 현상입니다.",
        expD: "이는 일반적으로 발생하지 않는 비현실적인 상황입니다.",
        points: 1,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K2"
      },
      {
        id: 46,
        text: "교차 검증(cross-validation)의 주요 목적은 무엇입니까?",
        options: [
          "모델의 훈련 속도를 향상시킵니다",
          "데이터 전처리 과정을 자동화합니다",
          "모델의 일반화 성능을 객관적으로 평가합니다",
          "특성 선택 과정을 최적화합니다"
        ],
        correct: 2,
        expA: "교차 검증은 훈련 속도와는 관련이 없습니다.",
        expB: "교차 검증은 데이터 전처리 자동화 기법이 아닙니다.",
        expC: "정확합니다! 교차 검증은 제한된 데이터로도 모델의 일반화 성능을 신뢰성 있게 평가하는 기법입니다.",
        expD: "특성 선택은 교차 검증과 별도로 수행되는 과정입니다.",
        points: 1,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K2"
      },
      {
        id: 47,
        text: "앙상블 방법(ensemble methods)의 핵심 아이디어는 무엇입니까?",
        options: [
          "단일 모델의 복잡도를 최대한 증가시킵니다",
          "여러 약한 학습기를 결합하여 강한 예측기를 만듭니다",
          "데이터셋의 크기를 인위적으로 확장시킵니다",
          "특성 공간의 차원을 효과적으로 축소시킵니다"
        ],
        correct: 1,
        expA: "단일 모델의 복잡도 증가는 과적합 위험을 높일 수 있습니다.",
        expB: "정확합니다! 앙상블은 여러 개별 모델의 예측을 결합하여 더 나은 성능을 달성합니다.",
        expC: "데이터 증강은 앙상블과는 다른 개념입니다.",
        expD: "차원 축소는 앙상블과는 별개의 기법입니다.",
        points: 1,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K2"
      },
      {
        id: 48,
        text: "정규화(regularization)의 주요 효과는 무엇입니까?",
        options: [
          "모델의 훈련 시간을 단축시킵니다",
          "데이터 수집 비용을 절감시킵니다",
          "과적합을 방지하고 일반화 성능을 향상시킵니다",
          "특성 추출 과정을 자동화시킵니다"
        ],
        correct: 2,
        expA: "정규화는 훈련 시간 단축이 주목적이 아닙니다.",
        expB: "정규화는 데이터 수집과는 관련이 없습니다.",
        expC: "정확합니다! 정규화는 모델의 복잡도를 제어하여 과적합을 방지하는 기법입니다.",
        expD: "특성 추출 자동화는 정규화의 기능이 아닙니다.",
        points: 1,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K2"
      },
      {
        id: 49,
        text: "경사 하강법(gradient descent)의 목적은 무엇입니까?",
        options: [
          "데이터의 분포를 정규화합니다",
          "특성 간의 상관관계를 분석합니다",
          "모델의 예측 속도를 최적화합니다",
          "손실 함수를 최소화하는 매개변수를 찾습니다"
        ],
        correct: 3,
        expA: "데이터 정규화는 전처리 과정의 일부입니다.",
        expB: "상관관계 분석은 탐색적 데이터 분석의 일부입니다.",
        expC: "예측 속도 최적화는 경사 하강법의 직접적 목적이 아닙니다.",
        expD: "정확합니다! 경사 하강법은 손실 함수의 최솟값을 찾기 위한 최적화 알고리즘입니다.",
        points: 1,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K2"
      },
      {
        id: 50,
        text: "전자상거래 추천 시스템에서 협업 필터링(collaborative filtering)을 구현할 때 가장 중요한 고려사항은 무엇입니까?",
        options: [
          "사용자-아이템 상호작용 데이터의 희소성 문제를 해결합니다",
          "제품 이미지의 화질을 최대한 향상시킵니다",
          "데이터베이스의 읽기 성능을 최적화합니다",
          "사용자 인터페이스의 응답 속도를 개선합니다"
        ],
        correct: 0,
        expA: "정확합니다! 협업 필터링에서 희소성은 추천 품질에 직접 영향을 미치는 핵심 문제입니다.",
        expB: "이미지 화질은 협업 필터링 알고리즘과 직접적 관련이 없습니다.",
        expC: "데이터베이스 성능은 시스템 최적화 관점이지 알고리즘 관점이 아닙니다.",
        expD: "UI 응답성은 사용자 경험 측면이지 알고리즘 핵심 이슈가 아닙니다.",
        points: 2,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K3"
      },
      {
        id: 51,
        text: "의료 진단 시스템에서 거짓 음성(false negative)을 줄이는 것이 중요한 이유는 무엇입니까?",
        options: [
          "시스템의 전반적인 정확도를 향상시키기 위해서입니다",
          "실제 질병을 놓치는 위험을 최소화하기 위해서입니다",
          "불필요한 추가 검사 비용을 절약하기 위해서입니다",
          "의료진의 업무 효율성을 증대시키기 위해서입니다"
        ],
        correct: 1,
        expA: "전반적 정확도는 중요하지만 거짓 음성의 핵심 위험은 아닙니다.",
        expB: "정확합니다! 의료 분야에서 거짓 음성은 실제 환자를 놓치는 치명적 결과를 초래할 수 있습니다.",
        expC: "비용 절약보다는 환자 안전이 더 중요한 고려사항입니다.",
        expD: "업무 효율성보다는 진단 정확성이 더 중요합니다.",
        points: 2,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K3"
      },
      {
        id: 52,
        text: "실시간 온라인 학습 시스템에서 가장 우선적으로 고려해야 할 요소는 무엇입니까?",
        options: [
          "모델 해석 가능성을 최대한 보장합니다",
          "데이터 저장 비용을 최소화합니다",
          "개념 변화(concept drift)에 대한 적응 능력을 확보합니다",
          "초기 훈련 데이터의 품질을 완벽하게 관리합니다"
        ],
        correct: 2,
        expA: "해석 가능성은 중요하지만 온라인 학습의 핵심 도전은 아닙니다.",
        expB: "저장 비용은 중요한 고려사항이지만 가장 우선적이지는 않습니다.",
        expC: "정확합니다! 온라인 환경에서는 데이터 패턴이 지속적으로 변화하므로 적응 능력이 핵심입니다.",
        expD: "초기 데이터 품질보다는 지속적인 변화 대응이 더 중요합니다.",
        points: 2,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K3"
      },
      {
        id: 53,
        text: "금융 사기 탐지 시스템에서 클래스 불균형 문제를 해결하기 위한 가장 효과적인 접근법은 무엇입니까?",
        options: [
          "단순히 더 많은 정상 거래 데이터를 수집합니다",
          "모든 특성에 동일한 가중치를 부여합니다",
          "소수 클래스에 더 높은 가중치를 부여하거나 샘플링 기법을 적용합니다",
          "복잡도가 낮은 선형 모델만을 사용합니다"
        ],
        correct: 2,
        expA: "더 많은 정상 거래 데이터는 불균형을 더욱 심화시킬 수 있습니다.",
        expB: "동일한 가중치는 클래스 불균형 문제를 해결하지 못합니다.",
        expC: "정확합니다! 클래스 불균형에서는 소수 클래스를 강조하는 기법이 필요합니다.",
        expD: "모델 복잡도는 클래스 불균형 해결과 직접적인 관련이 없습니다.",
        points: 2,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K3"
      },
      {
        id: 54,
        text: "다국어 자연어 처리 시스템에서 전이 학습(transfer learning)을 적용할 때의 주요 이점은 무엇입니까?",
        options: [
          "모든 언어에 대해 동일한 성능을 보장합니다",
          "훈련 데이터가 부족한 언어에서도 효과적인 모델 구축이 가능합니다",
          "번역 정확도를 100% 달성할 수 있습니다",
          "언어별 특성을 완전히 무시할 수 있습니다"
        ],
        correct: 1,
        expA: "전이 학습이 모든 언어에서 동일한 성능을 보장하지는 않습니다.",
        expB: "정확합니다! 전이 학습은 풍부한 언어의 지식을 부족한 언어로 활용할 수 있게 합니다.",
        expC: "100% 정확도는 현실적으로 불가능한 목표입니다.",
        expD: "언어별 특성은 여전히 중요한 고려사항입니다.",
        points: 2,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K3"
      },
      {
        id: 55,
        text: "자율주행차의 객체 인식 시스템에서 데이터 증강(data augmentation)을 적용할 때 가장 신중하게 고려해야 할 사항은 무엇입니까?",
        options: [
          "증강된 데이터가 실제 주행 환경의 물리 법칙을 위반하지 않도록 보장합니다",
          "증강 과정에서 처리 속도를 최대한 향상시킵니다",
          "가능한 한 많은 종류의 변형을 무작위로 적용합니다",
          "원본 데이터와 구별이 불가능하도록 완벽하게 재현합니다"
        ],
        correct: 0,
        expA: "정확합니다! 안전 관련 시스템에서는 증강 데이터가 현실적이고 물리적으로 타당해야 합니다.",
        expB: "처리 속도보다는 데이터의 현실성이 더 중요합니다.",
        expC: "무작위 변형은 비현실적인 상황을 만들 수 있어 위험합니다.",
        expD: "완벽한 재현보다는 현실적인 변이가 중요합니다.",
        points: 2,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K3"
      },
      {
        id: 56,
        text: "의료 AI 시스템 개발에서 규제 승인을 위해 가장 중요한 요구사항은 무엇입니까?",
        options: [
          "모델의 해석가능성과 결정 과정의 추적가능성을 확보합니다",
          "가장 최신의 딥러닝 기술을 반드시 적용합니다",
          "처리 속도를 기존 시스템보다 10배 향상시킵니다",
          "개발 비용을 최소화하여 경제성을 입증합니다"
        ],
        correct: 0,
        expA: "정확합니다! 의료 규제 기관은 AI 결정의 근거를 이해하고 추적할 수 있어야 승인을 내줍니다.",
        expB: "최신 기술보다는 신뢰성과 설명가능성이 더 중요합니다.",
        expC: "성능 향상은 중요하지만 규제 승인의 핵심 요건은 아닙니다.",
        expD: "경제성보다는 안전성과 신뢰성이 규제 승인의 핵심입니다.",
        points: 3,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K4"
      },
      {
        id: 57,
        text: "글로벌 금융 서비스 회사가 여러 국가에서 신용 평가 모델을 배포할 때, 규제 준수와 공정성을 동시에 확보하기 위한 최적의 전략은 무엇입니까?",
        options: [
          "모든 국가에서 동일한 단일 모델을 사용하여 일관성을 유지합니다",
          "각 국가별로 독립적인 모델을 개발하여 현지 법규에 완벽히 대응합니다",
          "기본 프레임워크는 공유하되 국가별 규제와 문화적 특성을 반영한 적응형 접근법을 채택합니다",
          "외부 신용평가기관의 기존 모델을 그대로 도입하여 책임을 전가합니다"
        ],
        correct: 2,
        expA: "단일 모델은 국가별 규제 차이와 문화적 편향을 고려하지 못합니다.",
        expB: "완전 독립 모델은 효율성이 떨어지고 전역적 일관성을 해칠 수 있습니다.",
        expC: "정확합니다! 공통 기반에서 지역 특성을 반영하는 접근법이 가장 균형잡힌 전략입니다.",
        expD: "외부 의존은 고유한 비즈니스 요구사항을 충족하지 못할 수 있습니다.",
        points: 3,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K4"
      },
      {
        id: 58,
        text: "자동화된 채용 시스템에서 알고리즘 편향을 최소화하고 공정성을 보장하기 위한 포괄적 접근법은 무엇입니까?",
        options: [
          "다양한 배경의 훈련 데이터 확보, 정기적 편향 감사, 그리고 투명한 결정 과정 구현",
          "가장 높은 정확도를 보이는 알고리즘을 선택하여 객관성을 확보",
          "인간 심사위원을 완전히 배제하고 알고리즘 결정만을 신뢰",
          "과거 성공 사례 데이터에만 기반하여 검증된 패턴을 재현"
        ],
        correct: 0,
        expA: "정확합니다! 공정한 AI 시스템은 다각적이고 지속적인 접근법이 필요합니다.",
        expB: "높은 정확도가 반드시 공정성을 보장하지는 않습니다.",
        expC: "완전 자동화는 편향을 감지하고 수정할 기회를 제거합니다.",
        expD: "과거 데이터는 기존 편향을 그대로 재현할 위험이 있습니다.",
        points: 3,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K4"
      },
      {
        id: 59,
        text: "스타트업이 제한된 자원으로 AI 기반 제품을 개발할 때, 기술적 혁신과 비즈니스 지속가능성을 균형있게 고려한 최적의 전략은 무엇입니까?",
        options: [
          "최첨단 연구 결과를 즉시 적용하여 기술적 우위를 확보합니다",
          "검증된 기존 기술만을 사용하여 리스크를 완전히 회피합니다",
          "핵심 가치 제안에 집중하되 점진적 혁신과 실용적 구현을 조합합니다",
          "외부 AI 서비스에 전적으로 의존하여 개발 부담을 외부화합니다"
        ],
        correct: 2,
        expA: "최첨단 기술은 검증되지 않은 리스크와 높은 개발 비용을 수반합니다.",
        expB: "혁신 부족은 시장에서의 차별화를 어렵게 만듭니다.",
        expC: "정확합니다! 제한된 자원에서는 핵심 가치에 집중하되 점진적 혁신이 최적입니다.",
        expD: "과도한 외부 의존은 핵심 경쟁력 구축을 저해할 수 있습니다.",
        points: 3,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K4"
      },
      {
        id: 60,
        text: "팀이 컴퓨터 비전용 심층 신경망에서 심각한 과적합을 발견했습니다. 가장 효과적인 해결 방법은 무엇입니까?",
        options: [
          "모델 복잡도를 더욱 증가시킵니다",
          "더 복잡한 알고리즘을 적용합니다",
          "정규화, 드롭아웃, 데이터 증강을 조합하여 적용합니다",
          "훈련 데이터 크기를 축소합니다"
        ],
        correct: 2,
        expA: "복잡도 증가는 과적합 문제를 악화시킵니다.",
        expB: "더 복잡한 알고리즘은 과적합을 더욱 심화시킬 수 있습니다.",
        expC: "정확합니다! 정규화 기법들의 조합은 과적합 방지의 표준적이고 효과적인 접근법입니다.",
        expD: "데이터 축소는 일반적으로 과적합을 악화시킵니다.",
        points: 3,
        chapter: "기계학습(ML) - 개요",
        difficulty: "K4"
      },
      {
        id: 61,
        text: "다음 중 데이터 라벨링의 일반적인 접근법은 무엇입니까?",
        options: [
          "내부 팀 라벨링",
          "전문 주석 서비스",
          "크라우드소싱 플랫폼",
          "반자동 라벨링 도구"
        ],
        correct: 0,
        expA: "정확합니다! 내부 라벨링은 조직 내의 개발자, 테스터 또는 팀이 수행합니다.",
        expB: "전문 서비스는 외부 전문가들이지, 내부 팀 접근법이 아닙니다.",
        expC: "크라우드소싱은 분산된 외부 작업자들을 사용하며, 내부 팀이 아닙니다.",
        expD: "반자동 도구는 라벨링을 지원하지만 순수한 팀 접근법은 아닙니다.",
        points: 1,
        chapter: "ML - 데이터",
        difficulty: "K1"
      },
      {
        id: 62,
        text: "다음 중 훈련 데이터셋에 대한 설명으로 옳은 것은 무엇입니까?",
        options: [
          "최종 모델 성능을 평가합니다",
          "모델 하이퍼파라미터를 조정합니다",
          "모델에게 패턴을 학습시킵니다",
          "모델 배포를 방지합니다"
        ],
        correct: 2,
        expA: "테스트 데이터셋이 최종 성능을 평가하며, 훈련 데이터셋이 아닙니다.",
        expB: "검증 데이터셋이 하이퍼파라미터를 조정하며, 훈련 데이터셋이 아닙니다.",
        expC: "정확합니다! 훈련 데이터셋은 모델이 패턴을 학습하는 데 사용됩니다.",
        expD: "데이터셋은 배포를 방지하지 않으며, 오히려 모델 생성을 가능하게 합니다.",
        points: 1,
        chapter: "ML - 데이터",
        difficulty: "K1"
      },
      {
        id: 63,
        text: "다음 중 검증 데이터셋에 대한 설명으로 옳은 것은 무엇입니까?",
        options: [
          "초기 모델 훈련에 사용됩니다",
          "개발 중 하이퍼파라미터를 조정합니다",
          "최종 성능 평가를 제공합니다",
          "테스트 데이터셋을 완전히 대체합니다"
        ],
        correct: 1,
        expA: "훈련 데이터셋이 초기 모델 학습에 사용됩니다.",
        expB: "맞습니다! 검증 데이터셋은 하이퍼파라미터를 조정하고 과적합을 방지합니다.",
        expC: "테스트 데이터셋이 최종 성능 평가를 제공합니다.",
        expD: "검증 데이터셋과 테스트 데이터셋은 서로 다른 목적을 갖습니다.",
        points: 1,
        chapter: "ML - 데이터",
        difficulty: "K2"
      },
      {
        id: 64,
        text: "다음 중 구조화된 데이터의 가장 좋은 예시는 무엇입니까?",
        options: [
          "픽셀 값을 가진 디지털 이미지",
          "고객 데이터베이스 테이블",
          "대화의 오디오 녹음",
          "자유 텍스트 제품 리뷰"
        ],
        correct: 1,
        expA: "이미지는 픽셀 배열을 가진 비구조화된 데이터입니다.",
        expB: "정확합니다! 데이터베이스 테이블은 조직화된 행과 열 구조를 갖습니다.",
        expC: "오디오 녹음은 비구조화된 데이터입니다.",
        expD: "자유 텍스트 리뷰는 비구조화된 데이터입니다.",
        points: 1,
        chapter: "ML - 데이터",
        difficulty: "K2"
      },
      {
        id: 65,
        text: "다음 중 데이터 품질이 좋지 않음을 나타낼 가능성이 가장 높은 것은 무엇입니까?",
        options: [
          "대용량 데이터셋 크기",
          "핵심 필드의 누락 값",
          "다중 데이터 소스",
          "복잡한 데이터 관계"
        ],
        correct: 1,
        expA: "대용량 데이터셋은 실제로 모델 품질을 향상시킬 수 있습니다.",
        expB: "정확합니다! 누락 값은 대표적인 데이터 품질 문제입니다.",
        expC: "다중 소스는 적절히 관리되면 데이터 풍부성을 향상시킬 수 있습니다.",
        expD: "복잡한 관계는 실제 세계 데이터에서 정상적인 현상입니다.",
        points: 1,
        chapter: "ML - 데이터",
        difficulty: "K2"
      },
      {
        id: 66,
        text: "다음 중 데이터 전처리 과제에 대한 설명으로 옳은 것은 무엇입니까?",
        options: [
          "일반적으로 최소한의 시간 투자가 필요합니다",
          "데이터 정제와 정규화 과정을 포함합니다",
          "수치 데이터 유형만 처리합니다",
          "도메인 전문성의 필요성을 제거합니다"
        ],
        correct: 1,
        expA: "데이터 전처리는 일반적으로 ML 프로젝트 시간의 25%를 사용합니다.",
        expB: "정확합니다! 데이터 전처리는 정제, 정규화, 특성 공학을 포함합니다.",
        expC: "수치형, 범주형, 텍스트, 이미지 등 모든 데이터 유형을 처리합니다.",
        expD: "도메인 전문성은 효과적인 데이터 전처리에 필수적입니다.",
        points: 1,
        chapter: "ML - 데이터",
        difficulty: "K2"
      },
      {
        id: 67,
        text: "다음 중 샘플링 편향을 일으킬 가능성이 가장 높은 것은 무엇입니까?",
        options: [
          "영업 시간 중에만 데이터를 수집하는 것",
          "단일 지리적 지역에서 데이터를 수집하는 것",
          "이용 가능한 소스에서 편의 샘플링을 사용하는 것",
          "가장 접근하기 쉬운 인구 집단에 집중하는 것"
        ],
        correct: 1,
        expA: "피크 시간은 시간적 편향을 만들지만 여전히 다양한 인구를 대표할 수 있습니다.",
        expB: "맞습니다! 단일 지리적 지역은 중요한 인구 다양성과 문화적 변이를 놓칩니다.",
        expC: "편의 샘플링은 한계가 있지만 다양한 소스를 포함할 수 있습니다.",
        expD: "접근 가능한 집단도 여전히 합리적인 인구 대표성을 제공할 수 있습니다.",
        points: 1,
        chapter: "ML - 데이터",
        difficulty: "K2"
      },
      {
        id: 68,
        text: "다음 중 데이터 개인정보보호에 대한 설명으로 옳은 것은 무엇입니까?",
        options: [
          "개인정보는 항상 완전히 제거되어야 합니다",
          "익명화는 개인정보보호를 완전히 보장합니다",
          "프라이버시 규제 준수가 ML 개발에 영향을 미칩니다",
          "데이터 암호화만으로도 모든 프라이버시 위험을 해결할 수 있습니다"
        ],
        correct: 2,
        expA: "완전한 제거는 항상 가능하거나 필요한 것은 아닙니다.",
        expB: "익명화도 재식별 위험이 있어 완전한 보장은 어렵습니다.",
        expC: "정확합니다! GDPR 등의 프라이버시 규제는 ML 개발 과정에 중요한 영향을 미칩니다.",
        expD: "암호화만으로는 모든 프라이버시 위험을 해결할 수 없습니다.",
        points: 1,
        chapter: "ML - 데이터",
        difficulty: "K2"
      },
      {
        id: 69,
        text: "다음 중 데이터 익명화 기법은 무엇입니까?",
        options: [
          "데이터 압축을 통한 저장 공간 최적화",
          "성능 향상을 위한 인덱스 생성",
          "k-익명성을 통한 개인 식별 방지",
          "데이터 백업을 위한 복제본 생성"
        ],
        correct: 2,
        expA: "데이터 압축은 저장 최적화 기법이지 익명화 기법이 아닙니다.",
        expB: "인덱스 생성은 성능 최적화 기법입니다.",
        expC: "정확합니다! k-익명성은 개인이 식별되지 않도록 하는 대표적인 익명화 기법입니다.",
        expD: "데이터 복제는 백업 전략이지 익명화 기법이 아닙니다.",
        points: 1,
        chapter: "ML - 데이터",
        difficulty: "K2"
      },
      {
        id: 70,
        text: "다음 중 ML 프로젝트에서 데이터 개인정보보호 문제를 해결하기 위한 균형잡힌 접근법은 무엇입니까?",
        options: [
          "개인정보보호와 모델 유용성 사이의 균형을 맞춥니다",
          "개인정보는 완전히 무시하고 모델 정확도에만 집중합니다",
          "모든 개인정보를 제거하여 모델 성능을 희생합니다",
          "법적 요구사항만 충족하고 기술적 조치는 무시합니다"
        ],
        correct: 0,
        expA: "정확합니다! 개인정보보호와 모델 유용성 사이의 균형이 실용적이고 윤리적인 접근법입니다.",
        expB: "개인정보 무시는 법적, 윤리적 문제를 야기할 수 있습니다.",
        expC: "과도한 개인정보 제거는 모델을 사용할 수 없게 만들 수 있습니다.",
        expD: "기술적 조치 없이는 법적 요구사항도 제대로 충족할 수 없습니다.",
        points: 1,
        chapter: "ML - 데이터",
        difficulty: "K2"
      },
      {
        id: 71,
        text: "전자상거래 플랫폼에서 추천 시스템의 편향을 감지하기 위한 가장 효과적인 접근법은 무엇입니까?",
        options: [
          "다양한 사용자 그룹별 추천 결과를 체계적으로 분석합니다",
          "전체 사용자 만족도만을 측정합니다",
          "가장 많이 팔린 제품들의 추천 빈도만 확인합니다",
          "시스템의 기술적 성능 지표만 모니터링합니다"
        ],
        correct: 0,
        expA: "정확합니다! 다양한 사용자 그룹별 분석은 편향을 체계적으로 식별하는 핵심 방법입니다.",
        expB: "전체 만족도만으로는 특정 그룹에 대한 편향을 놓칠 수 있습니다.",
        expC: "인기 제품 추천만으로는 편향의 전체적인 패턴을 파악하기 어렵습니다.",
        expD: "기술적 성능만으로는 사회적, 문화적 편향을 감지할 수 없습니다.",
        points: 2,
        chapter: "ML - 데이터",
        difficulty: "K3"
      },
      {
        id: 72,
        text: "의료 진단 AI 시스템에서 훈련 데이터의 대표성을 보장하기 위한 핵심 고려사항은 무엇입니까?",
        options: [
          "가장 흔한 질병 사례에만 집중합니다",
          "인구통계학적 다양성과 의료적 복잡성을 균형있게 포함합니다",
          "단일 의료기관의 데이터만 사용하여 일관성을 유지합니다",
          "최신 데이터만 사용하여 현재 의료 환경을 반영합니다"
        ],
        correct: 1,
        expA: "흔한 질병에만 집중하면 희귀 질환이나 다양한 증상 변이를 놓칠 수 있습니다.",
        expB: "정확합니다! 의료 AI는 다양한 인구와 의료적 복잡성을 모두 고려해야 공정하고 효과적입니다.",
        expC: "단일 기관 데이터는 지역적, 문화적 편향을 만들 수 있습니다.",
        expD: "최신 데이터만으로는 충분한 다양성과 대표성을 확보하기 어렵습니다.",
        points: 2,
        chapter: "ML - 데이터",
        difficulty: "K3"
      },
      {
        id: 73,
        text: "금융 신용평가 모델에서 공정성을 보장하기 위한 데이터 전략은 무엇입니까?",
        options: [
          "과거 승인 패턴만을 기반으로 모델을 구축합니다",
          "다양한 인구통계학적 그룹의 균형잡힌 대표성을 확보하고 편향을 모니터링합니다",
          "가장 안전한 고객군만을 대상으로 모델을 제한합니다",
          "기존 신용점수 시스템의 결정을 그대로 복제합니다"
        ],
        correct: 1,
        expA: "과거 패턴은 기존의 편향을 그대로 재현할 위험이 있습니다.",
        expB: "정확합니다! 균형잡힌 대표성과 지속적인 편향 모니터링이 공정한 금융 모델의 핵심입니다.",
        expC: "안전한 고객군 제한은 금융 포용성을 저해하고 편향을 강화할 수 있습니다.",
        expD: "기존 시스템 복제는 과거의 차별적 관행을 그대로 이어받을 수 있습니다.",
        points: 2,
        chapter: "ML - 데이터",
        difficulty: "K3"
      },
      {
        id: 74,
        text: "다국어 자연어 처리 시스템에서 언어적 편향을 최소화하기 위한 효과적인 데이터 전략은 무엇입니까?",
        options: [
          "각 언어별로 균등하게 가중치를 부여하고 문화적 맥락을 고려합니다",
          "가장 많이 사용되는 언어에만 집중합니다",
          "모든 언어를 단일 표준으로 정규화합니다",
          "기계 번역으로 모든 데이터를 영어로 통일합니다"
        ],
        correct: 0,
        expA: "정확합니다! 언어적 공정성을 위해서는 균등한 가중치와 문화적 맥락 고려가 필수적입니다.",
        expB: "주요 언어 편중은 소수 언어 화자들에게 불공정한 결과를 초래할 수 있습니다.",
        expC: "단일 표준 정규화는 언어의 고유한 특성과 문화적 뉘앙스를 손실시킵니다.",
        expD: "기계 번역 통일은 원본 언어의 의미와 문화적 맥락을 왜곡할 수 있습니다.",
        points: 2,
        chapter: "ML - 데이터",
        difficulty: "K3"
      },
      {
        id: 75,
        text: "IoT 환경에서 센서 데이터의 품질 문제를 해결하기 위한 포괄적 접근법은 무엇입니까?",
        options: [
          "모든 센서 데이터를 동일하게 신뢰합니다",
          "이상치는 무조건 제거합니다",
          "단일 센서 타입만 사용하여 일관성을 유지합니다",
          "다중 센서 검증과 시계열 이상 탐지를 결합합니다"
        ],
        correct: 3,
        expA: "모든 센서를 동일하게 신뢰하면 결함있는 센서의 영향을 받을 수 있습니다.",
        expB: "무조건적인 이상치 제거는 중요한 실제 이벤트를 놓칠 수 있습니다.",
        expC: "단일 센서 타입은 다양한 환경 요소를 포착하지 못할 수 있습니다.",
        expD: "정확합니다! 다중 센서 검증과 시계열 분석의 결합이 IoT 데이터 품질 보장의 핵심입니다.",
        points: 2,
        chapter: "ML - 데이터",
        difficulty: "K3"
      },
      {
        id: 76,
        text: "자율주행차 AI 시스템에서 엣지 케이스 데이터를 효과적으로 관리하기 위한 전략은 무엇입니까?",
        options: [
          "일반적인 주행 상황에만 집중합니다",
          "시뮬레이션과 실제 데이터를 결합하여 희귀 상황을 보강하고 지속적으로 업데이트합니다",
          "엣지 케이스는 무시하고 일반적인 패턴만 학습합니다",
          "과거 사고 데이터만을 기반으로 훈련합니다"
        ],
        correct: 1,
        expA: "일반적인 상황만으로는 예외적인 위험 상황에 대응할 수 없습니다.",
        expB: "정확합니다! 시뮬레이션과 실제 데이터의 결합으로 희귀하지만 중요한 상황을 효과적으로 처리할 수 있습니다.",
        expC: "엣지 케이스 무시는 자율주행에서 치명적인 안전 문제를 야기할 수 있습니다.",
        expD: "사고 데이터만으로는 예방적 대응보다는 사후적 대응에만 치우칠 수 있습니다.",
        points: 2,
        chapter: "ML - 데이터",
        difficulty: "K3"
      },
      {
        id: 77,
        text: "병원에서 다양한 진료과의 의료 데이터를 통합하여 AI 진단 시스템을 구축할 때, 편향을 최소화하고 공정성을 보장하기 위한 포괄적 전략은 무엇입니까?",
        options: [
          "다학제적 데이터 거버넌스, 지속적 편향 감사, 그리고 임상 전문가 검토를 통합합니다",
          "가장 많은 데이터를 보유한 진료과의 데이터만 사용합니다",
          "모든 진료과 데이터를 단순히 합쳐서 처리합니다",
          "외부 상업적 의료 데이터만을 사용하여 일관성을 확보합니다"
        ],
        correct: 0,
        expA: "정확합니다! 의료 AI의 공정성은 다학제적 접근, 지속적 모니터링, 전문가 검토의 통합이 필요합니다.",
        expB: "특정 진료과 편중은 다른 의료 분야에서 부정확한 진단을 초래할 수 있습니다.",
        expC: "단순 통합은 각 진료과의 특성과 편향을 고려하지 못합니다.",
        expD: "외부 데이터만으로는 해당 병원의 환자 특성과 진료 환경을 반영하지 못합니다.",
        points: 3,
        chapter: "ML - 데이터",
        difficulty: "K4"
      },
      {
        id: 78,
        text: "글로벌 소셜 미디어 플랫폼에서 다중 언어, 다중 문화 콘텐츠의 품질 관리를 위한 최적의 시스템 아키텍처는 무엇입니까?",
        options: [
          "다층 합의 메커니즘과 동적 점수 시스템을 통한 지역별 적응형 품질 평가 프레임워크를 구축합니다",
          "단일 언어 기준으로 모든 콘텐츠를 평가합니다",
          "각 지역별로 완전히 독립적인 시스템을 운영합니다",
          "자동화된 번역 도구만을 사용하여 통일된 기준을 적용합니다"
        ],
        correct: 0,
        expA: "정확합니다! 다층 합의와 동적 적응은 문화적 다양성을 존중하면서도 일관된 품질을 보장하는 최적의 접근법입니다.",
        expB: "단일 언어 기준은 다른 문화권의 콘텐츠를 부적절하게 평가할 수 있습니다.",
        expC: "완전 독립 시스템은 비효율적이고 글로벌 일관성을 해칠 수 있습니다.",
        expD: "자동 번역만으로는 문화적 뉘앙스와 맥락을 정확히 처리하기 어렵습니다.",
        points: 3,
        chapter: "ML - 데이터",
        difficulty: "K4"
      },
      {
        id: 79,
        text: "스마트 시티 통합 관리 시스템에서 교통, 에너지, 보안 등 다양한 도메인의 데이터를 융합할 때, 적응형 데이터 아키텍처 구축을 위한 전략적 접근법은 무엇입니까?",
        options: [
          "연방학습 기반의 분산 처리와 실시간 적응 메커니즘을 통한 도메인 간 지능형 협력 체계를 구현합니다",
          "모든 데이터를 중앙 집중식으로 통합하여 단일 모델로 처리합니다",
          "각 도메인별로 완전히 분리된 시스템을 유지합니다",
          "가장 중요한 도메인 하나만 선택하여 집중 관리합니다"
        ],
        correct: 0,
        expA: "정확합니다! 연방학습과 실시간 적응은 프라이버시를 보장하면서도 도메인 간 시너지를 최대화하는 최첨단 접근법입니다.",
        expB: "중앙 집중식 통합은 프라이버시 위험과 단일 실패점 문제를 야기할 수 있습니다.",
        expC: "완전 분리는 도메인 간 상호작용과 통합적 최적화 기회를 놓칩니다.",
        expD: "단일 도메인 집중은 스마트 시티의 통합적 이익을 실현하지 못합니다.",
        points: 3,
        chapter: "ML - 데이터",
        difficulty: "K4"
      },
      {
        id: 80,
        text: "대규모 농업 회사에서 다양한 지역, 작물, 기후 조건의 데이터를 통합하여 정밀 농업 AI를 구축할 때, 어노테이터 품질 관리와 지속적 개선을 위한 최적의 시스템은 무엇입니까?",
        options: [
          "다층 합의와 동적 점수 평가 및 피드백을 통해 품질 측정과 어노테이터 개선을 체계적으로 해결합니다",
          "ML 품질 필터만을 사용하여 문제를 식별합니다",
          "전문가 패널의 감독만으로 품질을 관리합니다",
          "인센티브 정렬만으로 동기부여 문제를 해결합니다"
        ],
        correct: 0,
        expA: "정확합니다! 다층 합의와 동적 피드백 시스템은 품질 측정과 어노테이터 개선을 모두 체계적으로 해결합니다.",
        expB: "ML 품질 필터는 문제를 식별하지만 어노테이터 불일치의 근본 원인을 해결하지 못합니다.",
        expC: "전문가 패널은 감독을 제공하지만 확장성이 제한적이고 개별 어노테이터 성능을 개선하지 못할 수 있습니다.",
        expD: "인센티브 정렬은 동기부여에 도움이 되지만 기술이나 합의 방법론 문제를 직접 해결하지 못합니다.",
        points: 3,
        chapter: "ML - 데이터",
        difficulty: "K4"
      },
      {
        id: 81,
        text: "다음 중 실제 양성 사례가 올바르게 식별된 비율을 측정하는 메트릭은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "정밀도(Precision)",
          "재현율(Recall)", 
          "정확도(Accuracy)",
          "F1-점수"
        ],
        correct: 1,
        expA: "정밀도는 예측된 양성 중 실제로 맞은 비율을 측정하며, 실제 양성을 찾은 비율이 아닙니다.",
        expB: "정확합니다! 재현율은 실제 양성 사례 중 모델이 올바르게 식별한 비율을 측정합니다.",
        expC: "정확도는 모든 클래스에 대한 전체적인 정확성을 측정하며, 구체적으로 실제 양성 식별률을 나타내지 않습니다.",
        expD: "F1-점수는 정밀도와 재현율을 결합하지만, 구체적으로 실제 양성 식별률을 측정하지는 않습니다.",
        points: 1,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K1"
      },
      {
        id: 82,
        text: "혼동 행렬에 대한 다음 설명 중 올바른 것은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "정확도 메트릭만 표시함",
          "예측과 실제 분류를 비교 표시함",
          "정밀도와 재현율 값을 측정함", 
          "F1-점수를 자동으로 계산함"
        ],
        correct: 1,
        expA: "혼동 행렬은 정확도 계산뿐만 아니라 분류 결과를 보여줍니다.",
        expB: "완벽합니다! 혼동 행렬은 예측된 분류가 실제 분류와 어떻게 비교되는지 표시합니다.",
        expC: "정밀도와 재현율을 계산할 수 있지만, 행렬 자체는 분류 개수를 보여줍니다.",
        expD: "F1-점수는 혼동 행렬 데이터로부터 계산되지만, 자동으로 표시되지는 않습니다.",
        points: 1,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K1"
      },
      {
        id: 83, 
        text: "다음 중 회귀 모델에 가장 적합한 메트릭은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "정밀도(Precision)",
          "재현율(Recall)", 
          "평균 제곱 오차(MSE)",
          "F1-점수"
        ],
        correct: 2,
        expA: "정밀도는 범주형 예측에 사용되는 분류 메트릭이며, 회귀용이 아닙니다.",
        expB: "재현율도 분류 메트릭이며, 회귀 문제에는 적용되지 않습니다.",
        expC: "정확합니다! 평균 제곱 오차(MSE)는 회귀 모델이 실제 데이터 포인트에 얼마나 잘 맞는지 측정합니다.", 
        expD: "F1-점수는 분류를 위한 정밀도와 재현율을 결합하며, 회귀 작업용이 아닙니다.",
        points: 1,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K2"
      },
      {
        id: 84,
        text: "다음 중 ML 기능 성능 메트릭의 한계는 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "계산이 너무 복잡함",
          "모델 성능을 부정확하게 반영함",
          "비즈니스 맥락을 무시할 수 있음",
          "작은 데이터셋에서만 작동함"
        ],
        correct: 2,
        expA: "대부분의 ML 메트릭은 적절히 설명하면 충분히 이해할 수 있습니다.",
        expB: "잘 선택된 메트릭은 일반적으로 모델 성능을 정확하게 반영합니다.",
        expC: "맞습니다! 기술적 메트릭은 때때로 실제 비즈니스 목표와 요구사항을 간과할 수 있습니다.",
        expD: "ML 메트릭은 적절한 통계적 고려사항과 함께 다양한 데이터 크기에서 작동합니다.",
        points: 1,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K2"
      },
      {
        id: 85,
        text: "불균형 데이터셋에서 다음 중 가장 적절한 메트릭은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "전체 정확도만 사용",
          "정밀도와 재현율 균형", 
          "샘플 수만 계산",
          "훈련 시간 측정"
        ],
        correct: 1,
        expA: "전체 정확도는 불균형 데이터셋에서 다수 클래스에 편향되어 오해를 일으킬 수 있습니다.",
        expB: "정확합니다! 불균형 데이터에서는 정밀도와 재현율의 균형이 더 의미 있는 평가를 제공합니다.",
        expC: "샘플 수는 분포 정보는 제공하지만 모델 성능을 직접적으로 평가하지는 않습니다.",
        expD: "훈련 시간은 성능 메트릭이지만 모델의 예측 품질과는 직접적으로 관련이 없습니다.",
        points: 2,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K3"
      },
      {
        id: 86,
        text: "ROC 곡선 분석에서 다음 중 가장 바람직한 특성은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "대각선에 가까운 곡선",
          "좌상단 모서리에 가까운 곡선", 
          "우하단 영역의 곡선",
          "수평선 형태의 곡선"
        ],
        correct: 1,
        expA: "대각선은 무작위 분류기를 나타내며, 바람직하지 않습니다.",
        expB: "정확합니다! 좌상단에 가까운 곡선은 높은 진양성률과 낮은 거짓양성률을 나타냅니다.",
        expC: "우하단 곡선은 성능이 무작위보다 나쁨을 나타냅니다.",
        expD: "수평선은 극단적인 경우를 나타내며 일반적으로 현실적이지 않습니다.",
        points: 2,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K3"
      },
      {
        id: 87,
        text: "클러스터링 모델의 품질을 평가할 때 다음 중 가장 적절한 접근법은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "내부 검증과 외부 검증 결합",
          "훈련 데이터에서만 평가", 
          "클러스터 수만 계산",
          "실행 시간만 측정"
        ],
        correct: 0,
        expA: "정확합니다! 내부 메트릭(실루엣 점수)과 외부 검증(도메인 지식)을 결합하면 포괄적인 평가가 가능합니다.",
        expB: "훈련 데이터만으로는 클러스터의 실제 유용성이나 일반화 능력을 평가할 수 없습니다.",
        expC: "클러스터 수는 구조의 한 측면이지만 클러스터링 품질을 완전히 평가하지는 못합니다.",
        expD: "실행 시간은 효율성을 나타내지만 클러스터링 결과의 품질과는 직접적으로 관련이 없습니다.",
        points: 1,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K2"
      },
      {
        id: 88,
        text: "의료 AI 시스템에서 민감도 최적화가 우선되어야 하는 경우는 언제입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "비용 절감이 주목표일 때",
          "처리 속도가 중요할 때", 
          "질병 놓침의 결과가 심각할 때",
          "데이터 저장 공간이 제한될 때"
        ],
        correct: 2,
        expA: "비용 절감은 중요하지만 의료 진단 정확성보다 우선될 수는 없습니다.",
        expB: "속도는 유용하지만 민감도 최적화의 주된 이유는 아닙니다.",
        expC: "정확합니다! 질병을 놓치는 것(거짓 음성)이 심각한 결과를 초래할 때 민감도가 우선되어야 합니다.",
        expD: "저장 공간 제약은 기술적 고려사항이지만 민감도 최적화와 직접적으로 관련이 없습니다.",
        points: 2,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K3"
      },
      {
        id: 89,
        text: "교차 검증에서 다음 중 가장 일반적인 문제는 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "계산 비용이 너무 높음",
          "결과 해석이 어려움", 
          "데이터 누출 위험",
          "메모리 사용량 증가"
        ],
        correct: 2,
        expA: "계산 비용은 고려사항이지만 가장 일반적인 문제는 아닙니다.",
        expB: "교차 검증 결과는 일반적으로 해석하기 어렵지 않습니다.",
        expC: "정확합니다! 부적절한 데이터 분할은 훈련과 검증 세트 간의 정보 누출로 이어질 수 있습니다.",
        expD: "메모리 사용량은 관리 가능한 기술적 측면입니다.",
        points: 2,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K3"
      },
      {
        id: 90,
        text: "다음 중 A/B 테스트의 핵심 요구사항은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "무작위 사용자 할당",
          "동일한 모델 아키텍처", 
          "같은 훈련 데이터",
          "동일한 하드웨어 설정"
        ],
        correct: 0,
        expA: "맞습니다! 무작위 할당은 편향을 방지하고 공정한 비교를 보장하는 핵심 요소입니다.",
        expB: "A/B 테스트는 종종 서로 다른 모델 아키텍처를 비교하는 데 사용됩니다.",
        expC: "다른 훈련 데이터를 사용하는 모델들도 A/B 테스트로 비교할 수 있습니다.",
        expD: "하드웨어 설정은 일관성을 위해 바람직하지만 핵심 요구사항은 아닙니다.",
        points: 1,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K2"
      },
      {
        id: 91,
        text: "금융 사기 탐지 시스템에서 도메인 적응이 필요한 상황은 언제입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "새로운 사기 패턴이 출현할 때",
          "시스템 성능이 안정적일 때", 
          "데이터 볼륨이 감소할 때",
          "하드웨어를 업그레이드할 때"
        ],
        correct: 0,
        expA: "정확합니다! 새로운 사기 패턴은 기존 모델이 학습하지 못한 것으로, 도메인 적응이 필요합니다.",
        expB: "안정적인 성능일 때는 일반적으로 도메인 적응이 불필요합니다.",
        expC: "데이터 볼륨 감소는 다른 최적화 접근법을 요구할 수 있지만 도메인 적응과는 직접적으로 관련이 없습니다.",
        expD: "하드웨어 업그레이드는 성능 향상이지만 도메인 적응의 이유는 아닙니다.",
        points: 2,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K3"
      },
      {
        id: 92,
        text: "다음 중 베이스라인 모델의 주요 목적은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "최종 프로덕션 시스템으로 사용",
          "복잡한 모델의 성능 비교 기준", 
          "데이터 전처리 자동화",
          "하이퍼파라미터 튜닝 대체"
        ],
        correct: 1,
        expA: "베이스라인 모델은 일반적으로 단순해서 최종 프로덕션 시스템으로는 부적절합니다.",
        expB: "정확합니다! 베이스라인은 더 복잡한 모델이 개선을 보이는지 평가하는 비교 기준점을 제공합니다.",
        expC: "베이스라인 모델은 데이터 전처리와 직접적으로 관련이 없습니다.",
        expD: "베이스라인은 하이퍼파라미터 튜닝을 대체하지 않으며, 성능 벤치마크를 제공합니다.",
        points: 1,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K2"
      },
      {
        id: 93,
        text: "시계열 예측에서 다음 중 가장 적절한 검증 방법은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "무작위 분할 교차 검증",
          "계층화 샘플링", 
          "시간 기반 분할",
          "부트스트랩 샘플링"
        ],
        correct: 2,
        expA: "무작위 분할은 시계열의 시간적 순서를 파괴하여 데이터 누출을 일으킬 수 있습니다.",
        expB: "계층화 샘플링은 분류 작업에 유용하지만 시계열에는 적절하지 않습니다.",
        expC: "정확합니다! 시간 기반 분할은 시간적 순서를 유지하고 실제 예측 시나리오를 모방합니다.",
        expD: "부트스트랩 샘플링은 시계열 데이터의 시간적 의존성을 깨뜨릴 수 있습니다.",
        points: 2,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K3"
      },
      {
        id: 94,
        text: "다음 중 모델 해석가능성 메트릭의 예는 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "훈련 정확도",
          "특성 중요도 점수", 
          "추론 지연 시간",
          "메모리 사용량"
        ],
        correct: 1,
        expA: "훈련 정확도는 성능 메트릭이지만 해석가능성을 측정하지는 않습니다.",
        expB: "정확합니다! 특성 중요도 점수는 모델 결정에서 각 특성의 기여도를 나타내어 해석가능성을 향상시킵니다.",
        expC: "추론 지연 시간은 성능 효율성 메트릭이지만 해석가능성과는 관련이 없습니다.",
        expD: "메모리 사용량은 리소스 효율성을 측정하지만 모델 해석가능성과는 직접적으로 관련이 없습니다.",
        points: 1,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K2"
      },
      {
        id: 95,
        text: "다중 클래스 분류에서 다음 중 가장 포괄적인 평가 접근법은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "전체 정확도만 보고",
          "가장 빈번한 클래스만 분석", 
          "각 클래스별 정밀도와 재현율",
          "훈련 시간만 측정"
        ],
        correct: 2,
        expA: "전체 정확도는 유용하지만 클래스별 성능의 차이를 숨길 수 있습니다.",
        expB: "한 클래스에만 집중하면 다른 클래스의 성능 문제를 놓칠 수 있습니다.",
        expC: "정확합니다! 각 클래스별 메트릭은 모든 클래스에서의 성능에 대한 완전한 그림을 제공합니다.",
        expD: "훈련 시간은 효율성 메트릭이지만 분류 품질을 평가하지는 않습니다.",
        points: 2,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K3"
      },
      {
        id: 96,
        text: "DataCorp이 사기 탐지 시스템을 개발 중입니다. 시스템이 높은 정확도를 보이지만 새로운 사기 유형을 놓치고 있습니다. 다음 중 가장 적절한 다중 요소 평가 프레임워크는 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "적응형 임계값과 새로운 패턴 탐지 결합",
          "단일 정확도 메트릭에만 의존", 
          "역사적 데이터에서만 성능 검증",
          "처리 속도 최적화에만 집중"
        ],
        correct: 0,
        expA: "정확합니다! 적응형 접근법은 진화하는 사기 패턴을 다루면서 정확도와 탐지 범위의 균형을 맞춥니다.",
        expB: "단일 메트릭으로는 새로운 사기 유형 탐지의 복잡성을 포착할 수 없습니다.",
        expC: "역사적 데이터만으로는 새로운 사기 패턴에 대한 모델의 적응력을 평가할 수 없습니다.",
        expD: "속도 최적화는 중요하지만 탐지 효과성 문제를 해결하지는 못합니다.",
        points: 3,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K4"
      },
      {
        id: 97,
        text: "TechHealth가 진단 AI 모델을 배포 중입니다. 규제 기관이 다양한 인구 집단에서의 공정성을 요구합니다. 다음 중 가장 포괄적인 공정성 평가 접근법은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "전체 정확도만 측정",
          "가장 큰 집단에서만 테스트", 
          "집단별 성능 격차와 결과 공정성 분석",
          "훈련 데이터 크기만 확인"
        ],
        correct: 2,
        expA: "전체 정확도는 집단 간 성능 차이를 숨길 수 있어 공정성 평가에 불충분합니다.",
        expB: "한 집단에서만 테스트하면 다른 집단에서의 잠재적 편향을 발견할 수 없습니다.",
        expC: "정확합니다! 집단별 성능 격차와 결과 공정성을 분석하면 규제 요구사항을 충족하는 포괄적인 평가가 가능합니다.",
        expD: "훈련 데이터 크기는 편향의 한 요소이지만 실제 성능 공정성을 측정하지는 않습니다.",
        points: 3,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K4"
      },
      {
        id: 98,
        text: "다음 중 앙상블 모델의 성능을 평가할 때 가장 중요한 고려사항은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "개별 모델 성능만 확인",
          "결합된 예측 성능과 다양성 균형", 
          "가장 빠른 모델만 선택",
          "메모리 사용량만 최적화"
        ],
        correct: 1,
        expA: "개별 모델 성능은 중요하지만 앙상블의 전체적인 이점을 평가하지는 못합니다.",
        expB: "정확합니다! 앙상블의 효과는 결합된 성능과 모델 간 다양성의 균형에서 나옵니다.",
        expC: "속도는 중요하지만 앙상블의 주요 목적인 성능 향상을 간과합니다.",
        expD: "메모리 최적화는 실용적이지만 앙상블의 예측 품질을 평가하지는 않습니다.",
        points: 1,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K2"
      },
      {
        id: 99,
        text: "AutoDrive가 자율주행 시스템을 개발 중입니다. 다양한 도로 조건에서 안전성이 우선되어야 합니다. 다음 중 가장 적절한 다중 기준 평가 접근법은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "상황 인식 검증을 통한 적응형 다중 기준 평가",
          "단일 메트릭으로는 중요한 성능 측면을 놓칠 수 있음", 
          "시나리오별 프로토콜이 도움이 되지만 다른 조건 간 상호작용을 놓칠 수 있음",
          "지속적 모니터링은 프로덕션에 유용하지만 배포 전 평가 프레임워크를 구축하지 못함"
        ],
        correct: 0,
        expA: "정확합니다! 상황 인식 검증을 통한 적응형 다중 기준 평가는 안전성 중심을 유지하면서 다양한 조건의 복잡성을 다룹니다.",
        expB: "단일 메트릭은 중요한 성능 측면을 놓칠 수 있으며 다른 안전 중요 시나리오에 적응하지 못합니다.",
        expC: "시나리오별 프로토콜은 도움이 되지만 다른 조건과 안전 측면 간의 상호작용을 놓칠 수 있습니다.",
        expD: "지속적 모니터링은 프로덕션에 유용하지만 포괄적인 배포 전 평가 프레임워크를 구축하지는 못합니다.",
        points: 3,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K4"
      },
      {
        id: 100,
        text: "TechFinance가 신용 점수 모델을 개발 중입니다. 시스템이 과거 데이터에서 우수한 메트릭을 보이지만 6개월 운영 후 성능이 저하됩니다. 다음 중 가장 효과적인 포괄적인 모니터링 전략은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "과거 기준선과 주요 메트릭 주간 비교",
          "데이터 드리프트, 모델 성능, 비즈니스 지표의 통합 모니터링", 
          "정확도가 임계값 이하로 떨어질 때 자동 재훈련",
          "입력 데이터 분포와 통계 유의성 정기 분석"
        ],
        correct: 1,
        expA: "과거 데이터와의 비교는 중요하지만 성능 저하의 원인을 식별하지는 못합니다.",
        expB: "정확합니다! 통합적 접근법은 데이터 드리프트, 기술적 메트릭, 실제 비즈니스 결과 간의 상호관계를 고려합니다.",
        expC: "원인 분석 없는 자동 재훈련은 문제를 악화시키거나 불안정성을 초래할 수 있습니다.",
        expD: "통계 분석은 유용하지만 그 자체로는 프로덕션 성능의 전체적인 그림을 제공하지 못합니다.",
        points: 3,
        chapter: "ML 기능 성능 메트릭",
        difficulty: "K4"
      },
      {
        id: 101,
        text: "다음 중 퍼셉트론을 올바르게 설명하는 것은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "하나의 뉴런을 가진 단층 신경망",
          "은닉층을 가진 다층 퍼셉트론",
          "선형 활성화를 가진 피드포워드 네트워크",
          "편향 항을 가진 단순 신경망"
        ],
        correct: 0,
        expA: "완벽합니다! 퍼셉트론은 정확히 그것입니다 - 단 하나의 뉴런을 가진 단층 신경망입니다.",
        expB: "다층 퍼셉트론은 은닉층을 가진 더 복잡한 아키텍처입니다.",
        expC: "피드포워드 네트워크는 더 넓은 범주이며, 퍼셉트론에 특정하지 않습니다.",
        expD: "퍼셉트론이 편향을 사용하지만, 이것이 핵심 구조를 정의하지는 않습니다.",
        points: 1,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K1"
      },
      {
        id: 102,
        text: "깊은 신경망에 대한 다음 설명 중 올바른 것은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "입력층과 출력층만 가짐",
          "수동적 특성 공학이 필요함",
          "여러 개의 은닉층으로 구성됨",
          "선형 활성화 함수만 사용함"
        ],
        correct: 2,
        expA: "깊은 네트워크는 구체적으로 은닉층을 포함한 여러 층을 가집니다.",
        expB: "깊은 네트워크는 특성을 자동으로 학습하여 수동 공학의 필요성을 줄입니다.",
        expC: "정확합니다! 깊은 신경망은 여러 개의 은닉층을 가지는 것으로 정의됩니다.",
        expD: "깊은 네트워크는 다양한 활성화 함수, 종종 비선형 함수들을 사용합니다.",
        points: 1,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K1"
      },
      {
        id: 103,
        text: "뉴런 커버리지에 대한 다음 설명 중 올바른 것은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "기준선 이상의 활성화를 가진 뉴런을 측정함",
          "최소 활성화 임계값을 초과하는 뉴런을 추적함",
          "상당한 활성화 변화를 보이는 뉴런을 모니터링함",
          "목표 활성화 수준을 달성하는 뉴런을 평가함"
        ],
        correct: 0,
        expA: "정확합니다! 뉴런 커버리지는 단순히 뉴런이 영점 기준선 이상으로 활성화되는지 측정합니다.",
        expB: "이는 특정 최소 임계값을 사용하는 임계값 커버리지를 설명합니다.",
        expC: "이는 활성화 차이를 추적하는 값 변화 커버리지를 설명합니다.",
        expD: "이는 특정 목표를 가진 더 정교한 커버리지 메트릭을 설명합니다.",
        points: 1,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K2"
      },
      {
        id: 104,
        text: "임계값 커버리지에 대한 다음 설명 중 올바른 것은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "영점 활성화만 확인함",
          "지정된 임계값 이상의 활성화가 필요함",
          "층 간의 커버리지를 측정함",
          "총 활성 뉴런 수를 계산함"
        ],
        correct: 1,
        expA: "임계값 커버리지는 영점뿐만 아니라 더 높은 임계값을 사용합니다.",
        expB: "완벽합니다! 임계값 커버리지는 뉴런이 지정된 임계값 이상으로 활성화되어야 합니다.",
        expC: "층 간의 커버리지는 사인-사인 커버리지와 같은 다른 메트릭에서 처리됩니다.",
        expD: "활성 뉴런을 단순히 계산하는 것이 아니라 임계값 요구사항에 중점을 둡니다.",
        points: 1,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K2"
      },
      {
        id: 105,
        text: "사인 변화 커버리지에 대한 다음 설명 중 올바른 것은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "뉴런이 양수와 음수 값을 모두 달성하도록 요구함",
          "테스트 실행 간의 활성화 차이를 측정함",
          "테스팅 중 임계값 교차를 추적함",
          "층 간 사인 일관성을 평가함"
        ],
        correct: 0,
        expA: "정확합니다! 사인 변화 커버리지는 각 뉴런이 양수와 음수 활성화 값을 모두 달성하도록 보장합니다.",
        expB: "이는 사인 변화 커버리지가 아닌 값 변화 커버리지를 설명합니다.",
        expC: "이는 사인 변화가 아닌 임계값 커버리지 동작을 설명합니다.",
        expD: "이는 개별 뉴런 사인 변화가 아닌 층 간 사인-사인 커버리지를 설명합니다.",
        points: 1,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K2"
      },
      {
        id: 106,
        text: "사인-사인 커버리지에 대한 다음 설명 중 올바른 것은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "개별 뉴런 활성화를 측정함",
          "활성화 값 변화를 추적함",
          "인접층 뉴런 쌍의 사인 변화를 검사함",
          "특정 임계값 이상의 뉴런을 계산함"
        ],
        correct: 2,
        expA: "사인-사인 커버리지는 개별이 아닌 뉴런 쌍을 구체적으로 살펴봅니다.",
        expB: "그것은 양수/음수 값을 추적하는 사인 변화 커버리지입니다.",
        expC: "정확합니다! 사인-사인 커버리지는 인접층의 뉴런 쌍을 검사하여 한 뉴런의 사인 변화가 다른 뉴런에 영향을 주는지 확인합니다.",
        expD: "그것은 활성화 임계값을 사용하는 임계값 커버리지입니다.",
        points: 1,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K2"
      },
      {
        id: 107,
        text: "값 변화 커버리지에 대한 다음 설명 중 올바른 것은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "영점 활성화를 가진 뉴런을 측정함",
          "고정 임계값 이상의 뉴런이 필요함",
          "선택된 양만큼의 활성화 차이가 필요함",
          "출력 뉴런에만 적용됨"
        ],
        correct: 2,
        expA: "값 변화 커버리지는 영점 값이 아닌 차이를 살펴봅니다.",
        expB: "그것은 값 변화 커버리지가 아닌 임계값 커버리지입니다.",
        expC: "완벽합니다! 값 변화 커버리지는 뉴런이 선택된 값을 초과하는 활성화 차이를 보이도록 요구합니다.",
        expD: "출력층뿐만 아니라 네트워크의 모든 뉴런에 적용됩니다.",
        points: 1,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K2"
      },
      {
        id: 108,
        text: "다음 중 이미지 처리에 가장 적합한 신경망 유형은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "풀링층을 가진 깊은 합성곱 신경망",
          "이미지 전처리층을 가진 다층 퍼셉트론",
          "스킵 연결을 가진 잔차 신경망",
          "특성 추출을 가진 밀집 연결 네트워크"
        ],
        correct: 0,
        expA: "훌륭합니다! 풀링을 가진 CNN은 이미지의 공간적 특성 추출을 위해 특별히 설계되었습니다.",
        expB: "MLP는 이미지를 처리할 수 있지만 CNN의 공간 인식과 효율성이 부족합니다.",
        expC: "ResNet은 강력하지만 실제로는 별도 범주가 아닌 CNN의 한 유형입니다.",
        expD: "밀집 네트워크도 작동할 수 있지만 CNN처럼 공간적 지역성을 활용하지 않습니다.",
        points: 1,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K2"
      },
      {
        id: 109,
        text: "다음 중 사인-사인 커버리지의 최고 예시를 제공하는 것은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "임계값 이상의 뉴런 활성화 테스트",
          "뉴런이 양수와 음수 값을 보이는지 확인",
          "사인 변화가 인접층 뉴런에 영향을 주는지 확인",
          "뉴런 전체의 총 활성화 측정"
        ],
        correct: 2,
        expA: "그것은 사인-사인 커버리지가 아닌 임계값 커버리지입니다.",
        expB: "그것은 사인-사인 커버리지가 아닌 사인 변화 커버리지입니다.",
        expC: "완벽합니다! 사인-사인 커버리지는 인접층 간 사인 변화 전파를 테스트합니다.",
        expD: "그것은 사인-사인 커버리지가 아닌 일반적인 활성화 측정입니다.",
        points: 1,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K2"
      },
      {
        id: 110,
        text: "신경망에 가장 포괄적인 테스팅을 제공하는 커버리지 접근법은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "여러 커버리지 측정의 가중 조합",
          "네트워크 복잡성 기반 우선순위 커버리지 메트릭",
          "의존성 분석을 통한 순차적 커버리지 측정",
          "테스팅 목표 기반 적응형 커버리지 선택"
        ],
        correct: 0,
        expA: "완벽합니다! 가중 조합은 중요도에 따라 다양한 측면의 균형을 맞춰 포괄적인 커버리지를 제공합니다.",
        expB: "우선순위화는 도움이 되지만 우선순위되지 않은 중요한 측면을 놓칠 수 있습니다.",
        expC: "순차적 측정은 체계적이지만 통찰력을 효과적으로 결합하지 않습니다.",
        expD: "적응형 선택은 유연하지만 포괄적인 커버리지를 달성하지 못할 수 있습니다.",
        points: 1,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K2"
      },
      {
        id: 111,
        text: "신경망이 85% 뉴런 커버리지와 60% 임계값 커버리지를 보입니다. 가장 정확한 설명은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "대부분 뉴런이 활성화되었지만 임계값을 초과한 것은 적음",
          "임계값 커버리지는 뉴런 커버리지와 같아야 함",
          "커버리지 메트릭이 테스팅 실패를 나타냄",
          "높은 임계값 커버리지가 항상 더 좋음"
        ],
        correct: 0,
        expA: "정확합니다! 격차는 많은 뉴런이 활성화되었지만(85%) 더 높은 임계값에 도달한 것은 적음(60%)을 보여줍니다.",
        expB: "이들은 서로 다른 활성화 수준을 측정하는 다른 메트릭입니다.",
        expC: "이들은 실패를 나타내지 않는 합리적인 커버리지 수준입니다.",
        expD: "커버리지 목표는 특정 테스팅 목표에 따라 달라집니다.",
        points: 2,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K3"
      },
      {
        id: 112,
        text: "신경망 테스팅 중 네트워크 견고성을 검증하는 최고의 접근법은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "훈련 데이터로만 테스팅",
          "양성 테스트 케이스만 확인",
          "단일 입력 유형으로 검증",
          "적대적 입력 예시 사용"
        ],
        correct: 3,
        expA: "훈련 데이터는 견고성을 테스트하지 않습니다 - 모델이 학습한 것입니다.",
        expB: "견고성은 엣지 케이스와 부정적 시나리오 테스팅이 필요합니다.",
        expC: "견고성 테스팅은 다양한 입력 유형과 시나리오가 필요합니다.",
        expD: "완벽합니다! 적대적 예시는 네트워크가 도전적이거나 예상치 못한 입력을 얼마나 잘 처리하는지 테스트합니다.",
        points: 2,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K3"
      },
      {
        id: 113,
        text: "신경망의 과적합을 식별하는 데 가장 효과적인 테스팅 전략은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "훈련과 검증 성능 비교",
          "은닉층 수 증가",
          "더 큰 훈련 데이터셋으로 테스트",
          "학습률 매개변수 감소"
        ],
        correct: 0,
        expA: "정확합니다! 과적합은 높은 훈련 성능이지만 낮은 검증 성능으로 나타납니다.",
        expB: "층을 추가하면 과적합을 감지하는 것이 아니라 악화시킬 수 있습니다.",
        expC: "더 큰 데이터셋은 과적합을 방지하는 데 도움이 되지만 감지하지는 않습니다.",
        expD: "학습률은 훈련 속도에 영향을 주지만 과적합 감지에는 영향을 주지 않습니다.",
        points: 2,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K3"
      },
      {
        id: 114,
        text: "팀이 CNN이 회전된 이미지를 잘못 분류한다는 것을 발견했습니다. 이를 해결하는 최고의 테스팅 접근법은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "기하학적 변환을 통한 회전 불변 테스팅 구현",
          "체계적 회전 테스팅 프로토콜과 데이터 증강 배포",
          "회전 기반 섭동으로 적대적 테스팅 적용",
          "표준화된 회전 데이터셋으로 견고성 벤치마크 생성"
        ],
        correct: 0,
        expA: "훌륭합니다! 회전 불변 테스팅은 기하학적 변환을 일관되게 처리하는 모델의 능력을 직접 검증합니다.",
        expB: "데이터 증강은 모델 견고성 향상에 도움이 되지만 기존 문제를 직접 테스트하지는 않습니다.",
        expC: "적대적 테스팅은 가치가 있지만 특정 회전 문제를 체계적으로 다루지 않을 수 있습니다.",
        expD: "벤치마크는 비교에 유용하지만 즉각적인 테스팅 필요를 직접 해결하지는 않습니다.",
        points: 2,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K3"
      },
      {
        id: 115,
        text: "사인 변화 커버리지 테스팅의 필요성을 가장 잘 보여주는 시나리오는 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "기본 뉴런 활성화 확인",
          "결정 경계 민감도 테스팅",
          "전체 네트워크 정확도 측정",
          "훈련 데이터 품질 검증"
        ],
        correct: 1,
        expA: "기본 활성화는 사인 변화가 아닌 뉴런 커버리지로 측정됩니다.",
        expB: "정확합니다! 사인 변화 커버리지는 결정 경계를 교차하는 입력에 대한 네트워크의 민감도를 테스트하는 데 도움이 됩니다.",
        expC: "정확도는 커버리지가 아닌 성능 메트릭으로 측정됩니다.",
        expD: "데이터 품질은 네트워크 커버리지와 별도로 평가됩니다.",
        points: 2,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K3"
      },
      {
        id: 116,
        text: "합성곱 네트워크가 엣지 검출 작업에서 낮은 성능을 보입니다. 가장 적절한 분석 접근법은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "필터 활성화 패턴과 특성 맵 응답 검사",
          "전체 네트워크 깊이를 크게 증가",
          "무작위 가중치 초기화 기법 적용",
          "입력 이미지 해상도를 체계적으로 감소"
        ],
        correct: 0,
        expA: "완벽합니다! 필터 활성화와 특성 맵을 검사하면 네트워크가 엣지와 공간적 특성을 얼마나 잘 감지하는지 알 수 있습니다.",
        expB: "단순히 깊이를 추가하는 것은 특정 엣지 검출 문제를 해결하지 못할 수 있습니다.",
        expC: "무작위 초기화는 기능적 엣지 검출 문제를 해결하지 않습니다.",
        expD: "해상도를 줄이면 엣지 검출 능력이 악화될 가능성이 높습니다.",
        points: 2,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K3"
      },
      {
        id: 117,
        text: "신경망 통합 테스팅 중 검증이 가장 중요한 측면은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "전처리 및 후처리 시스템과의 데이터 파이프라인 통합 검증",
          "다양한 시스템 부하와 리소스 제약 하에서 네트워크 성능 평가",
          "다른 하드웨어 가속 플랫폼 간 인터페이스 호환성 확인",
          "네트워크 추론과 시스템 응답 시간을 포함한 엔드투엔드 지연 분석"
        ],
        correct: 0,
        expA: "정확합니다! 통합 테스팅은 전처리, 추론, 후처리 단계를 통한 완전한 데이터 흐름을 검증해야 합니다.",
        expB: "부하 하에서의 성능은 중요하지만 기능적 통합 검증에 부차적입니다.",
        expC: "하드웨어 호환성은 중요하지만 일반적으로 배포 테스팅 중에 처리됩니다.",
        expD: "지연 분석은 핵심 통합 검증이 아닌 성능 테스팅입니다.",
        points: 3,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K4"
      },
      {
        id: 118,
        text: "신경망에 최고의 테스트 커버리지 평가를 제공하는 접근법은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "도메인별 테스트 통합과 위험 기반 커버리지 프레임워크 구현",
          "상황 인식 메트릭 가중치와 적응형 커버리지 측정 배포",
          "철저함과 효율성 균형의 커버리지 포트폴리오 최적화 설정",
          "자동화된 품질 게이트와 임계값을 가진 커버리지 검증 파이프라인 생성"
        ],
        correct: 0,
        expA: "완벽합니다! 위험 기반 프레임워크는 도메인 지식을 통합하면서 중요한 영역이 적절한 커버리지를 받도록 보장합니다.",
        expB: "적응형 측정은 정교하지만 필요한 체계적 위험 분석이 부족할 수 있습니다.",
        expC: "포트폴리오 최적화는 가치가 있지만 위험별 커버리지 요구를 다루지 않습니다.",
        expD: "자동화 파이프라인은 실행을 돕지만 커버리지 전략 선택을 다루지 않습니다.",
        points: 3,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K4"
      },
      {
        id: 119,
        text: "자율주행차 시스템이 객체 검출에 신경망을 사용합니다. 가장 적절한 테스팅 접근법은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "규제 준수 프레임워크와 체계적 적대적 테스팅 구현",
          "시뮬레이션, 폐쇄 트랙, 단계적 배포를 포함한 다단계 검증 배포",
          "포괄적 실패 모드 분석과 결함 주입 테스팅 설정",
          "실시간 안전 성능 평가와 지속적 모니터링 시스템 생성"
        ],
        correct: 0,
        expA: "훌륭합니다! 안전 중요 자율 시스템은 견고성을 보장하기 위해 규제 프레임워크 내에서 체계적 적대적 테스팅이 필요합니다.",
        expB: "다단계 검증은 철저하지만 적대적 견고성을 포괄적으로 다루지 못할 수 있습니다.",
        expC: "결함 주입은 가치가 있지만 입력 변화에 대한 신경망 견고성을 구체적으로 테스트하지 않습니다.",
        expD: "지속적 모니터링은 프로덕션에 필수적이지만 체계적 배포 전 테스팅을 대체하지 않습니다.",
        points: 3,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K4"
      },
      {
        id: 120,
        text: "금융기관의 신경망이 좋은 성능 메트릭에도 불구하고 규제 설명가능성 요구사항을 통과하지 못합니다. 이 문제를 가장 효과적으로 해결하는 접근법은 무엇입니까? 하나의 옵션을 선택하십시오.",
        options: [
          "내장 설명가능성을 가진 해석 가능한 아키텍처가 성능을 유지하면서 규제 요구사항을 체계적으로 해결함",
          "사후 설명은 도움이 되지만 고유한 모델 투명성에 대한 규제 요구사항을 충족하지 못할 수 있음",
          "단순화된 모델은 설명가능성을 만족시킬 수 있지만 비즈니스 목표에 필요한 성능을 희생할 수 있음",
          "문서화는 가치가 있지만 모델 자체의 근본적인 설명가능성 문제를 해결하지 않음"
        ],
        correct: 0,
        expA: "내장 설명가능성을 가진 해석 가능한 아키텍처가 성능을 유지하면서 규제 요구사항을 체계적으로 해결합니다.",
        expB: "사후 설명은 도움이 되지만 고유한 모델 투명성에 대한 규제 요구사항을 충족하지 못할 수 있습니다.",
        expC: "단순화된 모델은 설명가능성을 만족시킬 수 있지만 비즈니스 목표에 필요한 성능을 희생할 수 있습니다.",
        expD: "문서화는 가치가 있지만 모델 자체의 근본적인 설명가능성 문제를 해결하지 않습니다.",
        points: 3,
        chapter: "ML - 신경망과 테스팅",
        difficulty: "K4"
      },
      {
        id: 121,
        text: "AI 기반 시스템을 테스트할 때 가장 중요한 것은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "코드 복잡성 분석과 성능 최적화",
          "데이터 품질과 알고리즘 편향성",
          "시스템 통합과 사용자 인터페이스",
          "보안 취약점과 네트워크 구성"
        ],
        correct: 2,
        expA: "코드 복잡성은 중요하지만 AI 시스템의 가장 핵심적인 요소는 아닙니다.",
        expB: "데이터 품질과 편향성은 매우 중요하지만, 전체 테스트 관점에서는 부분적인 요소입니다.",
        expC: "정답입니다! AI 시스템은 다른 시스템과 통합되어 사용자와 상호작용하므로 이것이 가장 중요합니다.",
        expD: "보안은 중요하지만 AI 시스템 특성상 가장 우선적인 고려사항은 아닙니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스트 개요",
        difficulty: "K2"
      },
      {
        id: 122,
        text: "AI 시스템의 비결정적 특성이 테스트에 미치는 영향은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "테스트 자동화 도구 선택 어려움",
          "예상 결과 정의의 복잡성 증가",
          "테스트 데이터 생성 비용 상승",
          "테스트 환경 구축 시간 연장"
        ],
        correct: 1,
        expA: "자동화 도구 선택이 어려워질 수 있지만, 이것이 주요 문제는 아닙니다.",
        expB: "맞습니다! 비결정적 특성으로 인해 동일한 입력에도 다른 출력이 나올 수 있어 예상 결과 정의가 어려워집니다.",
        expC: "테스트 데이터 생성 비용은 비결정적 특성과 직접적인 관련이 적습니다.",
        expD: "환경 구축 시간은 비결정적 특성보다는 시스템 복잡성과 더 관련있습니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스트 개요",
        difficulty: "K1"
      },
      {
        id: 123,
        text: "AI 시스템에서 데이터 드리프트 테스트가 필요한 이유는 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "모델 성능 저하 조기 탐지",
          "시스템 보안 강화를 위해",
          "코드 품질 향상을 위해",
          "사용자 경험 개선을 위해"
        ],
        correct: 0,
        expA: "정확합니다! 데이터 드리프트는 훈련 데이터와 실제 운영 데이터 간의 차이로 모델 성능이 저하될 수 있어 조기 탐지가 중요합니다.",
        expB: "데이터 드리프트는 보안보다는 모델 정확성과 관련이 있습니다.",
        expC: "데이터 드리프트는 코드 품질과는 별개의 문제입니다.",
        expD: "사용자 경험 개선의 부차적 효과는 있지만 주목적이 아닙니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스트 개요",
        difficulty: "K3"
      },
      {
        id: 124,
        text: "AI 시스템 테스트에서 편향성 검증이 중요한 이유는 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "시스템 성능 최적화를 위해",
          "공정성과 윤리적 요구사항 충족",
          "테스트 비용 절감을 위해",
          "개발 일정 단축을 위해"
        ],
        correct: 1,
        expA: "성능 최적화도 중요하지만 편향성 검증의 주목적은 아닙니다.",
        expB: "정답입니다! 편향성 검증은 AI 시스템이 특정 그룹에 불공정하게 작동하지 않도록 하여 윤리적 요구사항을 충족시킵니다.",
        expC: "편향성 검증은 비용 절감보다는 품질 보장에 목적이 있습니다.",
        expD: "일정 단축과는 관련이 없으며, 오히려 추가 노력이 필요합니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스트 개요",
        difficulty: "K2"
      },
      {
        id: 125,
        text: "머신러닝 모델의 설명가능성 테스트 목적은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "모델 훈련 시간 단축",
          "의사결정 과정의 투명성 확보",
          "메모리 사용량 최적화",
          "네트워크 대역폭 절약"
        ],
        correct: 1,
        expA: "설명가능성은 훈련 시간과는 관련이 없습니다.",
        expB: "맞습니다! 설명가능성 테스트는 AI 모델이 어떻게 결정을 내리는지 이해할 수 있도록 하여 투명성을 확보합니다.",
        expC: "메모리 사용량 최적화는 설명가능성과 별개의 문제입니다.",
        expD: "네트워크 대역폭은 설명가능성과 관련이 없습니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스트 개요",
        difficulty: "K2"
      },
      {
        id: 126,
        text: "AI 시스템 테스트에서 가장 어려운 점은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "테스트 도구의 복잡성",
          "테스트 팀의 기술 부족",
          "예상 결과 정의의 어려움",
          "테스트 환경 구축 비용"
        ],
        correct: 2,
        expA: "도구의 복잡성은 학습으로 해결 가능한 문제입니다.",
        expB: "기술 부족은 교육과 훈련으로 개선할 수 있습니다.",
        expC: "정확합니다! AI의 비결정적 특성과 복잡한 알고리즘으로 인해 명확한 예상 결과를 정의하기 어렵습니다.",
        expD: "비용 문제는 해결 가능하지만, 본질적인 어려움은 아닙니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스트 개요",
        difficulty: "K1"
      },
      {
        id: 127,
        text: "AI 모델의 강건성 테스트에서 중점적으로 확인해야 할 사항은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "모델 훈련 속도 향상",
          "예상치 못한 입력에 대한 안정성",
          "코드 가독성 개선",
          "데이터베이스 연결 상태"
        ],
        correct: 1,
        expA: "훈련 속도는 강건성과 관련이 없습니다.",
        expB: "정답입니다! 강건성 테스트는 모델이 예상치 못한 입력이나 적대적 공격에도 안정적으로 작동하는지 확인합니다.",
        expC: "코드 가독성은 강건성 테스트의 범위가 아닙니다.",
        expD: "데이터베이스 연결은 인프라 테스트 영역입니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스트 개요",
        difficulty: "K2"
      },
      {
        id: 128,
        text: "AI 시스템의 A/B 테스트를 수행하는 주된 목적은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "시스템 보안성 강화",
          "서로 다른 모델 버전 성능 비교",
          "코드 복잡도 측정",
          "데이터 저장 공간 최적화"
        ],
        correct: 1,
        expA: "A/B 테스트는 보안성 강화와는 다른 목적입니다.",
        expB: "맞습니다! A/B 테스트는 두 개 이상의 모델 버전을 실제 환경에서 비교하여 더 나은 성능을 보이는 모델을 선택하기 위함입니다.",
        expC: "코드 복잡도 측정은 A/B 테스트의 목적이 아닙니다.",
        expD: "저장 공간 최적화는 A/B 테스트와 관련이 없습니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스트 개요",
        difficulty: "K2"
      },
      {
        id: 129,
        text: "AI 시스템에서 메타모픽 테스트의 특징은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "명확한 예상 결과가 필요함",
          "입력 관계를 이용한 검증 방법",
          "단일 테스트 케이스만 사용",
          "수동 테스트만 가능함"
        ],
        correct: 1,
        expA: "메타모픽 테스트는 명확한 예상 결과 없이도 수행할 수 있습니다.",
        expB: "정확합니다! 메타모픽 테스트는 입력 간의 관계를 이용하여 출력도 같은 관계를 만족하는지 검증하는 방법입니다.",
        expC: "메타모픽 테스트는 여러 관련된 테스트 케이스를 사용합니다.",
        expD: "메타모픽 테스트는 자동화가 가능합니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스트 개요",  
        difficulty: "K3"
      },
      {
        id: 130,
        text: "AI 시스템 테스트에서 오라클 문제란 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "데이터베이스 연결 오류",
          "네트워크 통신 장애",
          "메모리 부족 현상",
          "예상 결과 판단의 어려움"
        ],
        correct: 3,
        expA: "데이터베이스 연결 오류는 인프라 문제이지 오라클 문제가 아닙니다.",
        expB: "네트워크 통신 장애는 시스템 문제입니다.",
        expC: "메모리 부족은 리소스 문제입니다.",
        expD: "정답입니다! 오라클 문제는 AI 시스템의 복잡성과 비결정적 특성으로 인해 테스트 결과가 올바른지 판단하기 어려운 문제를 의미합니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스트 개요",
        difficulty: "K3"
      },
      {
        id: 131,
        text: "AI 모델의 적대적 공격 테스트의 목적은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "악의적 입력에 대한 취약점 발견",
          "모델 훈련 시간 측정",
          "데이터 압축 효율성 검증",
          "사용자 인터페이스 개선"
        ],
        correct: 0,
        expA: "정확합니다! 적대적 공격 테스트는 의도적으로 조작된 입력에 대해 모델이 올바르게 작동하는지 확인하여 보안 취약점을 발견합니다.",
        expB: "훈련 시간 측정은 적대적 공격 테스트의 목적이 아닙니다.",
        expC: "데이터 압축은 적대적 공격과 관련이 없습니다.",
        expD: "사용자 인터페이스는 별개의 테스트 영역입니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스트 개요",
        difficulty: "K3"
      },
      {
        id: 132,
        text: "AI 시스템에서 지속적 학습 모델의 테스트 시 고려사항은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "초기 배포 후 테스트 종료",
          "정적 테스트 케이스만 사용",
          "모델 성능의 지속적 모니터링",
          "수동 테스트로만 진행"
        ],
        correct: 2,
        expA: "지속적 학습 모델은 배포 후에도 계속 학습하므로 지속적인 테스트가 필요합니다.",
        expB: "정적 테스트 케이스로는 변화하는 모델을 충분히 검증할 수 없습니다.",
        expC: "정답입니다! 지속적 학습 모델은 새로운 데이터로 계속 학습하므로 성능 변화를 지속적으로 모니터링해야 합니다.",
        expD: "자동화된 모니터링이 필수적입니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스트 개요",
        difficulty: "K2"
      },
      {
        id: 133,
        text: "AI 시스템의 페어와이즈 테스트 기법의 장점은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "모든 조합을 완전히 테스트",
          "효율적인 테스트 케이스 축소",
          "단일 매개변수만 테스트",
          "수동 테스트만 지원"
        ],
        correct: 1,
        expA: "페어와이즈 테스트는 모든 조합이 아닌 효율적인 부분집합을 테스트합니다.",
        expB: "맞습니다! 페어와이즈 테스트는 모든 매개변수 쌍의 조합을 커버하면서도 전체 테스트 케이스 수를 크게 줄일 수 있습니다.",
        expC: "페어와이즈 테스트는 여러 매개변수의 쌍을 테스트합니다.",
        expD: "자동화된 도구로 지원 가능합니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스트 개요",
        difficulty: "K3"
      },
      {
        id: 134,
        text: "AI 시스템에서 백투백 테스트의 활용 목적은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "서로 다른 구현체 결과 비교",
          "데이터베이스 성능 측정",
          "네트워크 대역폭 테스트",
          "사용자 인터페이스 검증"
        ],
        correct: 0,
        expA: "정확합니다! 백투백 테스트는 같은 기능을 수행하는 서로 다른 AI 모델이나 구현체의 결과를 비교하여 검증합니다.",
        expB: "데이터베이스 성능 측정은 백투백 테스트의 목적이 아닙니다.",
        expC: "네트워크 대역폭은 별개의 테스트 영역입니다.",
        expD: "사용자 인터페이스 검증은 다른 테스트 기법을 사용합니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스트 개요",
        difficulty: "K2"
      },
      {
        id: 135,
        text: "대규모 AI 시스템 구축 프로젝트에서 테스트 전략 수립 시 가장 먼저 고려해야 할 요소는 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "테스트 도구 선정과 라이선스 비용",
          "비즈니스 요구사항과 위험도 분석",
          "개발팀 규모와 기술 수준",
          "하드웨어 사양과 클라우드 환경"
        ],
        correct: 1,
        expA: "도구 선정은 중요하지만, 전략 수립의 첫 번째 단계는 아닙니다.",
        expB: "정답입니다! 테스트 전략은 비즈니스 목표와 시스템의 위험도를 분석하여 우선순위를 정하는 것부터 시작해야 합니다.",
        expC: "팀 역량은 중요하지만 요구사항 분석 이후에 고려할 사항입니다.",
        expD: "인프라는 전략이 수립된 후 구체적인 실행 계획에서 고려할 요소입니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스트 개요",
        difficulty: "K4"
      },
      {
        id: 136,
        text: "의료용 AI 진단 시스템의 테스트 전략에서 가장 중요하게 고려해야 할 요소는 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "시스템 처리 속도 최적화",
          "사용자 인터페이스 직관성",
          "진단 정확도와 안전성 검증", 
          "데이터 저장 용량 관리"
        ],
        correct: 2,
        expA: "처리 속도도 중요하지만 의료 분야에서는 정확도와 안전성이 최우선입니다.",
        expB: "직관적인 UI는 중요하지만 생명과 직결된 정확도보다 우선순위가 낮습니다.",
        expC: "정답입니다! 의료용 AI는 환자의 생명과 직결되므로 진단의 정확도와 안전성이 가장 중요한 검증 요소입니다.",
        expD: "저장 용량은 기술적 고려사항일 뿐 핵심 요소가 아닙니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스트 개요",
        difficulty: "K4"
      },
      {
        id: 137,
        text: "자율주행 자동차의 AI 시스템 테스트에서 우선적으로 검증해야 할 시나리오는 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "음성 인식 시스템 정확도",
          "내비게이션 경로 최적화",
          "엔터테인먼트 시스템 안정성",
          "긴급상황 대응과 안전 제어"
        ],
        correct: 3,
        expA: "음성 인식은 편의 기능이므로 안전 기능보다 우선순위가 낮습니다.",
        expB: "경로 최적화는 중요하지만 생명 안전보다는 덜 중요합니다.",
        expC: "엔터테인먼트는 핵심 안전 기능이 아닙니다.",
        expD: "정확합니다! 자율주행에서는 사고 방지와 긴급상황 대응이 승객의 생명과 직결되므로 최우선으로 검증해야 합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스트 개요",
        difficulty: "K4"
      },
      {
        id: 138,
        text: "금융 서비스 AI 시스템에서 편향성 테스트가 특히 중요한 이유는 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "규제 준수와 공정한 서비스 제공",
          "시스템 성능 향상을 위해",
          "개발 비용 절감 효과",
          "마케팅 효과 극대화"
        ],
        correct: 0,
        expA: "맞습니다! 금융 서비스는 엄격한 규제를 받으며, 특정 집단에 대한 차별 없이 공정한 서비스를 제공해야 합니다.",
        expB: "성능 향상은 부차적 효과이지 편향성 테스트의 주목적이 아닙니다.",
        expC: "편향성 테스트는 비용 절감보다는 윤리적 의무와 관련있습니다.",
        expD: "마케팅 효과는 편향성 테스트의 목적이 아닙니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스트 개요", 
        difficulty: "K4"
      },
      {
        id: 139,
        text: "실시간 추천 시스템의 성능 테스트에서 중점적으로 확인해야 할 지표는 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "응답 시간과 추천 정확도의 균형",
          "데이터베이스 연결 안정성",
          "서버 하드웨어 사양",
          "네트워크 보안 설정"
        ],
        correct: 0,
        expA: "정확합니다! 실시간 추천 시스템은 빠른 응답과 정확한 추천 모두가 중요하므로 이 두 요소의 최적 균형점을 찾아야 합니다.",
        expB: "데이터베이스 안정성은 기본 인프라 요소일 뿐입니다.",
        expC: "하드웨어 사양은 성능에 영향을 주지만 핵심 지표는 아닙니다.",
        expD: "보안 설정은 별도의 보안 테스트 영역입니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스트 개요",
        difficulty: "K4"
      },
      {
        id: 140,
        text: "AI 기반 시스템의 인수 테스트에서 가장 중요한 검증 내용은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "코드 품질과 문서화 수준",
          "비즈니스 요구사항과 사용자 만족도",
          "시스템 테스트 대체 여부",
          "훈련 데이터 품질 재검증"
        ],
        correct: 1,
        expA: "코드 품질은 개발 단계에서 확인할 사항입니다.",
        expB: "정답입니다! 인수 테스트는 AI 시스템이 비즈니스 목표를 달성하고 사용자의 기대를 충족하는지 검증합니다.",
        expC: "인수 테스트는 시스템 테스트를 대체하는 것이 아니라 보완합니다.",
        expD: "훈련 데이터 품질은 훨씬 이전 단계에서 검증해야 할 사항입니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스트 개요",
        difficulty: "K3"
      },
      {
        id: 141,
        text: "자기 학습 시스템 테스트에서 가장 어려운 점은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "정적 머신러닝 모델 매개변수",
          "지속적 학습으로 인한 진화하는 시스템 동작",
          "제한된 훈련 데이터 다양성과 볼륨",
          "표준 신경망 아키텍처 제약사항"
        ],
        correct: 1,
        expA: "정적 매개변수는 실제로 테스트를 더 쉽고 예측 가능하게 만듭니다.",
        expB: "정답입니다! 자기 학습 시스템은 새로운 데이터를 기반으로 지속적으로 동작을 수정하여 기존 테스트 접근법으로는 부족합니다.",
        expC: "데이터 제한은 중요하지만, 핵심 과제는 변화하는 동작이지 단순한 데이터 제약이 아닙니다.",
        expD: "아키텍처 제약은 설계 결정사항이지 자기 학습 시스템의 주요 테스트 과제가 아닙니다.",
        points: 1,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K2"
      },
      {
        id: 142,
        text: "알고리즘 편향에 대한 다음 설명 중 올바른 것은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "결정에서 체계적 불공정성을 야기함",
          "무작위 알고리즘 오류를 생성함",
          "처리 속도에 영향을 미침",
          "메모리 할당에 영향을 줌"
        ],
        correct: 0,
        expA: "완벽합니다! 알고리즘 편향은 AI 결정에서 체계적인 차별이나 불공정성을 의미하며, 종종 과거 데이터 패턴을 반영합니다.",
        expB: "무작위 오류는 버그이지 편향이 아닙니다 - 편향은 체계적이고 예측 가능한 불공정성입니다.",
        expC: "속도 변화는 성능 문제이지 의사결정에서의 편향이 아닙니다.",
        expD: "메모리 문제는 기술적 문제이지 편향 관련 우려사항이 아닙니다.",
        points: 1,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K1"
      },
      {
        id: 143,
        text: "자율 AI 시스템 테스트에 가장 적합한 접근법은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "사전 정의된 테스트 스크립트",
          "수동 운영 감독",
          "엣지 케이스가 포함된 시뮬레이션",
          "축소된 테스트 커버리지"
        ],
        correct: 2,
        expA: "자율 시스템은 사전 정의된 스크립트뿐만 아니라 적응적 테스트가 필요합니다.",
        expB: "운영 중 수동 감독은 테스트가 아니라 모니터링입니다.",
        expC: "맞습니다! 시뮬레이션 환경은 자율 시스템에 대한 엣지 케이스와 예상치 못한 시나리오의 안전한 테스트를 가능하게 합니다.",
        expD: "자율 시스템은 실제로 축소된 커버리지가 아닌 더 포괄적인 테스트가 필요합니다.",
        points: 2,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K3"
      },
      {
        id: 144,
        text: "ML 훈련 데이터의 샘플 편향을 가장 잘 설명하는 것은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "체계적 데이터 수집 방법론이 편향된 샘플 생산",
          "모델 일반화에 부족한 훈련 데이터셋 크기",
          "모델 성능에 영향을 주는 비대표적 데이터 분포",
          "모델 아티팩트를 생성하는 데이터 전처리 불일치"
        ],
        correct: 2,
        expA: "방법론 문제는 편향에 기여할 수 있지만, 샘플 편향은 구체적으로 비대표적 분포를 의미합니다.",
        expB: "데이터셋 크기는 분산과 관련이 있지 편향과는 다릅니다 - 대표적인 소형 데이터셋과 편향된 대형 데이터셋이 있을 수 있습니다.",
        expC: "정확합니다! 샘플 편향은 훈련 데이터가 시스템이 프로덕션에서 만날 실제 인구를 대표하지 않을 때 발생합니다.",
        expD: "전처리 불일치는 기술적 아티팩트를 생성하지만 샘플 편향을 정의하는 대표성 문제는 아닙니다.",
        points: 1,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K2"
      },
      {
        id: 145,
        text: "확률적 AI 시스템 테스트에서 가장 어려운 점은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "결정론적 출력 패턴",
          "동일한 입력에 대한 가변적 출력",
          "일관된 성능 지표",
          "예측 가능한 오류율"
        ],
        correct: 1,
        expA: "결정론적 패턴은 실제로 테스트를 더 쉽게 만들지 더 어렵게 하지 않습니다.",
        expB: "절대적으로 맞습니다! 동일한 입력이 다른 출력을 생산할 때 예상 결과를 정의하고 정확성을 검증하기 어렵습니다.",
        expC: "일관된 지표는 테스트에 도움이 되며 도전을 만들지 않습니다.",
        expD: "예측 가능한 오류율은 테스트를 더 관리하기 쉽게 만들지 어렵게 하지 않습니다.",
        points: 2,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K3"
      },
      {
        id: 146,
        text: "AI 테스트에서 설명가능성에 대한 다음 설명 중 올바른 것은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "시스템 성능을 문서화함",
          "AI 결정 추론을 설명함",
          "코드 가독성을 향상시킴",
          "사용자 인터페이스를 명확히 함"
        ],
        correct: 1,
        expA: "성능 문서는 중요하지만 결정 추론을 설명하지는 않습니다.",
        expB: "완벽합니다! 설명가능성은 AI 시스템이 특정 결정을 내린 이유를 이해하고 해석할 수 있음을 의미합니다.",
        expC: "코드 가독성은 소스 코드에 관한 것이지 AI 결정 설명이 아닙니다.",
        expD: "UI 명확성은 사용자에게 도움이 되지만 AI의 추론 과정을 설명하지는 않습니다.",
        points: 1,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K1"
      },
      {
        id: 147,
        text: "모델 설명가능성 테스트에 가장 일반적으로 사용되는 도구는 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "SHAP 특성 중요도 분석 프레임워크",
          "LIME 지역적 설명을 위한 해석 방법",
          "통합 그래디언트 기여도 분석 방법",
          "순열 특성 중요도 테스트 접근법"
        ],
        correct: 1,
        expA: "SHAP는 전역 특성 중요도를 제공하지만 LIME이 지역적 설명가능성 테스트에 더 일반적으로 사용됩니다.",
        expB: "정답입니다! LIME(지역적 해석 가능한 모델 독립적 설명)은 테스트 중 개별 AI 예측을 이해하는 데 가장 일반적으로 사용되는 방법입니다.",
        expC: "통합 그래디언트는 신경망에 유용하지만 일반적인 설명가능성 테스트에서는 LIME보다 덜 사용됩니다.",
        expD: "순열 중요도는 특성 분석에 유용하지만 LIME이 설명가능성 테스트에 더 표준적입니다.",
        points: 1,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K2"
      },
      {
        id: 148,
        text: "복잡한 AI 시스템에서 테스트 과제를 가장 많이 만드는 특성은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "단순한 선형 처리",
          "다중 상호작용 구성요소",
          "단일 스레드 실행",
          "정적 구성 설정"
        ],
        correct: 1,
        expA: "단순한 선형 처리는 실제로 테스트를 더 쉽게 만듭니다.",
        expB: "정확합니다! 다중 상호작용 구성요소는 예측하고 테스트하기 어려운 복잡한 종속성과 창발적 동작을 만듭니다.",
        expC: "단일 스레드 실행은 복잡한 AI 시스템보다 테스트하기 더 간단합니다.",
        expD: "정적 설정은 시스템을 더 예측 가능하게 만들지 테스트하기 더 복잡하게 하지 않습니다.",
        points: 2,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K3"
      },
      {
        id: 149,
        text: "AI 시스템의 부적절한 편향을 가장 잘 특성화하는 것은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "공정성과 윤리 원칙을 위반하는 알고리즘 편향",
          "결정 투명성에 영향하는 모델 해석가능성 제한",
          "사용자 이해를 방해하는 시스템 설명가능성 격차",
          "일관된 결과에 영향하는 성능 신뢰성 문제"
        ],
        correct: 0,
        expA: "맞습니다! 부적절한 편향은 윤리적 원칙이나 공정성에 대한 법적 요구사항을 위반하는 불공정한 차별을 의미합니다.",
        expB: "해석가능성 제한은 투명성 문제이지 공정성에 영향하는 편향 문제가 아닙니다.",
        expC: "설명가능성 격차는 이해에 영향하지만 차별적 편향을 구성하지는 않습니다.",
        expD: "성능 신뢰성은 일관성에 영향하지만 공정성이나 차별적 편향과는 관련이 없습니다.",
        points: 1,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K2"
      },
      {
        id: 150,
        text: "AI 시스템의 테스트 오라클 문제를 가장 잘 설명하는 것은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "검증 비교를 위한 부족한 참조 데이터",
          "복잡한 테스트 환경 설정과 유지보수",
          "AI 출력에 대한 예상 결과 결정의 어려움",
          "충돌하는 결과를 생산하는 다중 테스트 접근법"
        ],
        correct: 2,
        expA: "참조 데이터 양은 중요하지만 근본적인 오라클 도전을 다루지 않습니다.",
        expB: "환경 복잡성은 테스트 설정에 영향하지만 핵심 오라클 문제가 아닙니다.",
        expC: "완벽합니다! 테스트 오라클 문제는 특히 비결정적 동작에 대해 AI 시스템의 올바른 출력이 무엇인지 결정하는 어려움에 관한 것입니다.",
        expD: "충돌하는 결과는 오라클 문제를 나타낼 수 있지만 예상 결과를 아는 근본적 문제가 아닙니다.",
        points: 2,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K3"
      },
      {
        id: 151,
        text: "AI 시스템의 투명성 테스트를 가장 잘 설명하는 것은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "코드 실행 속도 최적화",
          "내부 결정 과정 이해",
          "사용자 인터페이스 색상 설계",
          "데이터베이스 테이블 구조화"
        ],
        correct: 1,
        expA: "속도 최적화는 성능에 관한 것이지 의사결정의 투명성이 아닙니다.",
        expB: "정확합니다! 투명성은 AI 시스템이 내부 결정을 어떻게 내리는지 보고 이해할 수 있음을 의미합니다.",
        expC: "UI 색상은 시각적 설계이지 AI 결정 투명성이 아닙니다.",
        expD: "데이터베이스 구조는 데이터 관리이지 AI 투명성과는 관련이 없습니다.",
        points: 1,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K2"
      },
      {
        id: 152,
        text: "AI 시스템에서 샘플 편향에 대한 테스트 시 가장 중요하게 검증할 사항은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "훈련 데이터셋의 크기",
          "모든 사용자 그룹에 대한 데이터 대표성",
          "다양한 데이터 유형의 처리 속도",
          "데이터 저장 형식 사양"
        ],
        correct: 1,
        expA: "크기는 모델 품질에 중요하지만, 샘플 편향은 구체적으로 그룹 간 대표성과 관련있습니다.",
        expB: "정확합니다! 샘플 편향은 훈련 데이터가 모든 사용자 그룹을 동등하게 대표하지 않아 불공정한 대우를 초래할 때 발생합니다.",
        expC: "처리 속도는 기술적 성능 측면이지 데이터 대표성 품질과는 관련이 없습니다.",
        expD: "저장 형식은 기술적 구현 세부사항이지 샘플 편향 탐지와는 관련이 없습니다.",
        points: 1,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K2"
      },
      {
        id: 153,
        text: "안전 중심 애플리케이션용 AI 시스템 개발 시 가장 적합한 테스트 접근법은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "빠른 개발 사이클과 최소한의 문서화",
          "포괄적인 위험 평가와 엄격한 검증 프로세스",
          "표준 소프트웨어 테스트 방법론만 사용",
          "주로 자동화된 테스트 도구에 의존"
        ],
        correct: 1,
        expA: "안전 중심 시스템은 빠른 개발보다 철저한 검증이 우선되어야 합니다.",
        expB: "정답입니다! 안전 중심 애플리케이션은 잠재적 위험을 철저히 평가하고 엄격한 검증으로 안전성을 보장해야 합니다.",
        expC: "표준 방법론만으로는 AI 시스템의 고유한 안전 과제를 다루기에 부족합니다.",
        expD: "자동화 도구는 유용하지만 안전 중심 시스템은 광범위한 수동 검토와 검증도 필요합니다.",
        points: 3,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K4"  
      },
      {
        id: 154,
        text: "규제된 환경에서 자율 AI 시스템 배포 시 우선적으로 고려해야 할 테스트 측면은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "기본 기능 테스트만 완료",
          "격리된 환경에서만 테스트",
          "사용자 인터페이스 테스트에 집중",
          "다른 시스템과의 포괄적 통합 테스트"
        ],
        correct: 3,
        expA: "기본 기능 테스트만으로는 규제된 환경의 자율 시스템에 대해 충분하지 않습니다.",
        expB: "격리된 테스트는 자율 시스템이 다른 프로덕션 시스템과 어떻게 상호작용할지 드러내지 못합니다.",
        expC: "UI 테스트는 중요하지만 자율 시스템에는 통합 테스트가 더 중요합니다.",
        expD: "맞습니다! 자율 시스템은 다른 시스템과 독립적으로 작동하므로 프로덕션 환경에서 안전한 상호작용을 위해 포괄적인 통합 테스트가 중요합니다.",
        points: 2,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K3"
      },
      {
        id: 155,
        text: "의료 진단 AI 시스템에서 투명성 테스트의 주요 목적은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "시스템 처리 속도 향상",
          "데이터베이스 쿼리 최적화",
          "네트워크 대역폭 효율성 개선",
          "의료 전문가의 결정 검증 지원"
        ],
        correct: 3,
        expA: "처리 속도는 성능 문제이지 의료 맥락에서 투명성의 주요 목적이 아닙니다.",
        expB: "데이터베이스 최적화는 기술적 고려사항이지 투명성 테스트의 목적이 아닙니다.",
        expC: "네트워크 효율성은 인프라 최적화이지 투명성과는 관련이 없습니다.",
        expD: "정확합니다! 의료 환경에서 투명성은 의료 전문가가 AI 권장사항을 검증하고 환자 치료에 대한 정보에 입각한 결정을 내리는 데 중요합니다.",
        points: 2,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K3"
      },
      {
        id: 156,
        text: "은행이 신용 결정용 AI 시스템을 테스트할 때 가장 중요하게 주의해야 할 측면은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "모든 인구통계학적 그룹에 대한 공정성 테스트",
          "처리 속도 최적화",
          "통합 복잡성 최소화",
          "컴퓨팅 자원 최적화"
        ],
        correct: 0,
        expA: "정답입니다! 금융 의사결정에서 공정성과 차별 부재는 법적 준수와 윤리적 책임을 위한 중요한 요구사항입니다.",
        expB: "속도는 사용자 경험에 중요하지만 규제된 금융 결정에서 공정성보다 부차적입니다.",
        expC: "통합 복잡성은 기술적 우려사항이지만 주요 윤리적, 법적 요구사항을 다루지 않습니다.",
        expD: "자원 최적화는 운영 효율성이지 신용 결정 공정성의 주요 우려사항이 아닙니다.",
        points: 3,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K4"
      },
      {
        id: 157,
        text: "자기 적응 AI 시스템의 테스트 과제를 가장 잘 해결하는 접근법은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "고정된 테스트 케이스 실행",
          "적응적 테스트 전략을 통한 지속적 모니터링",
          "단일 단계 테스트 완료",
          "정적 성능 벤치마킹"
        ],
        correct: 1,
        expA: "고정된 테스트 케이스는 자기 적응 시스템이 동작을 변경함에 따라 구식이 됩니다.",
        expB: "정확합니다! 자기 적응 시스템은 시스템의 학습과 함께 진화하는 지속적인 모니터링과 테스트 전략이 필요합니다.",
        expC: "단일 단계 테스트는 지속적으로 학습하고 적응하는 시스템에는 부적절합니다.",
        expD: "정적 벤치마킹은 동적 적응 시스템의 변화하는 특성을 포착하지 못합니다.",
        points: 1,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K2"
      },
      {
        id: 158,
        text: "금융 서비스 AI에서 편향 테스트 전략 개발 시 주요 고려사항은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "규제 준수와 모든 보호된 특성에 대한 공정성",
          "주로 기술적 성능 지표에 집중",
          "빠른 배포를 위한 테스트 최소화",
          "단일 인구통계학적 그룹만 고려"
        ],
        correct: 0,
        expA: "정답입니다! 금융 서비스는 엄격하게 규제되며 연령, 성별, 인종 등 보호된 특성에 대한 공정성과 법적 준수가 필수입니다.",
        expB: "기술적 지표는 중요하지만 금융 AI에서는 공정성과 규제 준수가 우선되어야 합니다.",
        expC: "금융 규제 환경에서 편향 테스트를 최소화하는 것은 부적절하고 위험합니다.",
        expD: "포괄적인 편향 테스트는 모든 관련 인구통계학적 그룹을 고려해야 합니다.",
        points: 3,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K4"
      },
      {
        id: 159,
        text: "실시간 추천 시스템에서 확률적 동작 테스트를 위한 최적 접근법은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "고정된 예상 결과 사용",
          "정확한 결과 일치보다 통계적 검증 방법",
          "단일 테스트 실행으로 결정",
          "결정론적 기준만 적용"
        ],
        correct: 1,
        expA: "고정된 예상 결과는 확률적 시스템의 변동성을 수용하지 않습니다.",
        expB: "정확합니다! 확률적 시스템은 정확한 결과 일치가 아닌 오라클 검증을 위한 통계적 검증 방법이 필요합니다.",
        expC: "단일 실행은 확률적 시스템의 변동성과 성능 범위를 포착하기에 불충분합니다.",
        expD: "결정론적 기준은 확률적 시스템에 너무 단순하며 통계적 분포 평가가 필요합니다.",
        points: 3,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K4"
      },
      {
        id: 160,
        text: "복잡한 AI 시스템에서 창발적 동작 테스트를 위한 가장 효과적인 전략은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "개별 구성요소만 테스트",
          "단순화된 테스트 시나리오만 사용",
          "다양한 상호작용 패턴으로 시스템 수준 테스트",
          "예측 가능한 입력만으로 테스트"
        ],
        correct: 2,
        expA: "개별 구성요소 테스트는 여러 구성요소의 상호작용에서 나타나는 창발적 동작을 놓칩니다.",
        expB: "단순화된 시나리오는 복잡한 상호작용에서 발생하는 예상치 못한 동작을 드러내지 못합니다.",
        expC: "정확합니다! 창발적 동작은 구성요소 상호작용에서 발생하므로 다양한 상호작용 패턴을 가진 시스템 수준 테스트가 필요합니다.",
        expD: "예측 가능한 입력은 창발적 동작을 유발할 수 있는 예상치 못한 상황을 테스트하지 않습니다.",
        points: 3,
        chapter: "AI 특정 품질 특성 테스트",
        difficulty: "K4"
      },
      {
        id: 161,
        text: "적대적 예제에 대한 다음 설명 중 올바른 것은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "양성 입력 변형을 나타냄",
          "잘못된 예측을 유발하는 교란된 입력",
          "모델 강건성 테스트를 개선함",
          "정상 시스템 동작을 검증함"
        ],
        correct: 1,
        expA: "적대적 예제는 악의적이지 양성이 아닙니다 - 모델을 속이기 위해 특별히 제작됩니다.",
        expB: "정확합니다! 적대적 예제는 AI 시스템에서 잘못된 예측을 유발하도록 의도적으로 교란된 입력입니다.",
        expC: "강건성 테스트에 사용될 수 있지만, 적대적 예제는 공격이지 테스트 개선이 아닙니다.",
        expD: "적대적 예제는 정상 시스템 검증이 아닌 비정상적인 공격 시나리오를 테스트합니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",
        difficulty: "K1"
      },
      {
        id: 162,
        text: "데이터 독성에 대한 다음 설명 중 올바른 것은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "모델 검증 단계에만 영향을 미침",
          "훈련 데이터 신뢰성을 향상시킴",
          "훈련 중 모델 무결성을 손상시킬 수 있음",
          "데이터 전처리 효율성을 향상시킴"
        ],
        correct: 2,
        expA: "데이터 독성은 주로 훈련 단계에 영향을 미치지만 효과는 배포까지 지속됩니다.",
        expB: "데이터 독성은 의도적으로 데이터 신뢰성을 손상시키며 향상시키지 않습니다.",
        expC: "완벽합니다! 데이터 독성은 훈련 중 모델 무결성을 손상시키기 위해 악성 데이터를 주입하는 것입니다.",
        expD: "데이터 독성은 전처리 효율성 개선이 아닌 보안 공격에 관한 것입니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",
        difficulty: "K1"
      },
      {
        id: 163,
        text: "페어와이즈 테스트에 대한 다음 설명 중 올바른 것은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "모든 가능한 입력 조합을 테스트함",
          "매개변수 쌍 테스트에 중점을 둠",
          "신경망에서만 작동함",
          "기능 테스트를 완전히 대체함"
        ],
        correct: 1,
        expA: "페어와이즈 테스트는 모든 가능한 조합이 아닌 매개변수 쌍을 테스트하여 조합을 줄입니다.",
        expB: "맞습니다! 페어와이즈 테스트는 모든 입력 매개변수 쌍이 최소 한 번씩 함께 테스트되도록 보장합니다.",
        expC: "페어와이즈 테스트는 신경망뿐만 아니라 다양한 AI 시스템에 적용할 수 있습니다.",
        expD: "페어와이즈 테스트는 기능 테스트를 대체하는 것이 아니라 보완하는 기법입니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",
        difficulty: "K2"
      },
      {
        id: 164,
        text: "백투백 테스트에 대한 다음 설명 중 올바른 것은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "동일한 모델의 다른 버전 결과를 비교함",
          "상호 검증을 위해 병렬 독립 구현을 사용함",
          "다른 알고리즘의 성능 측정에만 집중함",
          "완전히 동일한 데이터셋에서만 모델을 확인함"
        ],
        correct: 1,
        expA: "버전 비교는 회귀 테스트이지 고전적인 백투백 테스트가 아닙니다.",
        expB: "정확합니다! 백투백 테스트는 동일한 기능의 독립적인 구현을 사용하여 불일치와 오류를 발견합니다.",
        expC: "성능은 한 측면일 뿐입니다. 백투백 테스트는 정확성과 결과의 일관성도 확인합니다.",
        expD: "효과적인 백투백 테스트는 동작 차이를 드러내기 위해 다양한 데이터셋이 필요합니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",
        difficulty: "K2"
      },
      {
        id: 165,
        text: "AI 시스템 맥락에서 A/B 테스트의 특징은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "실제 사용자에 대해 두 모델 버전을 비교함",
          "부하에 따라 알고리즘 간 자동 전환함",
          "훈련 및 검증 데이터에서 모델을 번갈아 테스트함",
          "두 다른 컴퓨팅 환경에서 알고리즘 성능을 측정함"
        ],
        correct: 0,
        expA: "정답입니다! A/B 테스트는 비즈니스 지표를 평가하기 위해 실제 사용자에 대해 다른 AI 시스템 버전의 동작을 비교합니다.",
        expB: "적응형 부하 분산은 성능 기법이지 비교 테스트 방법론이 아닙니다.",
        expC: "훈련/검증 분할은 A/B 테스트에 특화되지 않은 표준 ML 관행입니다.",
        expD: "환경 테스트는 사용자 경험과 비즈니스 결과가 아닌 인프라 검증입니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",
        difficulty: "K2"
      },
      {
        id: 166, 
        text: "AI 시스템에 대한 경험 기반 테스트의 주요 가치는 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "알려진 위험과 실패 패턴이 있는 영역의 문제 식별",
          "포괄적인 테스트 데이터셋을 자동으로 생성함",
          "구조화된 테스트 기법의 필요성을 대체함",
          "모든 가능한 사용 시나리오의 완전한 커버리지를 보장함"
        ],
        correct: 0,
        expA: "맞습니다! 숙련된 테스터는 AI 시스템의 일반적인 약점에 대한 지식을 바탕으로 문제 영역을 예측할 수 있습니다.",
        expB: "자동 테스트 생성은 별도의 기법입니다. 경험 기반 테스트는 인간의 전문성에 의존합니다.",
        expC: "경험적 테스트는 체계적인 테스트 접근법을 대체하는 것이 아니라 보완합니다.",
        expD: "어떤 테스트 기법도 모든 가능한 시나리오의 완전한 커버리지를 보장할 수 없습니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",
        difficulty: "K2"
      },
      {
        id: 167,
        text: "메타모픽 테스트를 전통적인 접근법과 구별하는 것은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "명확한 예상 결과 없이 입력 관계를 활용함",
          "테스트 실행 속도를 크게 향상시킴",
          "완전 자동화된 테스트 생성을 가능하게 함",
          "모든 가능한 입력 조합의 완전한 커버리지를 제공함"
        ],
        correct: 0,
        expA: "정확합니다! 메타모픽 테스트는 명확한 오라클 없이도 입력 간의 관계를 사용하여 출력이 동일한 관계를 만족하는지 검증합니다.",
        expB: "실행 속도는 메타모픽 테스트의 주요 장점이 아닙니다. 오라클 문제 해결이 핵심입니다.",
        expC: "메타모픽 테스트는 자동화를 가능하게 하지만 주요 이점은 오라클 문제 해결입니다.",
        expD: "메타모픽 테스트는 완전한 커버리지보다는 오라클 문제를 해결하는 데 중점을 둡니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",
        difficulty: "K2"
      },
      {
        id: 168,
        text: "AI 테스트에서 적대적 테스트의 주요 목적은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "시스템 성능을 최적화함",
          "의도적으로 조작된 입력에 대한 강건성을 평가함",
          "훈련 데이터 품질을 향상시킴",
          "정상 운영 조건에서 기능을 검증함"
        ],
        correct: 1,
        expA: "성능 최적화는 적대적 테스트의 주요 목적이 아닙니다.",
        expB: "정답입니다! 적대적 테스트는 악의적으로 조작된 입력에 대해 AI 시스템이 얼마나 견고한지 평가합니다.",
        expC: "훈련 데이터 품질은 별도의 관심사이며 적대적 테스트의 초점이 아닙니다.",
        expD: "적대적 테스트는 정상 운영이 아닌 공격 시나리오에 중점을 둡니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",
        difficulty: "K2"
      },
      {
        id: 169,
        text: "AI 시스템에 대한 테스트 기법 선택 시 무엇이 가장 중요합니까? 하나의 옵션을 선택하세요.",
        options: [
          "가장 최신 기법만 사용함",
          "시스템 특성과 위험에 따른 기법 선택",
          "모든 사용 가능한 기법을 동시에 적용함",
          "가장 빠른 실행 기법만 사용함"
        ],
        correct: 1,
        expA: "최신 기법이 모든 AI 시스템에 적합하거나 필요한 것은 아닙니다.",
        expB: "맞습니다! 테스트 기법 선택은 특정 AI 시스템의 특성, 위험 및 제약 조건을 기반으로 해야 합니다.",
        expC: "모든 기법을 사용하는 것은 비효율적이며 특정 시스템 요구사항을 다루지 못할 수 있습니다.",
        expD: "실행 속도만으로는 AI 시스템의 품질과 안전성 요구사항을 다룰 수 없습니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",
        difficulty: "K2"
      },
      {
        id: 170,
        text: "이미지 분류 AI 시스템에 메타모픽 테스트를 적용할 때 가장 적합한 접근법은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "모든 테스트 케이스에 대해 정확한 예상 결과 정의",
          "이미지 변환에 대한 불변성 속성 검증",
          "훈련 데이터셋에서만 테스트 수행",
          "단일 이미지로만 모든 테스트 제한"
        ],
        correct: 1,
        expA: "메타모픽 테스트의 핵심은 정확한 예상 결과 없이도 테스트할 수 있다는 것입니다.",
        expB: "정확합니다! 이미지를 회전, 크기 조정 또는 밝기 변경해도 분류가 동일하게 유지되어야 한다는 속성을 검증할 수 있습니다.",
        expC: "메타모픽 테스트는 훈련 데이터셋을 넘어 새로운 입력에서 속성을 검증해야 합니다.",
        expD: "효과적인 메타모픽 테스트는 속성이 광범위한 입력에서 유지되는지 확인하기 위해 다양한 이미지가 필요합니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",
        difficulty: "K3"
      },
      {
        id: 171,
        text: "AI 시스템에 페어와이즈 테스트를 적용할 때 가장 합리적인 전략은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "완전한 커버리지를 위해 모든 가능한 매개변수 조합을 테스트",
          "잠재적 위험이 가장 큰 매개변수 쌍에 집중",
          "자동으로 생성된 매개변수 조합만 사용",
          "계산 효율성이 가장 높은 쌍으로만 제한"
        ],
        correct: 1,
        expA: "복잡한 AI 시스템의 경우 지수적 증가로 인해 완전한 조합 테스트는 실질적으로 불가능합니다.",
        expB: "맞습니다! 위험한 매개변수 쌍에 집중하면 제한된 자원으로 중요한 결함을 발견할 확률을 최대화할 수 있습니다.",
        expC: "위험을 고려하지 않은 자동 생성은 중요한 문제 조합을 놓칠 수 있습니다.",
        expD: "계산 효율성은 중요하지만 테스트 조합 선택의 유일한 기준이어서는 안 됩니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",
        difficulty: "K3"
      },
      {
        id: 172,
        text: "새로운 추천 AI 시스템에 A/B 테스트를 최적으로 적용하는 방법은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "모든 사용자에게 동시에 새 시스템 배포",
          "핵심 지표 모니터링과 함께 점진적 배포 사용",
          "회사 내부 직원에게만 시스템 테스트",
          "과거 데이터에서만 성능 비교"
        ],
        correct: 1,
        expA: "전체 배포는 위험하며 이전 시스템 버전과의 비교를 허용하지 않습니다.",
        expB: "훌륭합니다! 점진적 배포는 위험을 제어하고 통계적으로 유의한 비교 데이터를 얻을 수 있게 합니다.",
        expC: "내부 테스트는 제한적이며 실제 사용자 행동을 반영하지 못할 수 있습니다.",
        expD: "과거 데이터는 현재 사용자 경험과 비즈니스 지표에 미치는 영향을 보여주지 않습니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",
        difficulty: "K3"
      },
      {
        id: 173,
        text: "AI 시스템에 대한 경험 기반 테스트 시 가장 생산적인 접근법은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "도메인 전문가와 AI 테스트 전문가 간의 협업",
          "전적으로 자동화된 탐색적 테스트 도구에 의존",
          "오직 기술적 구현 세부사항에만 집중",
          "과거 테스트 케이스만을 엄격하게 따름"
        ],
        correct: 0,
        expA: "정답입니다! 도메인 지식과 AI 테스트 전문성을 결합하면 일반적인 함정과 특정 응용 프로그램 위험을 모두 식별할 수 있습니다.",
        expB: "자동화된 도구는 유용하지만 AI 시스템의 미묘한 도메인별 문제를 놓칠 수 있습니다.",
        expC: "기술적 세부사항은 중요하지만 경험 기반 테스트는 더 넓은 시스템 동작에 집중해야 합니다.",
        expD: "과거 테스트 케이스만 따르면 새로운 AI별 위험과 실패 모드를 놓칠 수 있습니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",
        difficulty: "K3"
      },
      {
        id: 174,
        text: "복잡한 멀티모달 AI 시스템을 테스트할 때 가장 효과적인 접근법은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "각 모달리티를 개별적으로만 테스트",
          "모달리티 간 상호작용과 통합 동작에 집중",
          "가장 간단한 모달리티만 테스트",
          "모든 모달리티에 동일한 테스트 적용"
        ],
        correct: 1,
        expA: "개별 모달리티 테스트는 중요하지만 모달리티 간 상호작용에서 발생하는 문제를 놓칩니다.",
        expB: "정확합니다! 멀티모달 시스템에서 가장 복잡하고 위험한 동작은 종종 다른 모달리티 간의 상호작용에서 나타납니다.",
        expC: "가장 간단한 모달리티만 테스트하는 것은 시스템의 실제 복잡성을 다루지 않습니다.",
        expD: "각 모달리티는 고유한 특성과 잠재적 실패 모드를 가지므로 맞춤형 접근법이 필요합니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",
        difficulty: "K3"
      },
      {
        id: 175,
        text: "실시간 AI 시스템에 적대적 테스트를 적용할 때 가장 중요한 고려사항은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "정상 운영에 미치는 영향을 최소화하면서 테스트",
          "모든 가능한 적대적 시나리오를 동시에 테스트",
          "적대적 테스트 중 시스템 성능만 측정",
          "실제 사용자 데이터로만 적대적 예제 생성"
        ],
        correct: 0,
        expA: "맞습니다! 실시간 시스템에서는 적대적 테스트가 정상 운영을 방해하지 않으면서 시스템 취약점을 효과적으로 드러내야 합니다.",
        expB: "모든 시나리오를 동시에 테스트하는 것은 시스템을 압도하고 실용적인 통찰을 제공하지 않을 수 있습니다.",
        expC: "성능은 중요하지만 적대적 테스트는 보안과 강건성에도 중점을 둬야 합니다.",
        expD: "실제 사용자 데이터만 사용하는 것은 제한적이며 개인정보 보호 문제를 야기할 수 있습니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",  
        difficulty: "K3"
      },
      {
        id: 176,
        text: "자율주행차의 AI 시스템을 테스트하기 위한 종합적인 전략을 개발할 때 무엇이 가장 중요합니까? 하나의 옵션을 선택하세요.",
        options: [
          "최신 테스트 도구만 사용",
          "시뮬레이션, 실제 테스트, 규제 요구사항을 결합",
          "실험실 환경에서만 테스트 수행",
          "소프트웨어 구성요소만 테스트"
        ],
        correct: 1,
        expA: "최신 도구는 도움이 될 수 있지만 자율주행차의 복잡한 안전 요구사항을 완전히 다루지는 못합니다.",
        expB: "정답입니다! 자율주행차는 안전이 중요하므로 시뮬레이션, 실제 도로 테스트, 규제 준수를 결합한 다층적 접근법이 필요합니다.",
        expC: "실험실 테스트만으로는 실제 도로 조건의 복잡성과 예측 불가능성을 포착할 수 없습니다.",
        expD: "자율주행차는 소프트웨어, 하드웨어, 센서의 통합 시스템이므로 전체적인 테스트가 필요합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",
        difficulty: "K4"
      },
      {
        id: 177,
        text: "의료 진단 AI 시스템에 대한 테스트 전략을 설계할 때 어떤 접근법이 가장 적절합니까? 하나의 옵션을 선택하세요.",
        options: [
          "기본 기능 테스트에만 집중",
          "가장 빠른 테스트 기법만 사용",
          "임상 검증, 편향 테스트, 규제 준수를 통합",
          "경제적 고려사항을 우선시"
        ],
        correct: 2,
        expA: "기본 기능 테스트만으로는 의료 AI의 안전성과 효과에 대한 엄격한 요구사항을 충족할 수 없습니다.",
        expB: "의료 시스템에서는 속도보다 철저함과 정확성이 우선되어야 합니다.",
        expC: "정확합니다! 의료 AI 시스템은 환자 안전에 영향을 미치므로 임상 유효성, 공정성, 규제 요구사항의 포괄적인 검증이 필요합니다.",
        expD: "의료 분야에서는 안전성과 효과가 경제적 고려사항보다 중요합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",
        difficulty: "K4"
      },
      {
        id: 178,
        text: "대규모 추천 시스템에 대한 테스트 기법을 선택할 때 무엇을 우선적으로 고려해야 합니까? 하나의 옵션을 선택하세요.",
        options: [
          "가장 고급 AI 기법만 사용",
          "사용자 경험, 공정성, 확장성의 균형",
          "시스템 복잡성을 기본으로 축소",
          "단일 성능 지표에만 집중"
        ],
        correct: 1,
        expA: "고급 기법이 추천 시스템의 모든 측면에 적절하거나 필요한 것은 아닙니다.",
        expB: "훌륭합니다! 추천 시스템은 다양한 사용자에게 서비스를 제공하므로 사용자 만족도, 공정성, 대규모 성능의 균형이 필요합니다.",
        expC: "기능을 축소하면 사용자 기대치를 충족하지 못하고 비즈니스 가치를 제한할 수 있습니다.",
        expD: "단일 지표에 집중하면 편향을 유발하고 전체적인 시스템 품질을 놓칠 수 있습니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",
        difficulty: "K4"
      },
      {
        id: 179,
        text: "대규모 AI 프로젝트에서 다양한 테스트 기법을 최적으로 균형 잡는 방법은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "가장 진보되고 복잡한 테스트 기법만 사용",
          "시간 절약을 위해 자동화된 솔루션만 적용",  
          "적응적 기법 선택으로 위험 기반 전략 생성",
          "모든 구성요소에 대해 단일 기법 세트를 표준화"
        ],
        correct: 2,
        expA: "진보된 기법이 모든 구성요소에 최적인 것은 아닙니다. 선택은 특정 위험에 맞춰야 합니다.",
        expB: "완전한 자동화는 인간의 분석과 전문성이 필요한 미묘한 문제를 놓칠 수 있습니다.",
        expC: "정답입니다! 위험 기반 접근법은 자원을 효율적으로 배분하고 각 상황에 가장 적합한 기법을 선택할 수 있게 합니다.",
        expD: "AI 시스템의 다른 구성요소는 다른 위험 특성을 가지며 적응된 테스트 접근법이 필요합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",
        difficulty: "K4"
      },
      {
        id: 180,
        text: "AI 시스템의 테스트 기법 선택에 가장 체계적인 접근법은 무엇입니까? 하나의 옵션을 선택하세요.",
        options: [
          "최대 커버리지를 위해 모든 사용 가능한 테스트 기법을 동시에 적용",
          "위험 기반 기법 선택과 함께 시스템 특성의 체계적 분석",
          "맥락에 관계없이 가장 진보된 기법만 사용",
          "마감일 준수를 위해 실행 속도만을 기준으로 기법 선택"
        ],
        correct: 1,
        expA: "모든 기법을 적용하는 것은 비효율적이며 특정 시스템의 구체적인 위험을 다루지 못할 수 있습니다.",
        expB: "훌륭합니다! 체계적 분석은 자원의 목표 지향적 사용과 중요한 문제 발견의 최대 효율성을 보장합니다.",
        expC: "진보된 기법이 모든 시스템 특성이나 위험 유형에 가장 적합한 것은 아닙니다.",
        expD: "실행 속도가 결정 요인이 되어서는 안 되며, 특히 안전성과 신뢰성이 중요한 경우에는 더욱 그렇습니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스트 방법 및 기법",
        difficulty: "K4"
      },
      {
        id: 181,
        text: "AI 테스트 환경을 구별할 때 가장 중요한 것은 무엇입니까? 하나를 선택하세요.",
        options: [
          "AI 전용 프로세서 요구사항",
          "정의되지 않은 환경 변화에 대한 적응",
          "기계 학습 모델 배포 요구사항",
          "신경망 하드웨어 가속화"
        ],
        correct: 1,
        expA: "AI 프로세서는 중요하지만 기존 테스트 환경과의 주요 차별화 요소는 아닙니다.",
        expB: "정확합니다! 자가 학습 시스템은 초기 배포 시 완전히 정의되지 않은 변화하는 환경에 적응해야 합니다(실러버스 섹션 10.1).",
        expC: "모델 배포는 요소이지만 기존 시스템과의 가장 중요한 차별화는 아닙니다.",
        expD: "하드웨어 가속화는 AI를 지원하지만 테스트 환경 요구사항을 고유하게 차별화하지는 않습니다.",
        points: 1,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K1"
      },
      
      {
        id: 182,
        text: "빅데이터 특성을 가장 잘 설명하는 것은 무엇입니까? 하나를 선택하세요.",
        options: [
          "구조화된 관계형 데이터 저장",
          "실시간 스트리밍 데이터 처리",
          "분산 다형식 데이터 처리",
          "대용량, 속도, 다양성 특성"
        ],
        correct: 3,
        expA: "구조화된 저장은 하나의 데이터 처리 방식일 뿐, 빅데이터의 정의적 특성이 아닙니다.",
        expB: "실시간 처리는 한 측면이지만 빅데이터의 전체 정의를 포착하지 못합니다.",
        expC: "분산 처리는 중요하지만 포괄적인 빅데이터 설명은 아닙니다.",
        expD: "완벽합니다! 빅데이터는 3V로 정의됩니다: 대용량(Volume), 속도(Velocity), 다양성(Variety) 특성입니다.",
        points: 1,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K1"
      },
    
      {
        id: 183,
        text: "자율 시스템 테스팅에 대한 다음 설명 중 올바른 것은 무엇입니까? 하나를 선택하세요.",
        options: [
          "사전 정의된 시나리오로 경계 테스팅",
          "인수인계 임계점 식별을 위한 스트레스 테스팅",
          "정상 조건에서의 성능 테스팅",
          "인간 운영자와의 통합 테스팅"
        ],
        correct: 1,
        expA: "사전 정의된 시나리오는 자율 의사결정의 예측 불가능한 특성을 포착하지 못합니다.",
        expB: "맞습니다! 자율성 테스팅은 시스템이 언제 인간에게 제어권을 넘겨야 하는지 식별하기 위해 시스템을 극한까지 밀어붙여야 합니다.",
        expC: "정상 조건은 자율성 결정이 가장 중요한 임계적 경계 사례를 테스트하지 못합니다.",
        expD: "통합은 중요하지만 자율 의사결정 경계를 테스트하지는 않습니다.",
        points: 1,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K2"
      },
    
      {
        id: 184,
        text: "AI 테스팅에서 설명가능성 도전을 설명하는 것은 무엇입니까? 하나를 선택하세요.",
        options: [
          "복잡한 모델 아키텍처가 해석가능성을 감소시킴",
          "의사결정 프로세스가 투명한 추론 경로를 부족",
          "블랙박스 알고리즘이 내부 로직을 모호하게 함",
          "다층 네트워크가 특징 관계를 숨김"
        ],
        correct: 1,
        expA: "아키텍처 복잡성은 요소이지만 핵심 설명가능성 테스팅 도전은 아닙니다.",
        expB: "정확합니다! AI 의사결정 프로세스는 추론 경로를 이해하기 위해 설명가능성 도구를 테스트 환경에 통합해야 합니다(실러버스 섹션 10.1).",
        expC: "블랙박스 특성은 우려사항이지만 설명가능성은 의사결정을 투명하게 만드는 데 중점을 둡니다.",
        expD: "특징 관계는 중요하지만 주요 문제는 투명한 의사결정 추론입니다.",
        points: 1,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K2"
      },
    
      {
        id: 185,
        text: "가상 테스트 환경의 주요 이점은 다음 중 무엇입니까? 하나를 선택하세요.",
        options: [
          "가속화된 테스트 사이클 실행",
          "향상된 시나리오 재현성",
          "위험한 조건의 안전한 테스팅",
          "개선된 테스트 데이터 관리"
        ],
        correct: 2,
        expA: "가속화는 유익하지만 AI 시스템 테스팅의 주요 장점은 아닙니다.",
        expB: "재현성은 가치가 있지만 AI 테스팅 시나리오에서 가장 중요한 이점은 아닙니다.",
        expC: "완벽합니다! 가상 환경은 현실에서 불가능하거나 위험한 위험한 시나리오의 안전한 테스팅을 가능하게 합니다.",
        expD: "데이터 관리는 개선되지만 안전 테스팅이 가상 환경의 주요 이점입니다.",
        points: 1,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K2"
      },
    
      {
        id: 186,
        text: "다음 중 가상 환경에 가장 적합한 시나리오는 무엇입니까? 하나를 선택하세요.",
        options: [
          "핵재해 대응 시뮬레이션",
          "표준 API 통합 테스팅",
          "데이터베이스 트랜잭션 검증",
          "사용자 인증 워크플로우"
        ],
        correct: 0,
        expA: "정확합니다! 핵재해와 같은 극한적이고 위험한 시나리오는 가상 테스팅 환경에 이상적입니다.",
        expB: "API 테스팅은 가상 환경의 복잡성과 안전 이점이 필요하지 않습니다.",
        expC: "데이터베이스 검증은 가상 환경 기능이 필요하지 않은 표준 테스팅입니다.",
        expD: "인증 워크플로우는 가상 환경 복잡성이 필요하지 않은 일상적인 테스트입니다.",
        points: 1,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K2"
      },
    
      {
        id: 187,
        text: "다중 에이전트 시스템 테스팅을 가장 잘 설명하는 것은 무엇입니까? 하나를 선택하세요.",
        options: [
          "조정된 결정론적 에이전트 동작",
          "순차적 단일 에이전트 검증",
          "비결정론적 상호작용 패턴",
          "단순화된 통신 프로토콜"
        ],
        correct: 2,
        expA: "결정론적 동작은 다중 에이전트 시스템의 복잡한 상호작용을 반영하지 못합니다.",
        expB: "순차적 테스팅은 중요한 동시 상호작용 측면을 놓칩니다.",
        expC: "맞습니다! 다중 에이전트 시스템은 비결정론적 상호작용을 통합하는 테스트 환경이 필요합니다.",
        expD: "단순화된 프로토콜은 실제 다중 에이전트 조정의 복잡성을 포착하지 못합니다.",
        points: 1,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K2"
      },
    
      {
        id: 188,
        text: "AI 테스트 환경 하드웨어를 계획할 때 가장 중요한 요소는 무엇입니까? 하나를 선택하세요.",
        options: [
          "표준 서버 사양",
          "AI 전용 프로세서 요구사항",
          "네트워크 대역폭 제한",
          "저장 용량 최적화"
        ],
        correct: 1,
        expA: "표준 사양은 전문화된 AI 처리 요구사항을 지원하지 못할 수 있습니다.",
        expB: "맞습니다! GPU와 TPU와 같은 AI 전용 프로세서는 테스트 환경 계획에서 고려되어야 합니다.",
        expC: "대역폭은 중요하지만 AI 워크로드에 대한 처리 능력만큼 중요하지는 않습니다.",
        expD: "저장소는 필요하지만 AI 전용 처리 능력이 가장 중요한 하드웨어 요소입니다.",
        points: 1,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K2"
      },
    
      {
        id: 189,
        text: "자율 주행 차량 시스템 테스팅에 가장 효과적인 접근법은 무엇입니까? 하나를 선택하세요.",
        options: [
          "시뮬레이션과 실제 환경 테스팅의 결합",
          "실험실 조건에서만 테스팅",
          "표준 회귀 테스팅에만 의존",
          "수동 테스트 케이스 실행만 사용"
        ],
        correct: 0,
        expA: "완벽합니다! 자율 주행은 통제된 시뮬레이션과 실제 환경 검증을 모두 필요로 하는 포괄적인 테스팅 접근법이 필요합니다.",
        expB: "실험실 조건만으로는 실제 주행의 복잡하고 예측 불가능한 시나리오를 나타내지 못합니다.",
        expC: "표준 회귀 테스팅은 자율 주행의 복잡한 실시간 의사결정 요구사항을 다루지 못합니다.",
        expD: "수동 실행만으로는 자율 시스템의 동적이고 적응적 특성을 포괄적으로 검증할 수 없습니다.",
        points: 2,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K3"
      },
    
      {
        id: 190,
        text: "자가 학습 시스템을 위한 테스트 환경을 설계할 때 가장 중요한 고려사항은 무엇입니까? 하나를 선택하세요.",
        options: [
          "정적 테스트 데이터 세트 사용",
          "환경 변화에 대한 적응성 통합",
          "표준 테스트 절차에만 집중",
          "사전 정의된 결과에만 의존"
        ],
        correct: 1,
        expA: "정적 데이터는 자가 학습 시스템의 적응적 특성을 테스트하지 못합니다.",
        expB: "정확합니다! 자가 학습 시스템은 변화하는 운영 환경에 적응할 수 있는 능력을 테스트해야 합니다.",
        expC: "표준 절차만으로는 자가 학습의 동적이고 진화하는 특성을 다루지 못합니다.",
        expD: "사전 정의된 결과는 자가 학습 시스템의 적응적이고 예측 불가능한 특성과 모순됩니다.",
        points: 2,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K3"
      },
    
      {
        id: 191,
        text: "설명 가능한 AI 시스템의 테스트 환경에서 가장 중요한 것은 무엇입니까? 하나를 선택하세요.",
        options: [
          "실행 속도만 최적화",
          "정확도 메트릭에만 집중",
          "설명가능성 도구와 성능 검증 통합",
          "별도의 설명가능성 테스팅"
        ],
        correct: 2,
        expA: "속도 최적화만으로는 설명가능성 요구사항을 검증하지 못합니다.",
        expB: "정확도에만 집중하면 의사결정 투명성이라는 중요한 측면을 놓칩니다.",
        expC: "정확합니다! 테스트 환경은 설명가능성과 성능이 함께 효과적으로 작동하는지 검증해야 합니다.",
        expD: "별도 테스팅은 설명가능성 프로세스와 성능 영향 간의 중요한 상호작용을 놓칩니다.",
        points: 2,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K3"
      },
    
      {
        id: 192,
        text: "빅데이터 AI 시스템을 위한 테스트 환경을 구축할 때 가장 효과적인 전략은 무엇입니까? 하나를 선택하세요.",
        options: [
          "소규모 샘플 데이터만 사용",
          "단일 데이터 형식에만 집중",
          "과거 데이터만 복제",
          "다양한 데이터 유형과 볼륨으로 확장 가능한 인프라"
        ],
        correct: 3,
        expA: "소규모 샘플은 빅데이터 시스템의 확장성과 성능 특성을 테스트하지 못합니다.",
        expB: "단일 형식은 빅데이터의 다양성(Variety) 특성을 무시합니다.",
        expC: "과거 데이터만으로는 실시간 스트리밍과 동적 데이터 패턴을 테스트하지 못합니다.",
        expD: "완벽합니다! 빅데이터 AI 시스템은 다양한 데이터 유형과 볼륨을 처리할 수 있는 확장 가능한 테스트 인프라가 필요합니다.",
        points: 2,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K3"
      },
    
      {
        id: 193,
        text: "위험한 환경에서 작동하는 자율 시스템을 테스팅할 때 가장 적절한 접근법은 무엇입니까? 하나를 선택하세요.",
        options: [
          "실제 위험한 환경에서만 테스팅",
          "기본 기능 테스트에만 집중",
          "표준 사용자 시나리오만 시뮬레이션",
          "가상 위험 시나리오와 안전 프로토콜을 결합한 포괄적 테스팅"
        ],
        correct: 3,
        expA: "실제 위험한 환경은 테스터와 장비에 불필요한 위험을 초래합니다.",
        expB: "기본 기능만으로는 위험한 환경에서의 자율 의사결정을 검증하지 못합니다.",
        expC: "표준 시나리오는 위험한 환경의 예외적이고 중요한 상황을 다루지 못합니다.",
        expD: "훌륭합니다! 가상 위험 시나리오는 안전하면서도 포괄적인 자율 시스템 테스팅을 가능하게 합니다.",
        points: 2,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K3"
      },
    
      {
        id: 194,
        text: "다중 에이전트 AI 시스템의 테스트 환경에서 가장 중요한 것은 무엇입니까? 하나를 선택하세요.",
        options: [
          "에이전트 간 조정과 비결정론적 상호작용 모델링",
          "개별 에이전트만 격리하여 테스팅",
          "단순화된 통신 프로토콜 사용",
          "예측 가능한 에이전트 동작만 테스팅"
        ],
        correct: 0,
        expA: "정확합니다! 다중 에이전트 시스템은 에이전트 간의 복잡한 조정과 비결정론적 상호작용을 모델링하는 테스트 환경이 필요합니다.",
        expB: "격리된 테스팅은 에이전트 간의 중요한 상호작용과 협력을 놓칩니다.",
        expC: "단순화된 프로토콜은 실제 다중 에이전트 환경의 복잡성을 포착하지 못합니다.",
        expD: "예측 가능한 동작만으로는 다중 에이전트 시스템의 동적이고 적응적 특성을 검증하지 못합니다.",
        points: 2,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K3"
      },
    
      {
        id: 195,
        text: "극한 시나리오 테스팅을 위한 가상 환경의 가장 중요한 이점은 무엇입니까? 하나를 선택하세요.",
        options: [
          "비용 절감과 빠른 설정",
          "위험 없는 안전한 테스팅과 반복성",
          "단순화된 테스트 케이스 관리",
          "실제 환경과 동일한 정확성"
        ],
        correct: 1,
        expA: "비용과 설정 시간은 이점이지만 극한 시나리오 테스팅의 주요 가치는 아닙니다.",
        expB: "완벽합니다! 가상 환경은 위험한 극한 시나리오를 안전하게 반복 테스트할 수 있게 합니다.",
        expC: "테스트 케이스 관리의 단순화는 부차적인 이점입니다.",
        expD: "완전한 정확성보다는 안전한 근사화가 극한 시나리오 테스팅의 핵심 가치입니다.",
        points: 3,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K4"
      },
    
      {
        id: 196,
        text: "의료 AI 시스템을 위한 포괄적인 테스트 환경 전략을 개발할 때 가장 중요한 것은 무엇입니까? 하나를 선택하세요.",
        options: [
          "기본 기능 테스팅에만 집중",
          "규제 준수, 환자 안전, 설명가능성을 모두 다루는 다층 접근법",
          "표준 소프트웨어 테스팅 방법만 사용",
          "자동화된 테스팅 도구에만 의존"
        ],
        correct: 1,
        expA: "기본 기능만으로는 의료 AI의 복잡한 안전 및 규제 요구사항을 다루지 못합니다.",
        expB: "정확합니다! 의료 AI는 환자 안전, 규제 준수, 의사결정 설명가능성을 모두 보장하는 포괄적 전략이 필요합니다.",
        expC: "표준 방법만으로는 의료 특정 규제와 안전 요구사항을 다루지 못합니다.",
        expD: "자동화된 도구만으로는 의료 AI의 미묘하고 중요한 안전 고려사항을 다룰 수 없습니다.",
        points: 3,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K4"
      },
    
      {
        id: 197,
        text: "금융 거래 AI 시스템의 테스트 환경에서 보안과 성능을 모두 검증하는 최적 전략은 무엇입니까? 하나를 선택하세요.",
        options: [
          "보안 테스팅에만 집중",
          "성능 테스팅에만 집중",
          "통합된 보안-성능 테스팅과 실시간 위협 시뮬레이션",
          "별도의 보안 및 성능 테스트 환경"
        ],
        correct: 2,
        expA: "보안만 집중하면 금융 거래의 중요한 성능 요구사항을 놓칠 수 있습니다.",
        expB: "성능만 집중하면 금융 시스템에 중요한 보안 취약점을 놓칠 수 있습니다.",
        expC: "훌륭합니다! 통합된 접근법은 보안 조치가 성능에 미치는 영향과 실시간 위협 대응을 함께 검증합니다.",
        expD: "별도 테스팅은 보안과 성능 간의 중요한 상호작용과 트레이드오프를 놓칩니다.",
        points: 3,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K4"
      },
    
      {
        id: 198,
        text: "스마트 시티 AI 시스템의 테스트 환경에서 시민 데이터 프라이버시와 시스템 효율성을 모두 검증하는 접근법은 무엇입니까? 하나를 선택하세요.",
        options: [
          "실제 시민 데이터만 사용",
          "익명화된 데이터만 사용",
          "차등 프라이버시와 합성 데이터를 결합한 다층 접근법",
          "프라이버시 고려 없이 효율성에만 집중"
        ],
        correct: 2,
        expA: "실제 데이터 사용은 시민 프라이버시를 심각하게 위험에 빠뜨립니다.",
        expB: "익명화된 데이터만으로는 실제 시스템 복잡성과 효율성을 충분히 테스트하지 못할 수 있습니다.",
        expC: "완벽합니다! 차등 프라이버시와 합성 데이터의 조합은 프라이버시 보호와 현실적인 시스템 효율성 테스팅을 모두 가능하게 합니다.",
        expD: "프라이버시를 무시하는 것은 윤리적으로 부적절하며 규제 위반을 초래할 수 있습니다.",
        points: 3,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K4"
      },
    
      {
        id: 199,
        text: "빅데이터를 처리하는 AI 시스템의 테스트 환경에서 가장 포괄적인 검증 접근법은 무엇입니까? 하나를 선택하세요.",
        options: [
          "철저한 검증과 효율적 자원 활용의 균형을 맞춘 포괄적 테스팅",
          "샘플 기반 접근법에만 의존",
          "테스팅 범위 축소로 비용 절약",
          "과거 데이터 복제에만 집중"
        ],
        correct: 0,
        expA: "훌륭합니다! 빅데이터 AI 시스템은 철저한 검증과 효율적인 자원 활용의 균형을 맞춘 포괄적 테스팅이 필요합니다.",
        expB: "샘플 기반 접근법은 빅데이터 시나리오에서 중요한 패턴과 경계 사례를 놓칠 수 있습니다.",
        expC: "축소된 테스팅은 시스템이 실제 빅데이터 도전을 처리하는 능력을 검증하지 못합니다.",
        expD: "과거 복제는 새롭고 진화하는 데이터 패턴에 적응하는 시스템의 능력을 테스트하지 못합니다.",
        points: 3,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K4"
      },
    
      {
        id: 200,
        text: "다중 에이전트 농업 AI 시스템에 대한 최적의 검증 커버리지를 제공하는 접근법은 무엇입니까? 하나를 선택하세요.",
        options: [
          "에이전트 조정 테스팅과 함께 다양한 환경 시나리오",
          "완벽한 날씨 조건 테스팅만",
          "개별 에이전트 격리 테스팅",
          "과거 농업 데이터 검증만"
        ],
        correct: 0,
        expA: "훌륭합니다! 농업 AI는 환경 적응과 다중 에이전트 조정을 모두 테스트하는 다양한 시나리오가 필요합니다.",
        expB: "완벽한 조건은 도전적인 실제 조건에서 적응하고 조정하는 시스템 능력을 테스트하지 못합니다.",
        expC: "개별 테스팅은 다중 에이전트 농업 시스템에 필수적인 중요한 조정 측면을 놓칩니다.",
        expD: "과거 데이터는 새로운 조건에 적응하고 에이전트 응답을 조정하는 시스템 능력을 테스트하지 못합니다.",
        points: 3,
        chapter: "AI 기반 시스템을 위한 테스트 환경",
        difficulty: "K4"
      },
      {
        id: 201,
        text: "AI를 활용한 시각적 테스팅에서 가장 중요한 고려사항은 무엇입니까?",
        options: [
          "이미지 해상도 최적화 기준 설정",
          "적절한 학습 데이터 세트 구성", 
          "색상 대비 임계값 자동 조정",
          "화면 크기별 렌더링 검증 자동화"
        ],
        correct: 1,
        expA: "해상도는 중요하지만 AI 시각적 테스팅의 핵심 성공 요소는 아닙니다.",
        expB: "정답입니다! 품질 높은 학습 데이터가 있어야 AI가 시각적 이상을 정확히 탐지할 수 있어요.",
        expC: "색상 조정은 보조적 기능이며, 데이터 품질이 더 기본적인 요구사항입니다.",
        expD: "렌더링 검증은 유용하지만 AI 모델의 정확성은 학습 데이터에 달려 있습니다.",
        points: 2,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K2"
      },
      {
        id: 202,
        text: "결함 예측(Defect Prediction)에서 AI 시스템이 주로 분석하는 데이터 유형은 무엇입니까?",
        options: [
          "코드 복잡도 및 변경 이력 메트릭",
          "사용자 인터페이스 디자인 패턴",
          "네트워크 트래픽 패턴 분석",
          "데이터베이스 쿼리 실행 계획"
        ],
        correct: 2,
        expA: "네, 정확합니다! 코드 복잡도, 변경 빈도, 개발자 경험 등이 결함 예측의 핵심 지표예요.",
        expB: "UI 패턴은 사용성 테스팅에는 관련이 있지만 결함 예측의 주요 데이터는 아닙니다.",
        expC: "네트워크 분석은 성능 테스팅 영역이며, 결함 예측과는 직접적 관련이 없습니다.",
        expD: "쿼리 계획은 데이터베이스 최적화 관련이며, 코드 결함 예측과는 다른 영역입니다.",
        points: 1,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K1"
      },
      {
        id: 203,
        text: "테스트 케이스 생성을 위한 AI 도구 선택 시 가장 우선시해야 할 평가 기준은 무엇입니까?",
        options: [
          "생성된 테스트의 도메인 적합성",
          "도구의 사용자 인터페이스 직관성",
          "라이선스 비용 및 유지보수 수준",
          "기존 CI/CD 파이프라인 호환성"
        ],
        correct: 0,
        expA: "맞습니다! 도메인에 적합하고 의미있는 테스트 케이스를 생성하는 것이 AI 도구의 핵심 가치예요.",
        expB: "사용성도 중요하지만, 생성되는 테스트의 품질과 적합성이 더 중요한 기준입니다.",
        expC: "비용은 고려사항이지만, 먼저 도구가 요구사항에 맞는 테스트를 생성하는지 확인해야 합니다.",
        expD: "통합성은 중요하지만, 생성되는 테스트 케이스의 품질이 우선 평가되어야 합니다.",
        points: 2,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K2"
      },
      {
        id: 204,
        text: "AI 기반 테스트 오라클 구현 시 고려해야 할 핵심 도전과제는 무엇입니까?",
        options: [
          "하드웨어 리소스 최적화 방법론",
          "예상 결과의 명확한 정의",
          "테스트 실행 속도 향상 기법",
          "개발팀과의 커뮤니케이션 채널"
        ],
        correct: 1,
        expA: "리소스 최적화는 성능 측면이지만, 오라클의 근본적 문제는 아닙니다.",
        expB: "절대적으로 맞습니다! AI 시스템의 비결정적 특성으로 인해 '정답'을 정의하기가 가장 어려워요.",
        expC: "실행 속도도 중요하지만, 무엇이 올바른 결과인지 판단하는 것이 더 근본적인 문제입니다.",
        expD: "소통은 중요하지만, 오라클 문제의 기술적 핵심은 정답 정의의 어려움입니다.",
        points: 2,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K2"
      },
      {
        id: 205,
        text: "회귀 테스트 최적화를 위한 AI 도구의 주요 동작 원리는 무엇입니까?",
        options: [
          "코드 변경 영향도 분석을 통한 테스트 선별",
          "테스트 케이스의 실행 시간 단축",
          "병렬 테스트 실행을 위한 자원 배분",
          "테스트 결과의 자동 분류 및 보고"
        ],
        correct: 1,
        expA: "네, 정확합니다! 변경된 코드가 영향을 미치는 영역을 분석해서 꼭 필요한 테스트만 실행해요.",
        expB: "시간 단축은 결과이지, AI의 핵심 동작 원리는 영향도 기반 선별입니다.",
        expC: "병렬 실행은 인프라 최적화 기법이며, AI의 지능적 테스트 선별과는 다릅니다.",
        expD: "결과 분류는 후처리 과정이고, 최적화의 핵심은 테스트 선별 로직입니다.",
        points: 2,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K2"
      },
      {
        id: 206,
        text: "AI를 활용한 테스트 데이터 생성에서 개인정보보호 규정 준수를 위한 가장 효과적인 접근법은 무엇입니까?",
        options: [
          "합성 데이터 생성 기술 활용",
          "데이터 암호화 강도 향상",
          "접근 권한 관리 시스템 구축",
          "데이터 보관 기간 단축 정책"
        ],
        correct: 0,
        expA: "완벽합니다! 실제 개인정보와 통계적으로 유사하지만 가상의 데이터를 생성하는 것이 최선책이에요.",
        expB: "암호화는 보안 조치지만, 근본적으로는 개인정보 사용 자체를 피하는 것이 더 안전합니다.",
        expC: "접근 제어도 중요하지만, 애초에 개인정보를 사용하지 않는 것이 더 확실한 방법입니다.",
        expD: "보관 기간 단축은 리스크 관리법이지만, 합성 데이터 사용이 더 근본적 해결책입니다.",
        points: 2,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K2"
      },
      {
        id: 207,
        text: "AI 기반 테스트 결과 분석에서 거짓 양성(False Positive) 최소화를 위한 핵심 전략은 무엇입니까?",
        options: [
          "테스트케이스 실행 빈도 증가 방식",
          "모델 학습 데이터의 품질 개선",
          "하드웨어 성능 향상을 통한 처리",
          "테스터의 수동 검증 단계 추가"
        ],
        correct: 1,
        expA: "실행 빈도 증가는 더 많은 데이터를 제공하지만, 거짓 양성 자체를 줄이지는 못합니다.",
        expB: "정답입니다! 다양하고 정확한 학습 데이터로 모델을 훈련하면 판단 정확도가 크게 향상돼요.",
        expC: "하드웨어 성능은 처리 속도 향상에는 도움되지만 판단 정확도 개선과는 별개입니다.",
        expD: "수동 검증은 보완책이지만, 모델 자체의 정확도를 높이는 것이 더 근본적 해결책입니다.",
        points: 2,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K2"
      },
      {
        id: 208,
        text: "테스트 자동화에서 AI를 활용할 때 가장 주의해야 할 위험 요소는 무엇입니까?",
        options: [
          "라이선스 비용의 급격한 증가",
          "팀원들의 기술 습득 곡선",
          "AI 모델의 판단 결과에 대한 과신",
          "기존 테스트 인프라와의 호환성"
        ],
        correct: 2,
        expA: "비용 증가는 관리 이슈이지만, 테스트 품질에 직접적 영향을 주는 위험은 아닙니다.",
        expB: "학습 곡선은 도입 과정의 어려움이지만, 테스트 결과의 신뢰성 문제는 아닙니다.",
        expC: "맞습니다! AI 결과를 맹신하면 중요한 결함을 놓치거나 잘못된 의사결정을 할 수 있어요.",
        expD: "호환성 문제는 기술적 과제이지만, 과신으로 인한 테스트 품질 저하가 더 위험합니다.",
        points: 2,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K2"
      },
      {
        id: 209,
        text: "지속적 통합 환경에서 AI 기반 테스트 도구의 효과적인 통합을 위한 필수 고려사항은 무엇입니까?",
        options: [
          "클라우드 인프라로의 완전한 마이그레이션",
          "개발팀의 AI 전문 지식 보강",
          "빌드 파이프라인과의 원활한 연동",
          "실시간 모니터링 대시보드 구축"
        ],
        correct: 3,
        expA: "클라우드 전환은 하나의 옵션이지만, CI/CD 통합의 필수 조건은 아닙니다.",
        expB: "AI 지식은 도움이 되지만, 도구 통합 자체에는 파이프라인 연동이 더 중요합니다.",
        expC: "그렇습니다! 빌드 과정에 자연스럽게 통합되어야 개발 워크플로우를 방해하지 않아요.",
        expD: "모니터링도 중요하지만, 먼저 파이프라인에서 안정적으로 동작하는 것이 우선입니다.",
        points: 2,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K2"
      },
      {
        id: 210,
        text: "대규모 웹 애플리케이션에서 AI 기반 성능 테스트 구현 시 가장 효과적인 접근 전략은 무엇입니까?",
        options: [
          "단계적 부하 증가를 통한 임계점 탐지",
          "전체 시스템 동시 부하 테스트 실행",
          "개별 컴포넌트 성능 측정 후 통합",
          "과거 성능 데이터 기반 예측 모델링"
        ],
        correct: 0,
        expA: "훌륭한 선택입니다! AI가 부하를 점진적으로 증가시키며 성능 한계점을 지능적으로 찾아내는 방법이에요.",
        expB: "동시 전체 부하는 시스템을 압도할 수 있고, AI의 학습과 적응 능력을 제대로 활용하지 못합니다.",
        expC: "개별 테스트도 유용하지만, 실제 사용자 패턴을 반영한 통합적 접근이 더 효과적입니다.",
        expD: "예측 모델링은 보완적이지만, 실제 부하 패턴으로 시스템을 검증하는 것이 더 중요합니다.",
        points: 3,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K3"
      },
      {
        id: 211,
        text: "모바일 앱의 사용성 테스트에서 AI를 효과적으로 활용하기 위한 핵심 구현 방안은 무엇입니까?",
        options: [
          "다양한 디바이스에서의 호환성 검증",
          "사용자 행동 패턴 분석 및 이상 탐지",
          "앱 크래시 로그의 자동 분류 처리",
          "네트워크 상태별 성능 측정 자동화"
        ],
        correct: 1,
        expA: "호환성 검증은 중요하지만, 사용성 테스트의 핵심은 사용자 경험 분석입니다.",
        expB: "정확합니다! 사용자가 어떻게 앱을 사용하는지 패턴을 학습하고 비정상적 행동을 찾아내는 것이 핵심이에요.",
        expC: "크래시 분석은 안정성 테스트 영역이며, 사용성과는 다른 관점입니다.",
        expD: "성능 측정도 중요하지만, 사용성 테스트는 사용자 인터랙션 품질에 초점을 맞춰야 합니다.",
        points: 3,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K3"
      },
      {
        id: 212,
        text: "API 테스트 자동화에서 AI를 활용한 테스트 케이스 우선순위 결정 시 고려해야 할 주요 요인은 무엇입니까?",
        options: [
          "API 호출 빈도와 비즈니스 영향도",
          "테스트 실행 시간과 리소스 사용량",
          "개발팀의 코드 커밋 패턴 분석",
          "외부 의존성 서비스의 안정성 수준"
        ],
        correct: 2,
        expA: "호출 빈도와 비즈니스 영향도는 중요한 기준이지만, 우선순위 결정에는 더 포괄적 접근이 필요합니다.",
        expB: "실행 시간과 리소스는 효율성 요인이지만, 테스트의 중요도 판단 기준으로는 부족합니다.",
        expC: "맞습니다! 어떤 코드가 자주 변경되는지, 누가 작업하는지 등의 패턴을 분석하면 리스크가 높은 영역을 예측할 수 있어요.",
        expD: "외부 의존성도 고려사항이지만, 내부 개발 패턴 분석이 우선순위 결정에 더 직접적입니다.",
        points: 3,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K3"
      },
      {
        id: 213,
        text: "데이터베이스 테스트에서 AI를 활용한 데이터 품질 검증 구현 시 최우선 고려사항은 무엇입니까?",
        options: [
          "쿼리 성능 최적화를 위한 인덱스 분석",
          "데이터 일관성 규칙 학습 및 위반 탐지",
          "백업 및 복구 프로세스 자동화 구축",
          "동시 접근 제어를 위한 락 메커니즘"
        ],
        correct: 3,
        expA: "성능 최적화는 중요하지만, 데이터 품질 검증의 핵심 목적과는 다릅니다.",
        expB: "백업/복구는 데이터 안전성 관련이며, 품질 검증과는 별개의 영역입니다.",
        expC: "동시성 제어는 시스템 안정성 이슈이고, 데이터 자체의 품질과는 다른 관점입니다.",
        expD: "정답입니다! AI가 데이터 간의 관계와 규칙을 학습해서 일관성 위반을 자동으로 찾아내는 것이 핵심이에요.",
        points: 3,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K3"
      },
      {
        id: 214,
        text: "마이크로서비스 아키텍처에서 AI 기반 통합 테스트 전략 수립 시 핵심 접근 방법은 무엇입니까?",
        options: [
          "각 서비스별 독립적인 테스트 환경 구성",
          "전체 서비스 체인의 동시 배포 및 검증",
          "서비스 간 의존성 그래프 분석 기반 테스트",
          "컨테이너 오케스트레이션 도구와의 통합"
        ],
        correct: 3,
        expA: "독립적 테스트도 중요하지만, 통합 테스트는 서비스 간 상호작용에 초점을 맞춰야 합니다.",
        expB: "동시 검증은 복잡성을 증가시키며, 문제 발생 시 원인 파악이 어려워집니다.",
        expC: "맞습니다! 서비스 간 호출 관계와 의존성을 분석해서 영향도가 높은 경로부터 테스트하는 것이 효율적이에요.",
        expD: "오케스트레이션 통합은 배포 관점이며, 테스트 전략의 핵심은 의존성 분석입니다.",
        points: 3,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K3"
      },
      {
        id: 215,
        text: "클라우드 네이티브 애플리케이션의 AI 기반 보안 테스트에서 가장 효과적인 구현 접근법은 무엇입니까?",
        options: [
          "정적 코드 분석을 통한 취약점 탐지",
          "런타임 행위 분석 및 anomaly 탐지",
          "네트워크 트래픽 패턴 모니터링 분석",
          "인증 및 권한 체계 구성 검증"
        ],
        correct: 3,
        expA: "정적 분석은 기본적이지만, 클라우드 환경의 동적 특성을 완전히 커버하지 못합니다.",
        expB: "네트워크 모니터링은 중요하지만, 애플리케이션 레벨의 보안 이슈는 놓칠 수 있습니다.",
        expC: "인증/권한 검증은 필수이지만, 복합적 보안 위협에 대한 포괄적 접근이 필요합니다.",
        expD: "완벽합니다! 클라우드 환경에서는 실시간으로 변화하는 애플리케이션 행위를 모니터링하며 이상 패턴을 탐지하는 것이 가장 효과적이에요.",
        points: 3,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K3"
      },
      {
        id: 216,
        text: "기업 환경에서 AI 기반 테스트 도구 도입을 위한 최적 거버넌스 전략은 무엇입니까?",
        options: [
          "모든 프로젝트에 동일한 도구 표준화",
          "중앙 집중식 관리와 상황별 적응의 균형",
          "개발팀별 자유로운 도구 선택 허용",
          "하이브리드 접근법을 통한 점진적 확산"
        ],
        correct: 0,
        expA: "표준화는 일관성을 제공하지만, 프로젝트별 특성을 고려하지 않아 비효율적일 수 있습니다.",
        expB: "정답입니다! 전사 차원의 일관된 기준을 유지하면서도 각 팀의 특성에 맞게 적응할 수 있는 유연성이 필요해요.",
        expC: "자유로운 선택은 혁신을 격려하지만, 지식 공유와 표준화에 어려움을 만들 수 있습니다.",
        expD: "하이브리드 접근법은 좋지만, 중앙 거버넌스와 팀별 적응의 균형이 더 체계적입니다.",
        points: 3,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K4"
      },
      {
        id: 217,
        text: "AI 테스트 도구의 ROI 측정을 위한 가장 포괄적인 평가 프레임워크는 무엇입니까?",
        options: [
          "테스트 실행 시간 단축률과 인력 절감 효과",
          "결함 탐지율 향상과 고객 만족도 증가",
          "비용 절감, 품질 향상, 개발 속도의 통합 분석",
          "도구 라이선스 비용 대비 생산성 증가율"
        ],
        correct: 2,
        expA: "시간과 인력 절감은 중요한 지표이지만, ROI의 전체 그림을 보여주지는 못합니다.",
        expB: "품질과 만족도도 핵심 요소이지만, 비용 측면의 분석이 함께 있어야 완전합니다.",
        expC: "정확합니다! 투자 대비 효과를 제대로 측정하려면 비용, 품질, 속도라는 3가지 차원을 모두 종합적으로 분석해야 해요.",
        expD: "라이선스 비용만으로는 AI 도입의 전체적인 영향을 측정하기에 너무 제한적입니다.",
        points: 3,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K4"
      },
      {
        id: 218,
        text: "다국적 기업에서 AI 기반 테스트 자동화 표준화 추진 시 가장 중요한 전략적 고려사항은 무엇입니까?",
        options: [
          "모든 지역의 기술 인프라 통일",
          "현지 규정 준수와 글로벌 일관성의 균형",
          "중앙 집중식 AI 모델 관리 체계",
          "지역별 개발 문화 차이 최소화"
        ],
        correct: 2,
        expA: "인프라 통일은 이상적이지만 현실적으로 어렵고, 지역별 특성을 고려해야 합니다.",
        expB: "맞습니다! 각국의 데이터 보호법이나 업계 규정을 준수하면서도 전사적 일관성을 유지하는 것이 핵심이에요.",
        expC: "중앙 관리는 효율적이지만, 지역별 규정과 요구사항을 충분히 반영하지 못할 수 있습니다.",
        expD: "문화 차이는 관리해야 할 요소이지만, 규정 준수가 더 우선적이고 구체적인 과제입니다.",
        points: 3,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K4"
      },
      {
        id: 219,
        text: "AI 테스트 시스템의 장기적 진화 및 유지보수를 위한 최적 전략은 무엇입니까?",
        options: [
          "정기적인 모델 재학습과 성능 벤치마킹",
          "새로운 AI 기술의 즉각적인 도입",
          "테스트 데이터 아카이브의 지속적 확장",
          "외부 전문가 컨설팅을 통한 주기적 검토"
        ],
        correct: 2,
        expA: "데이터 확장은 좋지만, 체계적인 모델 관리와 성능 추적이 더 중요합니다.",
        expB: "즉각적 도입은 위험할 수 있으며, 안정성과 호환성을 충분히 검증해야 합니다.",
        expC: "정답입니다! 정기적으로 모델을 업데이트하고 성능을 측정해서 시스템이 계속 효과적으로 동작하도록 관리하는 것이 핵심이에요.",
        expD: "외부 검토도 유용하지만, 내부적으로 지속적인 모델 관리 체계를 구축하는 것이 더 중요합니다.",
        points: 3,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K4"
      },
      {
        id: 220,
        text: "조직 내 AI 테스팅 역량 구축을 위한 가장 효과적인 통합 접근법은 무엇입니까?",
        options: [
          "전문 AI 테스팅 팀의 별도 구성",
          "기존 테스터들의 단계적 AI 기술 교육",
          "외부 AI 전문업체와의 파트너십 체결",
          "중앙 거버넌스와 팀별 적응의 조화"
        ],
        correct: 3,
        expA: "전문 팀 구성은 깊이 있는 전문성을 제공하지만, 조직 전체로의 확산에는 한계가 있습니다.",
        expB: "기존 인력 교육은 현실적이지만, 새로운 관점과 혁신적 접근에는 제약이 있을 수 있습니다.",
        expC: "파트너십은 빠른 전문성 확보에 도움되지만, 내부 역량 구축에는 한계가 있습니다.",
        expD: "완벽합니다! 전사적 일관성을 위한 중앙 가이드라인을 제공하면서도 각 팀이 자신의 상황에 맞게 적응할 수 있는 유연성을 주는 것이 가장 효과적이에요.",
        points: 3,
        chapter: "테스팅을 위한 AI 활용",
        difficulty: "K4"
      },
      {
        id: 221,
        text: "다음 중 AI와 머신러닝에 대한 설명으로 가장 적절한 것은 무엇입니까?",
        options: [
          "머신러닝과 AI는 완전히 관련 없는 개념이다",
          "머신러닝은 인공지능의 하위 분야이다",
          "AI는 머신러닝의 하위 분야이다",
          "머신러닝과 AI는 동일한 용어이다"
        ],
        correct: 1,
        expA: "머신러닝과 AI는 분명히 관련이 있어요. 실제로 ML은 AI의 일부분입니다.",
        expB: "정확해요! 머신러닝은 AI 시스템을 구현하는 데 사용되는 기술 중 하나입니다.",
        expC: "이건 반대예요. AI가 ML을 포함하는 더 넓은 분야입니다.",
        expD: "관련이 있지만, 이 용어들은 분야에서 구별되는 의미를 가지고 있어요.",
        points: 1,
        chapter: "AI 소개",
        difficulty: "K2"
      },
      {
        id: 223,
        text: "일반적인 시스템과 AI 기반 시스템에 대한 설명 중 올바른 것은 무엇입니까?",
        options: [
          "일반적인 시스템은 프로그램된 논리 경로를 통해 적응한다",
          "AI 기반 시스템은 데이터 분석을 통해 패턴을 학습한다",
          "일반적인 시스템은 명시적 프로그래밍 규칙에 의존한다",
          "AI 기반 시스템은 의사결정에 통계적 추론을 사용한다"
        ],
        correct: 2,
        expA: "일반적인 시스템은 미리 정해진 경로를 따르지만 AI 시스템처럼 적응하지는 않아요.",
        expB: "이것은 AI 시스템을 정확히 설명하지만, 질문은 전반적으로 올바른 설명을 묻고 있어요.",
        expC: "정확합니다! 일반적인 시스템은 명시적이고 프로그래밍된 지시사항과 논리 규칙에 의존해요.",
        expD: "이것은 AI 시스템을 정확히 설명하지만 일반적인 시스템과 구별하지는 못해요.",
        points: 1,
        chapter: "AI 소개",
        difficulty: "K2"
      },
      {
        id: 225,
        text: "딥러닝 모델 훈련에 가장 중요한 하드웨어 구성요소는 무엇입니까?",
        options: [
          "그래픽 처리 장치(GPU)",
          "고속 인터넷 연결",
          "대용량 RAM 메모리",
          "솔리드 스테이트 드라이브(SSD)"
        ],
        correct: 0,
        expA: "완벽해요! GPU는 딥러닝 연산에 필수적인 병렬 처리 능력을 제공합니다.",
        expB: "인터넷 속도는 데이터 전송에는 도움되지만 훈련 과정 자체에는 중요하지 않아요.",
        expC: "RAM도 중요하지만 딥러닝 훈련에 가장 핵심적인 구성요소는 아닙니다.",
        expD: "SSD는 데이터 접근 속도를 향상시키지만 가장 중요한 훈련 구성요소는 아니에요.",
        points: 1,
        chapter: "AI 소개",
        difficulty: "K2"
      },
      {
        id: 226,
        text: "다음 중 AI 효과(AI Effect)를 가장 잘 보여주는 시나리오는 무엇입니까?",
        options: [
          "새로운 AI 시스템이 성능 기대치를 충족하지 못하는 경우",
          "AI 기능이 너무 일반화되어 사람들이 더 이상 AI라고 부르지 않는 경우",
          "AI 시스템이 상당한 컴퓨팅 리소스를 필요로 하는 경우",
          "AI 기술이 여러 산업에서 채택되는 경우"
        ],
        correct: 1,
        expA: "성능 실패는 AI 효과 개념을 보여주지 않습니다.",
        expB: "정확해요! AI 효과는 성공적인 AI가 너무 일반화되어 더 이상 '지능적'이라고 여겨지지 않을 때 발생해요.",
        expC: "리소스 요구사항은 AI 효과의 인식 변화와 관련이 없습니다.",
        expD: "광범위한 채택이 반드시 AI 효과 현상을 보여주는 것은 아니에요.",
        points: 1,
        chapter: "AI 소개",
        difficulty: "K2"
      },
      {
        id: 227,
        text: "AIaaS(AI as a Service)에 대한 설명 중 가장 정확한 것은 무엇입니까?",
        options: [
          "AIaaS는 조직이 로컬에서 AI 인프라를 구축하도록 요구한다",
          "AIaaS는 AI 기능에 대한 클라우드 기반 접근을 제공한다",
          "AIaaS는 맞춤 개발된 AI 모델에서만 작동한다",
          "AIaaS는 AI 애플리케이션에서 데이터 필요성을 제거한다"
        ],
        correct: 1,
        expA: "AIaaS는 실제로 클라우드 접근을 제공하여 로컬 AI 인프라 필요성을 제거해요.",
        expB: "맞습니다! AIaaS는 로컬 인프라 없이 클라우드 서비스를 통해 AI 기능을 제공해요.",
        expC: "AIaaS는 일반적으로 맞춤 솔루션뿐만 아니라 사전 구축된 모델과 서비스를 제공합니다.",
        expD: "제공 방법과 관계없이 AI 애플리케이션에는 여전히 데이터가 필수적이에요.",
        points: 1,
        chapter: "AI 소개",
        difficulty: "K2"
      },
      {
        id: 228,
        text: "다음 기술 중 AI 구현으로 간주될 가능성이 가장 낮은 것은 무엇입니까?",
        options: [
          "자연어 처리 시스템",
          "컴퓨터 비전 애플리케이션",
          "추천 알고리즘",
          "전통적인 데이터베이스 쿼리"
        ],
        correct: 3,
        expA: "자연어 처리는 분명히 핵심 AI 기술입니다.",
        expB: "컴퓨터 비전은 AI 기술의 주요 응용 분야를 나타내요.",
        expC: "추천 시스템은 일반적으로 머신러닝과 AI 알고리즘을 사용합니다.",
        expD: "맞아요! 전통적인 데이터베이스 쿼리는 AI 기법이 아닌 미리 정의된 논리를 사용해요.",
        points: 1,
        chapter: "AI 소개",
        difficulty: "K2"
      },
      {
        id: 229,
        text: "AI 개발 프레임워크에 대한 설명 중 가장 정확한 것은 무엇입니까?",
        options: [
          "모든 AI 프레임워크는 동일한 기능을 제공한다",
          "프레임워크 선택은 프로젝트 성공에 미미한 영향을 준다",
          "서로 다른 프레임워크는 서로 다른 AI 애플리케이션에 최적화되어 있다",
          "오픈소스 프레임워크가 상용 프레임워크보다 항상 우수하다"
        ],
        correct: 2,
        expA: "AI 프레임워크는 기능과 대상 애플리케이션에서 상당히 다릅니다.",
        expB: "프레임워크 선택은 개발 효율성과 프로젝트 결과에 상당한 영향을 줄 수 있어요.",
        expC: "정확해요! 서로 다른 프레임워크는 컴퓨터 비전, NLP, 일반 ML 등 다른 영역에서 뛰어나요.",
        expD: "오픈소스나 상용 프레임워크 모두 보편적으로 우수하지 않아요. 필요에 따라 달라져요.",
        points: 1,
        chapter: "AI 소개",
        difficulty: "K2"
      },
    
      // ================= K1 QUESTIONS =================
      {
        id: 222,
        text: "다음 중 슈퍼 AI의 예는 무엇입니까?",
        options: [
          "여러 도메인에서 인간 수준의 성능을 달성하는 AI 시스템",
          "인간의 능력을 넘어서는 일반 지능을 보여주는 AI 시스템",
          "전문 기술 영역에서 고급 학습을 하는 AI 시스템",
          "인지 작업에서 적응형 지능을 보여주는 AI 시스템"
        ],
        correct: 1,
        expA: "이것은 인공일반지능(AGI)을 설명하는 것이지, 인간 능력을 넘어서는 슈퍼 AI가 아니에요.",
        expB: "맞아요! 슈퍼 AI는 모든 인지 영역과 능력에서 인간 지능을 능가할 것입니다.",
        expC: "고급 전문 학습은 협소한 AI를 설명하는 것이지, 더 넓은 슈퍼 AI 개념이 아니에요.",
        expD: "적응형 지능은 일반 AI의 특징이지만, 슈퍼 AI는 우수한 능력을 의미해요.",
        points: 1,
        chapter: "AI 소개",
        difficulty: "K1"
      },
      {
        id: 224,
        text: "다음 중 AI 구현에 일반적으로 사용되는 개발 프레임워크는 무엇입니까?",
        options: [
          "전통적인 머신러닝 알고리즘을 위한 Scikit-learn",
          "빠른 신경망 개발을 위한 Keras",
          "AI 연구 및 제품 시스템을 위한 PyTorch",
          "그래디언트 부스팅 구현을 위한 XGBoost"
        ],
        correct: 2,
        expA: "Scikit-learn은 전통적인 ML에는 유용하지만 딥러닝 애플리케이션에는 제한적이에요.",
        expB: "Keras는 신경망에 뛰어나지만 현재 TensorFlow에 통합되어 있어요.",
        expC: "정답입니다! PyTorch는 AI 연구와 제품 구현 모두에 널리 사용되고 있어요.",
        expD: "XGBoost는 그래디언트 부스팅에 특화되어 있어서 일반적인 AI 개발용은 아니에요.",
        points: 1,
        chapter: "AI 소개",
        difficulty: "K1"
      },
    
      // ================= K3 QUESTIONS =================
      {
        id: 230,
        text: "의료 기관이 AI 진단 시스템을 구현하려고 합니다. 안정적인 성능을 보장하기 위한 가장 적절한 접근법은 무엇입니까?",
        options: [
          "규제 준수와 함께 포괄적인 검증 프로토콜 수립",
          "통제된 조건에서 단일 기관 테스팅에 집중",
          "광범위한 검증보다 배포 속도 우선시",
          "다양한 환자 데이터 세트로 시스템 테스트"
        ],
        correct: 3,
        expA: "규제 준수는 중요하지만 다양한 데이터 테스팅이 신뢰성에 더 기본적이에요.",
        expB: "단일 기관 데이터는 시스템이 다른 환경으로 일반화하는 능력을 제한합니다.",
        expC: "의료 분야에서 속도 우선시는 환자 안전과 시스템 신뢰성을 위험에 빠뜨릴 수 있어요.",
        expD: "정확해요! 다양한 데이터 세트는 AI 시스템이 다른 환자군에서 안정적으로 작동하도록 보장해요.",
        points: 2,
        chapter: "AI 소개",
        difficulty: "K3"
      },
      {
        id: 231,
        text: "회사가 비즈니스 애플리케이션을 위해 협소한 AI 또는 일반 AI 중 선택을 평가하고 있습니다. 결정에 가장 영향을 주어야 할 요인은 무엇입니까?",
        options: [
          "현재 기술적 가용성과 비즈니스 필요",
          "예상 투자 수익률 기간",
          "경쟁 우위와 시장 차별화",
          "장기 전략적 기술 로드맵"
        ],
        correct: 0,
        expA: "완벽해요! 실용적 가용성과 실제 비즈니스 요구사항이 기술 선택을 주도해야 해요.",
        expB: "ROI 고려사항은 중요하지만 기술적 실현 가능성이 우선되어야 합니다.",
        expC: "경쟁 우위도 중요하지만 실용적 구현 고려사항을 무시해서는 안 돼요.",
        expD: "전략적 계획은 가치 있지만 현재 능력과 필요가 더 즉각적인 관심사예요.",
        points: 2,
        chapter: "AI 소개",
        difficulty: "K3"
      },
      {
        id: 232,
        text: "AI 시스템을 구현하는 조직이 AI 기반 시스템과 일반적인 시스템 간의 차이를 고려해야 합니다. 가장 적합한 테스팅 접근법은 무엇입니까?",
        options: [
          "AI 시스템의 비결정적 특성에 맞춘 테스팅 방법론",
          "강화된 커버리지를 가진 전통적 테스팅 프로세스",
          "AI별 검증과 결합된 하이브리드 테스팅 접근법",
          "기계학습 알고리즘에 특화된 테스트 기술"
        ],
        correct: 2,
        expA: "비결정적 특성은 중요하지만 AI 검증의 한 측면일 뿐이에요.",
        expB: "전통적 테스팅만으로는 학습과 적응 같은 AI별 행동을 다루지 못해요.",
        expC: "정답입니다! AI 시스템은 포괄적 검증을 위해 전통적 테스팅과 전문화된 기술이 모두 필요해요.",
        expD: "ML별 기술은 유용하지만 완전한 AI 시스템 검증에는 더 넓은 접근이 필요해요.",
        points: 2,
        chapter: "AI 소개",
        difficulty: "K3"
      },
      {
        id: 233,
        text: "조직이 AI 기반 추천 시스템을 개발하고 있습니다. 편향 완화를 위한 가장 효과적인 전략은 무엇입니까?",
        options: [
          "알고리즘 투명성과 설명 가능성 개선",
          "다양하고 대표적인 훈련 데이터 보장",
          "정기적인 성능 모니터링과 편향 감사",
          "사용자 피드백과 인간 감독 통합"
        ],
        correct: 1,
        expA: "투명성은 중요하지만 편향의 근본 원인인 데이터 문제를 직접 해결하지는 못해요.",
        expB: "맞아요! 다양하고 대표적인 데이터는 편향을 방지하는 가장 기본적이고 효과적인 방법이에요.",
        expC: "모니터링은 편향을 감지하는 데 도움되지만 애초에 방지하는 것만큼 효과적이지 않아요.",
        expD: "피드백과 감독은 유용하지만 품질 높은 데이터가 더 근본적인 해결책이에요.",
        points: 2,
        chapter: "AI 소개",
        difficulty: "K3"
      },
      {
        id: 234,
        text: "AIaaS 솔루션을 구현할 때 시스템 신뢰성 보장을 위해 가장 중요한 고려사항은 무엇입니까?",
        options: [
          "서비스 수준 협약과 보안 준수 표준",
          "기존 시스템 아키텍처와의 통합 기능",
          "다양한 컴퓨팅 요구에 대한 확장성 옵션",
          "벤더 지원 품질과 기술 문서"
        ],
        correct: 0,
        expA: "정답이에요! SLA와 보안 준수는 AIaaS 솔루션의 신뢰성과 신뢰성에 직접 영향을 줘요.",
        expB: "통합 기능은 중요하지만 신뢰성은 서비스 가용성과 보안에 초점을 맞춰요.",
        expC: "확장성은 성장을 지원하지만 기본적인 신뢰성 우려를 직접 해결하지는 않아요.",
        expD: "지원 품질은 장기적 성공에 영향을 주지만 즉각적 신뢰성은 서비스 보장에 달려 있어요.",
        points: 2,
        chapter: "AI 소개",
        difficulty: "K3"
      },
      {
        id: 235,
        text: "팀이 안전이 중요한 환경에서 작동할 AI 시스템의 테스트를 설계하고 있습니다. 고유한 도전과제를 가장 잘 해결할 접근법은 무엇입니까?",
        options: [
          "강화된 커버리지로 포괄적인 전통적 테스팅 적용",
          "실패 모드 분석에 집중한 리스크 기반 테스팅 구현",
          "비결정적 행동을 위한 전문 테스팅 프로토콜 개발",
          "전통적 테스팅과 AI별 검증 기술 결합"
        ],
        correct: 3,
        expA: "전통적 테스팅만으로는 학습과 적응 같은 AI별 행동을 다루지 못해요.",
        expB: "리스크 기반 접근법은 가치 있지만 AI별 기술과 결합되어야 해요.",
        expC: "비결정적 행동 테스팅은 중요하지만 AI 검증의 한 측면일 뿐이에요.",
        expD: "완벽해요! AI 시스템은 포괄적 검증을 위해 전통적 테스팅과 전문화된 기술이 모두 필요해요.",
        points: 2,
        chapter: "AI 소개",
        difficulty: "K3"
      },
      {
        id: 236,
        text: "조직이 AI 기술을 구현하려 하지만 기술적 전문성이 제한적입니다. 이런 상황에 가장 효과적인 전략은 무엇입니까?",
        options: [
          "내부 역량을 구축하면서 AI 벤더와 파트너십",
          "즉각적인 구현을 위해 외부 컨설턴트 고용",
          "점진적 역량 확장을 통한 파일럿 프로젝트 집중",
          "AIaaS 솔루션으로 시작해서 내부 전문성 개발"
        ],
        correct: 3,
        expA: "파트너십은 가치 있지만 내부 개발에 필요한 실습 학습을 제공하지 못할 수 있어요.",
        expB: "외부 컨설턴트는 즉각적 역량을 제공하지만 지식을 효과적으로 전수하지 못할 수 있어요.",
        expC: "파일럿 프로젝트는 좋지만 확장에 필요한 기초 지식을 제공하지 못할 수 있어요.",
        expD: "현명해요! AIaaS는 점진적인 내부 역량 개발을 허용하면서 즉각적인 가치를 제공해요.",
        points: 2,
        chapter: "AI 소개",
        difficulty: "K3"
      },
    
      // ================= K4 QUESTIONS =================
      {
        id: 237,
        text: "금융 서비스 회사가 혁신과 규제 준수의 균형을 맞춰야 하는 포괄적인 AI 전략을 개발하고 있습니다. 목표를 가장 잘 지원할 접근법은 무엇입니까?",
        options: [
          "모든 사업 부문에 걸친 신속한 AI 구현 우선시",
          "규제 승인된 AI 애플리케이션에만 집중",
          "규제 고려사항과 독립적으로 AI 솔루션 개발",
          "혁신과 준수를 위한 별도 전략 수립"
        ],
        correct: 0,
        expA: "훌륭해요! 신속하지만 체계적인 구현은 준수 감독을 유지하면서 혁신을 허용해요.",
        expB: "승인된 애플리케이션에만 집중하면 혁신과 경쟁 우위가 제한될 수 있어요.",
        expC: "금융 서비스에서 규제 고려사항을 무시하면 상당한 위험을 만들어요.",
        expD: "별도 전략은 갈등과 통합 도전과제를 만들 수 있어요.",
        points: 3,
        chapter: "AI 소개",
        difficulty: "K4"
      },
      {
        id: 238,
        text: "기술 회사가 즉각적인 비즈니스 필요를 위한 협소한 AI 솔루션 투자와 미래 기회를 위한 일반 AI 능력 개발 중 선택해야 합니다. 가장 효과적인 전략적 접근법은 무엇입니까?",
        options: [
          "보장된 단기 수익을 위해 협소한 AI에만 집중",
          "즉각적 필요와 미래 연구 모두를 다루는 균형 잡힌 포트폴리오 생성",
          "장기 경쟁 우위를 위해 주로 일반 AI 개발에 투자",
          "독립적 평가 없이 업계 리더의 전략 따르기"
        ],
        correct: 1,
        expA: "협소한 AI에만 집중하면 중요한 미래 기회와 경쟁 포지셔닝을 놓칠 수 있어요.",
        expB: "훌륭해요! 균형 잡힌 접근법은 현재 비즈니스 필요를 다루면서 미래 기회를 준비해요.",
        expC: "일반 AI 투자만으로는 지속 가능성에 필요한 즉각적 비즈니스 가치를 제공하지 못할 수 있어요.",
        expD: "독립적 분석 없이 다른 사람을 따르면 고유한 비즈니스 상황과 경쟁 차별화를 무시해요.",
        points: 3,
        chapter: "AI 소개",
        difficulty: "K4"
      },
      {
        id: 239,
        text: "다국적 기업이 다양한 기술 인프라를 가진 다양한 시장에 배포할 AI 기술을 평가해야 합니다. 기술 선택 전략에 가장 영향을 주어야 할 요인은 무엇입니까?",
        options: [
          "전 세계적으로 사용 가능한 가장 기술적으로 진보된 솔루션 선택",
          "가장 발전된 시장 요구사항을 기반으로 기술 선택",
          "다양한 인프라 수준에 걸친 확장성과 적응성 평가",
          "최적 로컬 성능을 위한 시장별 AI 기술 구현"
        ],
        correct: 2,
        expA: "가장 진보된 솔루션은 다양한 인프라 환경에서 효과적으로 작동하지 않을 수 있어요.",
        expB: "가장 발전된 시장만을 위한 최적화는 다른 중요한 시장 기회를 무시해요.",
        expC: "완벽해요! 확장 가능하고 적응 가능한 기술은 다양한 인프라 조건에서 성공적인 배포를 보장해요.",
        expD: "시장별 기술은 복잡성을 증가시키고 기업 전체의 규모 경제를 줄여요.",
        points: 3,
        chapter: "AI 소개",
        difficulty: "K4"
      },
      {
        id: 240,
        text: "조직이 즉각적인 비즈니스 필요와 신흥 기술 트렌드의 균형을 맞춰야 하는 장기 AI 전략을 개발하고 있습니다. 지속 가능한 성공을 위한 가장 효과적인 접근법은 무엇입니까?",
        options: [
          "입증된 ROI로 즉각적인 비즈니스 애플리케이션에만 집중",
          "최첨단 실험 기술에 주로 투자",
          "현재 애플리케이션과 미래 연구의 균형을 맞춘 포트폴리오 접근법 생성",
          "기술이 성숙할 때까지 관망하는 접근법 채택"
        ],
        correct: 2,
        expA: "즉각적 필요에만 집중하면 빠르게 진화하는 AI 기술의 특성을 무시해요.",
        expB: "실험 기술에만 투자하면 즉각적인 비즈니스 가치를 제공하지 못할 수 있어요.",
        expC: "정확해요! 균형 잡힌 포트폴리오는 현재 필요를 다루면서 미래 기회를 준비해요.",
        expD: "성숙을 기다리면 경쟁자보다 뒤처지고 시장 기회를 놓칠 수 있어요.",
        points: 3,
        chapter: "AI 소개",
        difficulty: "K4"
      },
      {
        id: 241,
        text: "기술 회사가 제품 개발과 시장 포지셔닝에 대한 AI 효과의 영향을 평가하고 있습니다. 이 현상을 탐색하는 데 가장 도움될 전략은 무엇입니까?",
        options: [
          "기술 혁신보다 마케팅 용어에 집중",
          "실제 가치와 혜택에 집중하여 용어와 관계없이 고객이 능력을 인정하도록 도움",
          "복잡성을 강조하여 AI 인식을 유지",
          "고객 기대치를 맞추기 위해 잘못된 AI 라벨링 사용"
        ],
        correct: 1,
        expA: "마케팅 용어에 집중하면 실질적 가치 제공에서 주의가 분산될 수 있어요.",
        expB: "완벽해요! 실제 가치와 혜택에 집중하면 용어와 관계없이 고객이 능력을 인정하도록 도와줘요.",
        expC: "복잡성 강조는 고객을 혼란스럽게 할 수 있고 AI 효과 도전과제를 해결하지 못해요.",
        expD: "잘못된 AI 라벨링은 고객을 오도하고 기대치가 충족되지 않을 때 신뢰성을 손상시킬 수 있어요.",
        points: 3,
        chapter: "AI 소개",
        difficulty: "K4"
      },
      {
        id: 242,
        text: "빅데이터 처리를 위한 전문화된 테스팅 접근법이 필요한 도메인은? 하나를 선택하세요.",
        options: [
          "Angular 의존성 주입 서비스 패턴",           // 프론트엔드
          "빅데이터 분석 및 머신러닝 시스템",          // AI/ML 도메인 - 정답
          "MySQL 데이터베이스 인덱싱 최적화 기법",    // 데이터베이스
          "Jenkins CI/CD 파이프라인 자동화 워크플로"   // DevOps
        ],
        correct: 1,
        expA: "Angular 서비스는 프론트엔드 의존성을 처리하지, 빅데이터 처리 요구사항은 아닙니다.",
        expB: "맞습니다! AI/ML 맥락에서 빅데이터는 용량과 다양성을 위한 전문화된 테스팅 접근법이 필요합니다.",
        expC: "MySQL 인덱싱은 데이터베이스 성능을 향상시키지만 빅데이터 맥락에 특화되지 않았습니다.",
        expD: "Jenkins는 배포 파이프라인을 자동화하지만 빅데이터 테스팅에 특화되지 않았습니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스팅 개요",
        difficulty: "K1"
      },
      {
        id: 243,
        text: "다음 중 AI 테스팅에서 자동화 편향에 대한 가장 좋은 설명은? 하나를 선택하세요.",
        options: [
          "수동 접근법보다 자동화된 테스팅 도구를 선호하는 것",
          "검증 없이 머신러닝 출력에 지나치게 의존하는 것",
          "인간 감독 없이 테스트 프로세스를 자동화하는 것",
          "AI 시스템을 사용하여 테스트 케이스를 자동 생성하는 것"
        ],
        correct: 1,
        expA: "도구 선호는 방법론적 선택이지, AI 맥락에서의 자동화 편향이 아닙니다.",
        expB: "정확합니다! 자동화 편향은 적절한 검증이나 확인 없이 AI 출력을 신뢰하는 것입니다.",
        expC: "감독 부족은 좋지 않은 관행이지만 자동화 편향의 핵심 정의는 아닙니다.",
        expD: "AI로 테스트 케이스를 생성하는 것은 유용한 기법이지, 편향이 아닙니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스팅 개요",
        difficulty: "K2"
      },
      {
        id: 244,
        text: "다음 중 AI 시스템에서 결정론적 동작과 비결정론적 동작을 가장 잘 구별하는 것은? 하나를 선택하세요.",
        options: [
          "결정론적 시스템은 항상 예측 가능한 반면, 비결정론적 시스템은 확률적 출력을 생성함",
          "결정론적 시스템은 규칙 기반이고, 비결정론적 시스템은 데이터 기반임",
          "결정론적 시스템은 빠르고, 비결정론적 시스템은 느림",
          "결정론적 시스템은 간단하고, 비결정론적 시스템은 복잡함"
        ],
        correct: 0,
        expA: "맞습니다! 결정론적 시스템은 동일한 입력에 대해 항상 동일한 출력을 생성하지만, 비결정론적 시스템은 확률적 변동을 보입니다.",
        expB: "둘 다 규칙 기반이거나 데이터 기반일 수 있습니다 - 핵심 차이는 출력 예측가능성입니다.",
        expC: "속도는 결정론적/비결정론적 동작과 직접적인 관련이 없습니다.",
        expD: "복잡성은 시스템 설계와 관련되지, 동작의 예측가능성과는 다릅니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스팅 개요",
        difficulty: "K2"
      },
      {
        id: 245,
        text: "다음 중 AI 기반 시스템에서 오라클 문제를 해결하는 데 가장 효과적인 접근법은? 하나를 선택하세요.",
        options: [
          "전문가 판단과 통계적 기준을 결합한 다층 검증",
          "완전히 자동화된 출력 검증 시스템 사용",
          "인간 전문가만을 사용한 수동 검증",
          "역사적 데이터와의 단순 비교만 의존"
        ],
        correct: 0,
        expA: "탁월합니다! 다층 접근법은 AI 시스템의 복잡성과 불확실성을 다루는 포괄적인 검증을 제공합니다.",
        expB: "완전한 자동화는 AI 출력의 미묘함과 맥락적 정확성을 놓칠 수 있습니다.",
        expC: "인간만의 검증은 확장 가능하지 않고 일관성이 없을 수 있습니다.",
        expD: "역사적 비교만으로는 AI 시스템의 적응성과 새로운 시나리오를 다루지 못합니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스팅 개요",
        difficulty: "K2"
      },
      {
        id: 246,
        text: "다음 중 AI 기반 시스템에서 테스트 데이터 관리의 주요 도전과제는? 하나를 선택하세요.",
        options: [
          "학습, 검증, 테스트 세트 간의 적절한 분리 보장",
          "데이터베이스 백업 스케줄링 및 복구 절차",
          "버전 제어 시스템에서 파일 충돌 해결",
          "테스트 환경에서 네트워크 대역폭 최적화"
        ],
        correct: 0,
        expA: "정확합니다! AI에서 데이터 누출 방지와 편향되지 않은 평가를 위해 적절한 데이터 분리가 중요합니다.",
        expB: "백업과 복구는 일반적인 데이터 관리이지, AI 특화 도전과제가 아닙니다.",
        expC: "버전 제어 충돌은 소프트웨어 개발 문제이지, AI 데이터 관리와 특별히 관련되지 않습니다.",
        expD: "네트워크 최적화는 인프라 관심사이지, AI 데이터 관리의 핵심 도전과제가 아닙니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스팅 개요",
        difficulty: "K2"
      },
      {
        id: 247,
        text: "다음 중 AI 시스템의 테스트 가능성을 개선하는 데 가장 효과적인 설계 원칙은? 하나를 선택하세요.",
        options: [
          "복잡한 모놀리식 아키텍처 사용",
          "모듈형 구성 요소와 명확한 인터페이스",
          "모든 처리에 대한 단일 통합 모델",
          "최대 성능을 위한 고도로 최적화된 코드"
        ],
        correct: 1,
        expA: "모놀리식 아키텍처는 개별 구성 요소를 격리하고 테스트하기 어렵게 만듭니다.",
        expB: "정확합니다! 모듈형 설계는 개별 AI 구성 요소의 독립적 테스팅과 검증을 가능하게 합니다.",
        expC: "단일 모델은 특정 기능이나 문제를 격리하고 디버깅하기 어렵게 만듭니다.",
        expD: "최적화된 코드가 성능을 향상시킬 수 있지만, 테스트 가능성을 희생할 수 있습니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스팅 개요",
        difficulty: "K2"
      },
      {
        id: 248,
        text: "다음 중 AI 기반 시스템에서 회귀 테스팅의 주요 복잡성은? 하나를 선택하세요.",
        options: [
          "모델 업데이트로 인한 비결정론적 동작 변화",
          "전통적인 소프트웨어와 동일한 테스트 케이스 재사용",
          "테스트 실행 시간이 일정하게 유지됨",
          "AI 구성 요소에 대한 고정된 성능 기준선"
        ],
        correct: 0,
        expA: "맞습니다! AI 모델 업데이트는 예측하기 어려운 동작 변화를 일으켜 회귀 테스팅을 복잡하게 만듭니다.",
        expB: "AI 시스템은 동적 동작으로 인해 종종 새로운 테스트 접근법이 필요합니다.",
        expC: "AI 테스팅은 모델 복잡성과 데이터 변화로 인해 가변적인 실행 시간을 가집니다.",
        expD: "AI 시스템은 지속적인 학습과 개선으로 인해 진화하는 기준선을 가집니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스팅 개요",
        difficulty: "K2"
      },
      {
        id: 249,
        text: "다음 중 AI 기반 시스템의 성능 테스팅에서 고려해야 할 독특한 측면은? 하나를 선택하세요.",
        options: [
          "추론 지연시간, 정확도, 자원 소비 간의 균형",
          "표준 하드웨어 벤치마크만 측정",
          "단순한 응답 시간 메트릭에만 집중",
          "전통적인 부하 테스팅 패턴만 사용"
        ],
        correct: 0,
        expA: "탁월합니다! AI 성능 테스팅은 속도, 정확도, 자원 사용량 간의 복잡한 절충을 평가해야 합니다.",
        expB: "표준 벤치마크만으로는 AI 특화 성능 특성을 포착하지 못합니다.",
        expC: "응답 시간만으로는 정확도나 모델 품질을 고려하지 못합니다.",
        expD: "전통적인 부하 패턴은 AI 워크로드의 독특한 특성을 반영하지 못할 수 있습니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 개요",
        difficulty: "K3"
      },
      {
        id: 250,
        text: "멀티모달 AI 시스템(텍스트, 이미지, 오디오 처리)을 테스팅할 때 가장 효과적인 전략은? 하나를 선택하세요.",
        options: [
          "각 모달리티를 완전히 독립적으로 테스트",
          "모달리티별 테스팅과 크로스모달 상호작용 검증을 결합",
          "텍스트 모달리티에만 집중하고 다른 것들 무시",
          "무작위 테스팅으로 모든 조합 커버"
        ],
        correct: 1,
        expA: "독립적 테스팅만으로는 모달리티 간 중요한 상호작용과 통합 문제를 놓칩니다.",
        expB: "정확합니다! 이는 모달리티 전반에 걸친 체계적 커버리지를 보장하면서 중요한 크로스모달 상호작용을 검증합니다.",
        expC: "하나의 모달리티에 집중하는 것은 멀티모달 통합의 복잡성을 무시합니다.",
        expD: "무작위 테스팅은 멀티모달 시스템 신뢰성에 필요한 체계적 커버리지가 부족합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 개요",
        difficulty: "K3"
      },
      {
        id: 251,
        text: "AI 기반 추천 시스템을 테스팅할 때 편향을 탐지하고 완화하는 가장 포괄적인 접근법은? 하나를 선택하세요.",
        options: [
          "다양한 사용자 그룹에 걸친 공정성 메트릭 분석",
          "기술적 성능 지표에만 집중",
          "단일 인구통계적 그룹으로만 테스트",
          "추천 정확도만 측정"
        ],
        correct: 0,
        expA: "탁우습니다! 다양한 사용자 그룹에 걸친 공정성 분석은 시스템적 편향을 식별하고 해결합니다.",
        expB: "기술적 메트릭만으로는 사회적 영향이나 공정성 문제를 포착하지 못합니다.",
        expC: "단일 그룹 테스팅은 다른 인구통계에 대한 편향된 동작을 놓칩니다.",
        expD: "정확도만으로는 추천이 공정하거나 편향되지 않았는지 보장하지 못합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 개요",
        difficulty: "K3"
      },
      {
        id: 252,
        text: "자율주행차의 AI 시스템을 테스팅할 때 안전성을 보장하는 가장 중요한 전략은? 하나를 선택하세요.",
        options: [
          "실제 도로 테스팅에만 의존",
          "시뮬레이션과 실제 테스팅을 계층화된 접근법으로 결합",
          "기본적인 기능 테스팅만 수행",
          "최적 조건에서만 테스트"
        ],
        correct: 1,
        expA: "실제 테스팅만으로는 위험하고 모든 가능한 시나리오를 커버할 수 없습니다.",
        expB: "완벽합니다! 계층화된 접근법은 제어된 환경에서 포괄적 검증을 제공한 후 실제 조건으로 진행합니다.",
        expC: "기본 테스팅만으로는 복잡한 실제 시나리오에서 안전성을 보장하지 못합니다.",
        expD: "최적 조건 테스팅은 중요한 엣지 케이스와 어려운 상황을 놓칩니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 개요",
        difficulty: "K3"
      },
      {
        id: 253,
        text: "연속 학습 AI 시스템을 테스팅할 때 진화하는 동작을 관리하는 가장 효과적인 접근법은? 하나를 선택하세요.",
        options: [
          "학습 능력 완전히 비활성화",
          "초기 배포 후 테스팅 중단",
          "적응형 모니터링과 지속적 검증 구현",
          "고정된 성능 기준만 사용"
        ],
        correct: 2,
        expA: "학습 비활성화는 시스템의 적응 능력이라는 핵심 가치를 제거합니다.",
        expB: "테스팅 중단은 시스템이 진화함에 따라 문제를 탐지하지 못하게 합니다.",
        expC: "정확합니다! 적응형 접근법은 시스템이 학습하고 변화함에 따라 지속적인 품질 보장을 제공합니다.",
        expD: "고정된 기준은 진화하는 시스템의 동적 특성에 적응하지 못합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 개요",
        difficulty: "K3"
      },
      {
        id: 254,
        text: "대규모 언어 모델(LLM)을 테스팅할 때 출력 품질을 평가하는 가장 포괄적인 접근법은? 하나를 선택하세요.",
        options: [
          "간단한 키워드 매칭만 사용",
          "자동화된 메트릭, 인간 평가, 작업별 벤치마크를 결합",
          "기술적 성능 지표에만 의존",
          "단일 평가 기준만 적용"
        ],
        correct: 1,
        expA: "키워드 매칭은 언어 출력의 의미론적 품질이나 맥락 적절성을 포착하지 못합니다.",
        expB: "탁월합니다! 다면적 평가는 LLM 출력의 다양한 품질 차원을 포괄적으로 평가합니다.",
        expC: "기술적 메트릭만으로는 언어 출력의 인간 인식 품질을 평가하지 못합니다.",
        expD: "단일 기준은 LLM 출력 품질의 복잡하고 다차원적 특성을 충분히 평가하지 못합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 개요",
        difficulty: "K3"
      },
      {
        id: 255,
        text: "높은 규제 요구사항을 가진 의료 AI 시스템에 대한 테스팅 전략을 개발할 때 가장 중요한 고려사항은? 하나를 선택하세요.",
        options: [
          "개발 비용 최소화에만 집중",
          "가장 빠른 시장 출시를 우선시",
          "포괄적인 검증, 추적가능성, 규제 준수를 우선시",
          "기본적인 기능 테스팅으로 제한"
        ],
        correct: 2,
        expA: "비용만 고려하는 것은 의료 AI의 안전성과 효과성 요구사항을 무시합니다.",
        expB: "빠른 출시는 환자 안전과 규제 승인에 필요한 철저한 검증을 훼손할 수 있습니다.",
        expC: "완벽합니다! 의료 AI는 환자 안전과 규제 승인을 위해 엄격한 검증과 문서화가 필요합니다.",
        expD: "기본 테스팅은 복잡한 의료 시나리오와 환자 안전 요구사항에 부적절합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 개요",
        difficulty: "K4"
      },
      {
        id: 256,
        text: "여러 팀과 이해관계자가 참여하는 엔터프라이즈 AI 프로젝트에서 테스팅을 조정하는 가장 효과적인 접근법은? 하나를 선택하세요.",
        options: [
          "각 팀이 독립적으로 테스팅하도록 허용",
          "단일 중앙집중식 테스팅 팀만 사용",
          "통합된 테스팅 프레임워크와 명확한 역할 정의",
          "테스팅을 완전히 외부 업체에 아웃소싱"
        ],
        correct: 2,
        expA: "독립적 테스팅은 일관성 부족과 통합 문제로 이어질 수 있습니다.",
        expB: "중앙집중만으로는 다양한 AI 구성 요소의 전문 지식이 부족할 수 있습니다.",
        expC: "정확합니다! 통합된 프레임워크는 일관성을 보장하면서 전문 지식을 활용합니다.",
        expD: "완전한 아웃소싱은 내부 AI 지식과 비즈니스 맥락에 대한 이해가 부족할 수 있습니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 개요",
        difficulty: "K4"
      },
      {
        id: 257,
        text: "실시간 사기 탐지 AI 시스템의 배포 전 검증을 위한 가장 포괄적인 전략은? 하나를 선택하세요.",
        options: [
          "역사적 데이터로만 테스트",
          "기본적인 성능 메트릭만 확인",
          "시뮬레이션된 공격 시나리오, 실시간 성능, 오탐 분석 결합",
          "단순한 규칙 기반 검증만 사용"
        ],
        correct: 2,
        expA: "역사적 데이터만으로는 새로운 사기 패턴이나 실시간 성능을 검증하지 못합니다.",
        expB: "기본 메트릭만으로는 사기 탐지의 복잡한 요구사항을 다루지 못합니다.",
        expC: "탁월합니다! 포괄적인 접근법은 다양한 위협과 운영 조건에서 시스템 효과성을 보장합니다.",
        expD: "규칙 기반 검증만으로는 AI 시스템의 적응적 특성을 평가하지 못합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 개요",
        difficulty: "K4"
      },
      {
        id: 258,
        text: "다국어 고객 서비스 챗봇의 품질을 보장하는 가장 효과적인 테스팅 전략은? 하나를 선택하세요.",
        options: [
          "한 언어로만 테스트하고 번역 정확성 가정",
          "문화적 고려사항 없이 기술적 기능에만 집중",
          "원어민과 함께하는 문화 인식 테스팅 구현",
          "모든 테스트 시나리오에 자동 번역 도구 사용"
        ],
        correct: 2,
        expA: "번역 가정은 문화적 뉘앙스와 맥락별 오류를 놓칠 수 있습니다.",
        expB: "기술적 테스팅만으로는 중요한 사용자 경험 측면을 놓칩니다.",
        expC: "완벽합니다! 문화적 인식과 원어민 참여는 포괄적인 품질 검증을 보장합니다.",
        expD: "자동 번역은 오류를 도입하고 문화적 맥락을 놓칠 수 있습니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 개요",
        difficulty: "K4"
      },
      {
        id: 259,
        text: "여러 비즈니스 단위에 걸친 자율 학습 시스템의 테스팅 복잡성을 관리하는 가장 좋은 거버넌스 접근법은? 하나를 선택하세요.",
        options: [
          "모든 자율 학습 능력 제거",
          "모든 단위에 동일한 테스팅 사용",
          "시스템 기능을 기본으로 축소",
          "지속적 모니터링을 통한 위험 기반 테스팅 프레임워크 구현"
        ],
        correct: 3,
        expA: "자율 학습 제거는 테스팅 도전과제를 관리하기보다는 가치 있는 적응 능력을 제거합니다.",
        expB: "다른 비즈니스 단위는 맞춤형 테스팅 접근법이 필요한 다양한 위험 허용도를 가집니다.",
        expC: "기능 축소는 테스팅 복잡성 도전과제를 해결하기보다는 비즈니스 가치를 희생합니다.",
        expD: "맞습니다! 위험 기반 프레임워크는 맞춤형 테스팅 강도를 허용하면서 지속적 모니터링이 진화를 추적합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 개요",
        difficulty: "K4"
      },
      {
        id: 260,
        text: "다음 중 AI 시스템 테스팅을 전통적인 소프트웨어 테스팅과 가장 구별하는 특성은? 하나를 선택하세요.",
        options: [
          "Kubernetes 클러스터 확장 및 관리 요구사항",  // DevOps
          "Vue.js 반응형 데이터 바인딩 및 상태 관리",   // 프론트엔드
          "MongoDB 집계 파이프라인 쿼리 최적화",        // 데이터베이스
          "오라클 정의를 어렵게 만드는 비결정론적 동작"   // AI/ML - 정답
        ],
        correct: 3,
        expA: "Kubernetes 확장은 인프라 관리이지, AI 테스팅 도전과제에 특화되지 않았습니다.",
        expB: "Vue.js 데이터 바인딩은 프론트엔드 개발이며, AI 테스팅 복잡성과 관련이 없습니다.",
        expC: "MongoDB 최적화는 데이터베이스 관리이며, AI 시스템 테스팅에 고유하지 않습니다.",
        expD: "정확합니다! 비결정론적 AI 동작은 테스팅에서 독특한 오라클 문제를 만듭니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스팅 개요",
        difficulty: "K1"
      },
      {
        id: 261,
        text: "확률적 AI 시스템 출력을 검증하는 데 사용되는 접근법은? 하나를 선택하세요.",
        options: [
          "React 컴포넌트 프롭 검증과 타입 체킹",           // 프론트엔드
          "PostgreSQL 트랜잭션 격리 및 일관성 레벨",       // 데이터베이스
          "Docker 컨테이너 상태 모니터링과 재시작 정책",    // DevOps
          "통계적 허용 기준과 신뢰 구간"                    // AI/ML 도메인 - 정답
        ],
        correct: 3,
        expA: "React 검증은 프론트엔드 컴포넌트 속성을 처리하지, AI 시스템 출력 검증이 아닙니다.",
        expB: "PostgreSQL 격리는 데이터베이스 일관성을 보장하지, 확률적 AI 출력 검증은 아닙니다.",
        expC: "Docker 모니터링은 컨테이너 상태를 관리하지, AI 시스템의 확률적 출력 검증은 아닙니다.",
        expD: "정확합니다! 확률적 AI 시스템은 허용 가능한 범위 내에서 출력을 검증하기 위한 통계적 방법이 필요합니다.",
        points: 1,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K1"
      },
      {
        id: 262,
        text: "AI 시스템에서 불공정한 처리 패턴을 설명하는 개념은? 하나를 선택하세요.",
        options: [
          "Vue.js 반응형 데이터 바인딩과 계산된 속성",      // 프론트엔드
          "MongoDB 집계 파이프라인 최적화 기법",           // 데이터베이스
          "Kubernetes 리소스 할당량과 스케줄링 정책",      // DevOps
          "알고리즘 편향과 체계적 차별"                    // AI/ML 도메인 - 정답
        ],
        correct: 3,
        expA: "Vue.js는 프론트엔드 반응성을 처리하지, AI 시스템의 공정성이나 차별 문제가 아닙니다.",
        expB: "MongoDB 집계는 데이터베이스 쿼리를 최적화하지, AI 공정성이나 편향 문제가 아닙니다.",
        expC: "Kubernetes는 리소스 할당을 관리하지, AI 시스템의 편향이나 차별 패턴이 아닙니다.",
        expD: "완벽합니다! 알고리즘 편향은 AI 의사결정에서 체계적인 불공정한 차별을 의미합니다.",
        points: 1,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K1"
      },
      {
        id: 263,
        text: "다음 중 자율 학습 시스템을 테스팅하는 데 가장 좋은 접근법은? 하나를 선택하세요.",
        options: [
          "적응형 AI 기준선을 통한 지속적 모니터링",
          "고정된 성능 벤치마크를 사용한 정적 모델 검증",
          "과거 데이터 검증을 통한 주기적 재훈련 주기",
          "학습 알고리즘 파라미터 변경의 수동 검토"
        ],
        correct: 0,
        expA: "맞습니다! 자율 학습 시스템은 동작이 지속적으로 진화하기 때문에 적응형 모니터링이 필요합니다.",
        expB: "고정된 벤치마크는 자율 학습 시스템이 새로운 패턴에 적응함에 따라 구식이 됩니다.",
        expC: "주기적 접근법은 자율 학습 시스템 동작의 지속적인 변화를 놓칩니다.",
        expD: "수동 검토는 진화하는 시스템의 모든 파라미터 변경을 모니터링하기에는 확장성이 없습니다.",
        points: 2,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K2"
      },
      {
        id: 264,
        text: "다음 중 자율 시스템을 테스팅할 때 가장 중요한 것은? 하나를 선택하세요.",
        options: [
          "실시간 의사결정 성능 최적화",
          "다중 환경 안전성 검증 프로토콜",
          "엣지 케이스 동작 분석 및 포괄적 테스팅",
          "다양한 환경 조건에서 센서 융합 정확도"
        ],
        correct: 1,
        expA: "성능 최적화는 중요하지만 안전성 검증 요구사항에 비해서는 부차적입니다.",
        expB: "절대적으로! 다양한 환경에서의 안전성 검증은 자율 시스템에서 가장 중요합니다.",
        expC: "엣지 케이스 테스팅은 중요하지만 안전성 검증이 더 광범위한 보호를 제공합니다.",
        expD: "센서 정확도는 중요하지만 전체 안전성 검증이 더 광범위한 위험을 다룹니다.",
        points: 2,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K2"
      },
      {
        id: 265,
        text: "알고리즘 편향을 테스팅하는 데 가장 효과적인 접근법은? 하나를 선택하세요.",
        options: [
          "동질적인 데이터 그룹으로만 테스트",
          "기술적 정확도 메트릭에만 독점적으로 집중",
          "공정성 메트릭을 포함한 다양한 데이터셋 사용",
          "인구통계학적 고려사항을 완전히 회피"
        ],
        correct: 2,
        expA: "동질적 데이터는 다른 인구통계 그룹에 영향을 미치는 편향 패턴을 드러낼 수 없습니다.",
        expB: "기술적 정확도만으로는 다른 인구 그룹에 걸친 공정성을 포착하지 못합니다.",
        expC: "정확합니다! 공정성 메트릭이 포함된 다양한 데이터는 편향 패턴을 드러내고 공평한 시스템 동작을 가능하게 합니다.",
        expD: "인구통계를 회피하는 것은 체계적 차별 패턴의 탐지를 방해합니다.",
        points: 2,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K2"
      },
      {
        id: 266,
        text: "비결정론적 AI 시스템을 테스팅할 때 가장 중요한 도전과제는? 하나를 선택하세요.",
        options: [
          "일관된 테스트 결과를 위한 예측 가능한 출력 확보",
          "동일한 입력에 대한 다양한 출력 처리",
          "다양성으로 인한 성능 벤치마크 설정",
          "확률적 동작을 위한 테스트 오라클 정의"
        ],
        correct: 3,
        expA: "예측 가능한 출력 확보는 중요하지만 오라클 정의가 더 근본적인 도전과제입니다.",
        expB: "다양한 출력 처리는 기술적 문제이지만 오라클 정의가 핵심 어려움입니다.",
        expC: "벤치마크 설정은 중요하지만 적절한 검증 기준 설정이 더 근본적입니다.",
        expD: "정확합니다! 비결정론적 시스템에서 적절한 테스트 오라클을 정의하는 것이 가장 큰 도전과제입니다.",
        points: 2,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K2"
      },
      {
        id: 267,
        text: "다음 중 AI 시스템의 투명성을 평가하는 가장 좋은 방법은? 하나를 선택하세요.",
        options: [
          "모델 성능 메트릭만 분석",
          "의사결정 추적 가능성과 설명 가능성 평가",
          "처리 속도와 효율성에만 집중",
          "입력 데이터 품질만 검증"
        ],
        correct: 1,
        expA: "성능 메트릭만으로는 시스템이 어떻게 결정을 내리는지 이해할 수 없습니다.",
        expB: "완벽합니다! 의사결정 추적 가능성과 설명 가능성이 AI 투명성의 핵심 요소입니다.",
        expC: "속도와 효율성은 운영 메트릭이지, 투명성과는 직접적으로 관련이 없습니다.",
        expD: "데이터 품질은 중요하지만 시스템의 의사결정 투명성을 평가하지는 못합니다.",
        points: 2,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K2"
      },
      {
        id: 268,
        text: "다음 중 AI 시스템의 견고성을 테스팅하는 가장 포괄적인 접근법은? 하나를 선택하세요.",
        options: [
          "노이즈가 있는 데이터와 적대적 입력에 대한 테스팅",
          "완벽한 조건에서의 정확도 측정만",
          "표준 데이터셋에 대한 성능 평가만",
          "단일 메트릭을 사용한 모델 검증만"
        ],
        correct: 0,
        expA: "정확합니다! 견고성 테스팅은 노이즈, 적대적 입력, 예상치 못한 조건에서 시스템 안정성을 평가해야 합니다.",
        expB: "완벽한 조건만으로는 실제 환경의 도전적인 상황에서 견고성을 평가할 수 없습니다.",
        expC: "표준 데이터셋만으로는 시스템이 예상치 못한 입력에 어떻게 반응하는지 평가하지 못합니다.",
        expD: "단일 메트릭은 견고성의 다차원적 특성을 포괄적으로 평가하지 못합니다.",
        points: 2,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K2"
      },
      {
        id: 269,
        text: "다음 중 AI 시스템의 적응성을 평가하는 가장 적절한 방법은? 하나를 선택하세요.",
        options: [
          "정적 환경에서의 성능만 측정",
          "변화하는 환경과 새로운 데이터에 대한 적응 능력 평가",
          "초기 훈련 데이터에 대한 정확도만 확인",
          "고정된 알고리즘 파라미터 유지"
        ],
        correct: 1,
        expA: "정적 환경만으로는 시스템의 적응 능력을 평가할 수 없습니다.",
        expB: "맞습니다! 적응성은 변화하는 조건과 새로운 데이터에 대해 시스템이 얼마나 잘 적응하는지를 측정합니다.",
        expC: "초기 데이터에 대한 정확도는 새로운 상황에 대한 적응성을 나타내지 않습니다.",
        expD: "고정된 파라미터는 적응성과 반대되는 개념입니다.",
        points: 2,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K2"
      },
      {
        id: 270,
        text: "금융 AI 시스템에서 편향을 탐지하고 완화하는 가장 효과적인 전략은? 하나를 선택하세요.",
        options: [
          "단일 인구통계 그룹으로만 테스트",
          "다양한 인구통계에 걸친 공정성 메트릭 분석",
          "기술적 성능에만 집중",
          "규제 요구사항 무시"
        ],
        correct: 1,
        expA: "단일 그룹 테스팅은 다른 인구통계에 대한 편향된 결과를 놓칠 수 있습니다.",
        expB: "탁월합니다! 다양한 인구통계에 걸친 공정성 분석은 금융 서비스에서 편향을 식별하고 완화하는 핵심입니다.",
        expC: "기술적 성능만으로는 사회적 공정성과 규제 준수 요구사항을 다루지 못합니다.",
        expD: "금융 AI는 반드시 공정성과 비차별에 관한 규제 요구사항을 준수해야 합니다.",
        points: 3,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K3"
      },
      {
        id: 271,
        text: "의료 진단 AI 시스템의 신뢰성을 보장하는 가장 포괄적인 접근법은? 하나를 선택하세요.",
        options: [
          "단일 성능 메트릭만 사용",
          "다중 검증 방법과 임상 전문가 검토 결합",
          "자동화된 테스팅에만 의존",
          "기본적인 정확도 측정만 수행"
        ],
        correct: 1,
        expA: "단일 메트릭으로는 의료 진단의 복잡성과 중요성을 포괄적으로 평가하지 못합니다.",
        expB: "정확합니다! 의료 AI는 다중 검증과 임상 전문지식이 결합된 포괄적 접근법이 필요합니다.",
        expC: "자동화만으로는 의료 맥락과 임상적 판단의 미묘함을 놓칠 수 있습니다.",
        expD: "기본 정확도만으로는 환자 안전에 필요한 포괄적 신뢰성 평가가 부족합니다.",
        points: 3,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K3"
      },
      {
        id: 272,
        text: "자율주행 AI 시스템의 윤리적 의사결정을 테스팅하는 가장 적절한 방법은? 하나를 선택하세요.",
        options: [
          "기술적 성능에만 집중",
          "윤리적 딜레마 시나리오와 의사결정 투명성 평가",
          "속도 최적화만 고려",
          "기본적인 기능 테스팅만 수행"
        ],
        correct: 1,
        expA: "기술적 성능만으로는 복잡한 윤리적 상황에서의 의사결정 품질을 평가하지 못합니다.",
        expB: "완벽합니다! 윤리적 딜레마 시나리오는 자율주행 시스템의 도덕적 의사결정 능력을 테스트하는 핵심입니다.",
        expC: "속도 최적화는 중요하지만 윤리적 의사결정 능력에 비해서는 부차적입니다.",
        expD: "기본 기능 테스팅만으로는 복잡한 윤리적 상황을 다루지 못합니다.",
        points: 3,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K3"
      },
      {
        id: 273,
        text: "AI 추천 시스템의 다양성을 평가하는 가장 효과적인 접근법은? 하나를 선택하세요.",
        options: [
          "추천 정확도만 측정",
          "사용자 만족도만 고려",
          "추천 범위의 다양성과 편향 방지 메트릭 분석",
          "시스템 응답 시간만 평가"
        ],
        correct: 2,
        expA: "정확도만으로는 추천의 다양성이나 편향 문제를 파악하지 못합니다.",
        expB: "사용자 만족도는 중요하지만 다양성의 객관적 측정을 제공하지는 못합니다.",
        expC: "정확합니다! 다양성 메트릭과 편향 방지 분석은 균형잡힌 추천 시스템을 보장합니다.",
        expD: "응답 시간은 성능 메트릭이지, 추천 다양성과는 관련이 없습니다.",
        points: 3,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K3"
      },
      {
        id: 274,
        text: "대화형 AI 시스템의 사용자 경험을 테스팅하는 가장 포괄적인 방법은? 하나를 선택하세요.",
        options: [
          "기술적 메트릭만 분석",
          "자연스러운 대화 흐름, 맥락 이해, 사용자 만족도 평가",
          "응답 속도만 측정",
          "정확한 키워드 매칭만 확인"
        ],
        correct: 1,
        expA: "기술적 메트릭만으로는 사용자와의 상호작용 품질을 포괄적으로 평가하지 못합니다.",
        expB: "탁월합니다! 대화형 AI는 자연스러운 상호작용, 맥락 이해, 전반적 사용자 경험을 종합 평가해야 합니다.",
        expC: "응답 속도는 중요하지만 대화의 품질과 자연스러움을 평가하지는 못합니다.",
        expD: "키워드 매칭만으로는 대화의 맥락과 의미를 포착하지 못합니다.",
        points: 3,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K3"
      },
      {
        id: 275,
        text: "AI 기반 품질 관리 시스템의 일관성을 테스팅하는 가장 적절한 전략은? 하나를 선택하세요.",
        options: [
          "단일 조건에서만 테스트",
          "다양한 운영 조건에서 일관된 품질 기준 적용 검증",
          "최적 상황에서만 평가",
          "기본적인 기능만 확인"
        ],
        correct: 1,
        expA: "단일 조건만으로는 다양한 실제 운영 환경에서의 일관성을 평가하지 못합니다.",
        expB: "맞습니다! 품질 관리 AI는 다양한 조건에서 일관된 기준을 적용할 수 있어야 합니다.",
        expC: "최적 상황만으로는 실제 제조 환경의 변동성을 다루지 못합니다.",
        expD: "기본 기능만으로는 복잡한 품질 관리 시나리오를 포괄하지 못합니다.",
        points: 3,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K3"
      },
      {
        id: 276,
        text: "높은 규제 요구사항을 가진 항공 AI 시스템의 안전성을 보장하는 가장 효과적인 전략은? 하나를 선택하세요.",
        options: [
          "기본적인 기능 테스팅만 수행",
          "개발 비용 최소화에만 집중",
          "포괄적인 안전성 분석, 장애 모드 평가, 규제 준수",
          "빠른 배포를 위한 간소화된 테스팅"
        ],
        correct: 2,
        expA: "기본 테스팅만으로는 항공 시스템의 안전 임계적 요구사항을 만족하지 못합니다.",
        expB: "비용 최소화는 항공 안전에 필요한 엄격한 검증을 훼손할 수 있습니다.",
        expC: "완벽합니다! 항공 AI는 승객 안전과 규제 승인을 위해 포괄적인 안전성 분석이 필요합니다.",
        expD: "간소화된 테스팅은 항공 시스템의 안전 임계적 특성에 부적절합니다.",
        points: 3,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K4"
      },
      {
        id: 277,
        text: "자율 시스템의 포괄적인 테스팅을 위한 가장 중요한 고려사항은? 하나를 선택하세요.",
        options: [
          "내비게이션 정확도에만 집중",
          "미적 디자인 선호도 테스트",
          "안전성, 적응성, 윤리적 의사결정 결합",
          "비용 최적화에만 독점적으로 우선순위"
        ],
        correct: 2,
        expA: "내비게이션만으로는 복잡한 환경에서의 안전 위험, 윤리적 딜레마, 적응 요구를 놓칩니다.",
        expB: "미학은 자율 시스템의 근본적인 안전 및 운영 요구사항에 비해 부차적입니다.",
        expC: "맞습니다! 자율 시스템은 안전 프로토콜, 환경 적응성, 윤리적 프레임워크가 필요합니다.",
        expD: "비용 집중은 운영 환경에서 자율 시스템의 안전 임계적 특성을 무시합니다.",
        points: 3,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K4"
      },
      {
        id: 278,
        text: "다중 AI 모델에 대한 적절한 허용 기준을 보장하는 가장 좋은 테스팅 전략은? 하나를 선택하세요.",
        options: [
          "모든 모델에 동일한 기준 사용",
          "규제 준수 고려사항 회피",
          "위험 평가를 통한 모델별 기준 설정",
          "처리 속도에만 집중"
        ],
        correct: 2,
        expA: "다른 AI 모델은 서로 다른 목적을 가지며 위험을 반영하는 맞춤형 허용 기준이 필요합니다.",
        expB: "AI 시스템은 공정성과 투명성에 대한 규제 요구사항을 고려해야 합니다.",
        expC: "완벽합니다! 위험 평가를 통한 모델별 기준은 각 사용 사례에 적절한 표준을 보장합니다.",
        expD: "속도는 중요하지만 비즈니스 애플리케이션에서 정확성, 공정성, 준수성에 비해서는 부차적입니다.",
        points: 3,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K4"
      },
      {
        id: 279,
        text: "다중 모델 진단 시스템에 대한 테스트 오라클을 설정하는 가장 좋은 접근법은? 하나를 선택하세요.",
        options: [
          "단순 다수결 투표만 사용",
          "신뢰도 수준 차이 무시",
          "불확실성 정량화를 통한 가중 앙상블 검증 생성",
          "가장 빠른 모델만 독점적으로 선택"
        ],
        correct: 2,
        expA: "단순 투표는 진단 의사결정에서 모델 신뢰도와 전문성 차이를 무시합니다.",
        expB: "신뢰도 수준은 신뢰성을 나타내며 진단 검증에서 반드시 고려되어야 합니다.",
        expC: "정확합니다! 불확실성 측정을 통한 가중 앙상블은 진단 AI 시스템에 견고한 검증을 제공합니다.",
        expD: "속도만으로는 정확도와 신뢰도가 중요한 진단 의사결정에 부족합니다.",
        points: 3,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K4"
      },
      {
        id: 280,
        text: "비즈니스 단위 전반에 걸친 자율 학습 시스템의 테스팅 복잡성을 가장 잘 관리하는 거버넌스 접근법은? 하나를 선택하세요.",
        options: [
          "모든 자율 학습 기능 제거",
          "모든 단위에 동일한 테스팅 사용",
          "시스템 기능을 기본으로 축소",
          "지속적 모니터링을 통한 위험 기반 테스팅 프레임워크 구현"
        ],
        correct: 3,
        expA: "자율 학습 제거는 테스팅 도전과제를 관리하기보다는 가치 있는 적응 능력을 제거합니다.",
        expB: "다른 비즈니스 단위는 맞춤형 테스팅 접근법이 필요한 다양한 위험 허용도를 가집니다.",
        expC: "기능 축소는 테스팅 복잡성 도전과제를 해결하기보다는 비즈니스 가치를 희생합니다.",
        expD: "맞습니다! 위험 기반 프레임워크는 맞춤형 테스팅 강도를 허용하면서 지속적 모니터링이 진화를 추적합니다.",
        points: 3,
        chapter: "AI 특정 품질 특성 테스팅",
        difficulty: "K4"
      },
      {
        id: 281,
        text: "AI 시스템 업데이트 후 이전 기능이 변경되지 않았음을 보장하는 접근법은? 하나를 선택하세요.",
        options: [
          "Vue.js 컴포넌트 상태 관리와 생명주기 훅",        // 프론트엔드
          "AI 시스템 기능 검증을 위한 회귀 테스팅",         // 테스팅/AI - 정답
          "PostgreSQL 데이터베이스 트랜잭션 롤백 절차",    // 데이터베이스
          "Docker 컨테이너 이미지 버전 관리와 롤백 전략"    // DevOps
        ],
        correct: 1,
        expA: "Vue.js는 프론트엔드 컴포넌트 상태를 관리하지, AI 시스템 기능 검증이 아닙니다.",
        expB: "완벽합니다! 회귀 테스팅은 AI 시스템 업데이트가 기존 기능을 손상시키지 않음을 보장합니다.",
        expC: "PostgreSQL 롤백은 데이터베이스 일관성을 처리하지, AI 시스템 기능 테스팅이 아닙니다.",
        expD: "Docker 버전 관리는 컨테이너 배포를 관리하지, AI 기능 검증이 아닙니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K1"
      },
      {
        id: 282,
        text: "AI 시스템 테스트 검증을 위한 예상 결과를 제공하는 구성 요소는? 하나를 선택하세요.",
        options: [
          "React 훅 의존성과 효과 정리 메커니즘",          // 프론트엔드
          "AI 시스템 검증과 비교를 위한 테스트 오라클",     // 테스팅/AI - 정답
          "MongoDB 복제 세트 구성과 장애조치 시스템",      // 데이터베이스
          "Kubernetes 서비스 디스커버리와 로드밸런싱 규칙"  // DevOps
        ],
        correct: 1,
        expA: "React 훅은 프론트엔드 컴포넌트 효과를 관리하지, 테스트 결과 검증이 아닙니다.",
        expB: "정확합니다! 테스트 오라클은 AI 시스템 출력을 비교하기 위한 예상 결과를 제공합니다.",
        expC: "MongoDB 복제 세트는 데이터베이스 가용성을 보장하지, 테스트 검증이 아닙니다.",
        expD: "Kubernetes 로드밸런싱은 트래픽 분산을 관리하지, 테스트 오라클이 아닙니다.",
        points: 1,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K1"
      },
      {
        id: 283,
        text: "다음 중 AI 테스팅에서 동등성 분할에 대한 올바른 설명은? 하나를 선택하세요.",
        options: [
          "유사한 AI 입력을 그룹화하여 테스팅 노력을 줄임",
          "AI 모델 아키텍처를 복잡도 수준별로 분할",
          "AI 학습 데이터셋을 검증 세그먼트로 분할",
          "AI 추론 파이프라인을 처리 단계별로 세분화"
        ],
        correct: 0,
        expA: "맞습니다! 동등성 분할은 유사하게 동작해야 하는 AI 입력을 그룹화하여 테스팅 노력을 줄입니다.",
        expB: "모델 아키텍처 분할은 시스템 설계이지, 테스팅 기법의 동등성 분할이 아닙니다.",
        expC: "데이터셋 분할은 ML 워크플로우이지, 테스팅에서의 동등성 분할 기법이 아닙니다.",
        expD: "파이프라인 세분화는 시스템 아키텍처이지, 테스팅 입력의 동등성 분할이 아닙니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K2"
      },
      {
        id: 284,
        text: "다음 중 AI 시스템에서 경계값 분석의 주요 목적은? 하나를 선택하세요.",
        options: [
          "AI 모델 파라미터의 임계값에서 동작 테스팅",
          "AI 훈련 데이터의 최소 및 최대값 식별",
          "AI 시스템 메모리 사용량의 상한선 측정",
          "AI 알고리즘 처리 시간의 성능 벤치마크 설정"
        ],
        correct: 0,
        expA: "정확합니다! 경계값 분석은 AI 모델이 임계값이나 경계 조건에서 어떻게 동작하는지 테스트합니다.",
        expB: "데이터 범위 식별은 데이터 분석이지, 테스팅 기법의 경계값 분석이 아닙니다.",
        expC: "메모리 측정은 성능 모니터링이지, 경계값 분석 테스팅 기법이 아닙니다.",
        expD: "성능 벤치마크는 성능 테스팅이지, 경계값 분석의 주요 목적이 아닙니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K2"
      },
      {
        id: 285,
        text: "다음 중 AI 시스템에서 결정 테이블 테스팅의 가장 적절한 적용 사례는? 하나를 선택하세요.",
        options: [
          "복잡한 AI 의사결정 규칙과 조건 조합 테스팅",
          "AI 모델의 훈련 정확도와 손실 함수 추적",
          "AI 시스템의 실시간 추론 지연시간 측정",
          "AI 데이터 파이프라인의 처리량과 병목현상 분석"
        ],
        correct: 0,
        expA: "완벽합니다! 결정 테이블은 AI 시스템의 복잡한 의사결정 로직과 조건 조합을 체계적으로 테스트합니다.",
        expB: "정확도 추적은 모델 훈련 모니터링이지, 결정 테이블 테스팅 기법이 아닙니다.",
        expC: "지연시간 측정은 성능 테스팅이지, 결정 테이블의 적용 사례가 아닙니다.",
        expD: "처리량 분석은 성능 분석이지, 결정 테이블 테스팅 기법이 아닙니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K2"
      },
      {
        id: 286,
        text: "다음 중 AI 시스템에서 상태 전이 테스팅이 가장 유용한 경우는? 하나를 선택하세요.",
        options: [
          "AI 시스템이 다양한 운영 상태 간 전이를 관리할 때",
          "AI 모델이 새로운 데이터로 점진적 학습할 때",
          "AI 알고리즘이 최적화 과정에서 수렴할 때",
          "AI 시스템이 분산 처리에서 병렬 계산할 때"
        ],
        correct: 0,
        expA: "맞습니다! 상태 전이 테스팅은 AI 시스템이 다양한 운영 모드나 상태 간에 올바르게 전환되는지 검증합니다.",
        expB: "점진적 학습은 연속 학습이지, 상태 전이 테스팅의 주요 적용 영역이 아닙니다.",
        expC: "알고리즘 수렴은 최적화 과정이지, 시스템 상태 전이 테스팅이 아닙니다.",
        expD: "병렬 계산은 분산 처리이지, 상태 전이 테스팅의 적용 사례가 아닙니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K2"
      },
      {
        id: 287,
        text: "다음 중 AI 시스템에서 페어와이즈 테스팅의 주요 이점은? 하나를 선택하세요.",
        options: [
          "AI 입력 파라미터의 모든 조합을 효율적으로 커버",
          "AI 모델 아키텍처의 레이어별 성능 분석",
          "AI 시스템의 사용자 인터페이스 반응성 향상",
          "AI 데이터 전처리 과정의 속도 최적화"
        ],
        correct: 0,
        expA: "정확합니다! 페어와이즈 테스팅은 AI 시스템의 입력 파라미터 조합을 효율적으로 커버하여 결함을 발견합니다.",
        expB: "레이어별 분석은 모델 프로파일링이지, 페어와이즈 테스팅의 주요 이점이 아닙니다.",
        expC: "UI 반응성은 사용자 경험이지, 페어와이즈 테스팅의 핵심 이점이 아닙니다.",
        expD: "전처리 최적화는 성능 튜닝이지, 페어와이즈 테스팅의 주요 목적이 아닙니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K2"
      },
      {
        id: 288,
        text: "다음 중 AI 시스템에서 탐색적 테스팅을 적용할 때 가장 중요한 고려사항은? 하나를 선택하세요.",
        options: [
          "AI 모델의 예측 불가능한 동작에 대한 창의적 탐색",
          "AI 시스템의 정해진 테스트 케이스만 실행",
          "AI 알고리즘의 수학적 정확성만 검증",
          "AI 성능 메트릭의 자동화된 측정만 수행"
        ],
        correct: 0,
        expA: "탁월합니다! 탐색적 테스팅은 AI의 예측 불가능한 동작을 창의적으로 탐색하여 예상치 못한 문제를 발견합니다.",
        expB: "정해진 케이스만 실행하는 것은 스크립트 테스팅이지, 탐색적 테스팅의 정신이 아닙니다.",
        expC: "수학적 정확성만 검증하는 것은 제한적이며, 탐색적 테스팅의 창의적 특성을 놓칩니다.",
        expD: "자동화된 측정만으로는 탐색적 테스팅의 인간 직관과 창의성을 활용하지 못합니다.",
        points: 2,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K2"
      },
      {
        id: 289,
        text: "AI 기반 추천 시스템의 개인화 알고리즘을 테스팅하는 가장 효과적인 전략은? 하나를 선택하세요.",
        options: [
          "단일 사용자 프로필로만 테스트",
          "다양한 사용자 행동 패턴과 선호도 시뮬레이션",
          "시스템 성능 메트릭에만 집중",
          "추천 정확도 점수만 측정"
        ],
        correct: 1,
        expA: "단일 프로필만으로는 추천 시스템의 개인화 능력을 포괄적으로 평가할 수 없습니다.",
        expB: "정확합니다! 다양한 사용자 패턴 시뮬레이션은 개인화 알고리즘의 적응성과 정확성을 종합 평가합니다.",
        expC: "성능 메트릭만으로는 추천 품질이나 개인화 정확성을 평가하지 못합니다.",
        expD: "정확도 점수만으로는 사용자 만족도나 다양성 같은 중요한 품질 측면을 놓칩니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K3"
      },
      {
        id: 290,
        text: "컴퓨터 비전 AI 시스템의 이미지 분류 정확도를 테스팅하는 가장 포괄적인 접근법은? 하나를 선택하세요.",
        options: [
          "고품질 이미지로만 테스트",
          "다양한 조명, 각도, 품질의 이미지로 종합 테스팅",
          "흑백 이미지로만 제한하여 테스트",
          "단일 카테고리 이미지만 집중 테스트"
        ],
        correct: 1,
        expA: "고품질 이미지만으로는 실제 환경의 다양한 조건을 반영하지 못합니다.",
        expB: "완벽합니다! 다양한 환경 조건에서의 종합 테스팅은 컴퓨터 비전 시스템의 견고성을 보장합니다.",
        expC: "흑백 이미지만으로는 컬러 이미지 처리 능력을 평가할 수 없습니다.",
        expD: "단일 카테고리만으로는 시스템의 전반적인 분류 성능을 평가하지 못합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K3"
      },
      {
        id: 291,
        text: "자연어 처리 AI 시스템의 언어 이해 능력을 테스팅하는 가장 효과적인 방법은? 하나를 선택하세요.",
        options: [
          "표준 문법 문장으로만 테스트",
          "다양한 언어 스타일, 맥락, 복잡성으로 종합 테스팅",
          "단일 도메인 텍스트로만 제한",
          "짧은 문장으로만 테스트"
        ],
        correct: 1,
        expA: "표준 문법만으로는 실제 언어 사용의 다양성과 복잡성을 반영하지 못합니다.",
        expB: "탁월합니다! 다양한 언어 패턴과 맥락을 통한 종합 테스팅은 NLP 시스템의 실제 이해 능력을 평가합니다.",
        expC: "단일 도메인만으로는 시스템의 일반화 능력과 전이 학습 효과를 평가할 수 없습니다.",
        expD: "짧은 문장만으로는 복잡한 언어 구조나 긴 맥락 이해 능력을 테스트하지 못합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K3"
      },
      {
        id: 292,
        text: "강화학습 AI 에이전트의 의사결정 품질을 테스팅하는 가장 적절한 전략은? 하나를 선택하세요.",
        options: [
          "단일 환경에서만 테스트",
          "다양한 환경 복잡도와 보상 구조에서 적응성 평가",
          "최적 상황에서만 성능 측정",
          "짧은 에피소드로만 제한"
        ],
        correct: 1,
        expA: "단일 환경만으로는 에이전트의 일반화 능력과 적응성을 평가할 수 없습니다.",
        expB: "정확합니다! 다양한 환경과 보상 구조에서의 테스팅은 강화학습 에이전트의 견고한 의사결정 능력을 검증합니다.",
        expC: "최적 상황만으로는 에이전트가 어려운 상황에서 어떻게 대처하는지 평가하지 못합니다.",
        expD: "짧은 에피소드만으로는 장기적 전략과 누적 보상 최적화 능력을 테스트하지 못합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K3"
      },
      {
        id: 293,
        text: "AI 음성 인식 시스템의 정확도를 테스팅할 때 가장 중요한 고려사항은? 하나를 선택하세요.",
        options: [
          "스튜디오 품질 녹음으로만 테스트",
          "다양한 억양, 배경 소음, 말하기 속도로 종합 테스팅",
          "단일 화자의 음성으로만 제한",
          "조용한 환경에서만 테스트"
        ],
        correct: 1,
        expA: "스튜디오 품질만으로는 실제 사용 환경의 다양한 음향 조건을 반영하지 못합니다.",
        expB: "완벽합니다! 다양한 음성 특성과 환경 조건을 통한 테스팅은 음성 인식 시스템의 실용성을 보장합니다.",
        expC: "단일 화자만으로는 다양한 사용자에 대한 시스템의 일반화 능력을 평가할 수 없습니다.",
        expD: "조용한 환경만으로는 실제 사용 환경의 소음 조건에서 성능을 평가하지 못합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K3"
      },
      {
        id: 294,
        text: "AI 이상 탐지 시스템의 효과성을 테스팅하는 가장 포괄적인 방법은? 하나를 선택하세요.",
        options: [
          "알려진 이상 패턴으로만 테스트",
          "정상 데이터와 다양한 유형의 이상 데이터로 균형 테스팅",
          "과거 데이터로만 제한하여 테스트",
          "단일 이상 유형에만 집중"
        ],
        correct: 1,
        expA: "알려진 패턴만으로는 새로운 유형의 이상이나 진화하는 위협을 탐지하는 능력을 평가하지 못합니다.",
        expB: "탁월합니다! 정상 데이터와 다양한 이상 패턴의 균형 테스팅은 시스템의 민감도와 특이도를 종합 평가합니다.",
        expC: "과거 데이터만으로는 현재나 미래의 새로운 이상 패턴에 대한 탐지 능력을 검증하지 못합니다.",
        expD: "단일 이상 유형만으로는 시스템의 전반적인 이상 탐지 범위와 성능을 평가할 수 없습니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K3"
      },
      {
        id: 295,
        text: "AI 시계열 예측 시스템의 정확성을 테스팅하는 가장 효과적인 접근법은? 하나를 선택하세요.",
        options: [
          "단일 시간 범위로만 테스트",
          "다양한 시간 범위와 계절성 패턴으로 종합 테스팅",
          "과거 동일 기간 데이터로만 제한",
          "단기 예측에만 집중"
        ],
        correct: 1,
        expA: "단일 시간 범위만으로는 시스템의 다양한 예측 지평과 적응성을 평가할 수 없습니다.",
        expB: "정확합니다! 다양한 시간 범위와 패턴을 통한 테스팅은 시계열 예측 시스템의 견고성과 정확성을 보장합니다.",
        expC: "동일 기간만으로는 시스템이 새로운 패턴이나 트렌드 변화에 어떻게 반응하는지 평가하지 못합니다.",
        expD: "단기 예측만으로는 장기 예측 능력과 복잡한 시간적 의존성을 테스트하지 못합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K3"
      },
      {
        id: 296,
        text: "높은 정확도가 요구되는 의료 진단 AI 시스템의 테스팅 전략을 설계할 때 가장 중요한 고려사항은? 하나를 선택하세요.",
        options: [
          "개발 비용 최소화에만 집중",
          "빠른 배포 일정을 우선시",
          "임상 검증, 규제 준수, 환자 안전을 종합 고려",
          "기술적 성능 메트릭만 최적화"
        ],
        correct: 2,
        expA: "비용만 고려하는 것은 의료 AI의 환자 안전과 진단 정확성 요구사항을 무시합니다.",
        expB: "빠른 배포는 의료 AI에 필요한 엄격한 검증과 안전성 확보를 훼손할 수 있습니다.",
        expC: "완벽합니다! 의료 AI는 환자 안전, 임상 유효성, 규제 준수를 모두 만족하는 포괄적 접근법이 필요합니다.",
        expD: "기술적 메트릭만으로는 임상 유용성과 환자 안전에 대한 실제 효과를 평가하지 못합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K4"
      },
      {
        id: 297,
        text: "글로벌 사용자를 대상으로 하는 다국어 AI 번역 시스템의 품질 보장을 위한 가장 효과적인 전략은? 하나를 선택하세요.",
        options: [
          "주요 언어 몇 개로만 제한하여 테스트",
          "자동화된 메트릭에만 의존",
          "다양한 언어 쌍, 문화적 맥락, 원어민 검증을 종합",
          "기계 번역 정확도 점수만 측정"
        ],
        correct: 2,
        expA: "주요 언어만으로는 글로벌 사용자의 다양한 언어적, 문화적 요구를 충족하지 못합니다.",
        expB: "자동화된 메트릭만으로는 번역의 문화적 적절성과 자연스러움을 평가할 수 없습니다.",
        expC: "탁월합니다! 다양한 언어 쌍과 문화적 맥락, 원어민 검증을 통한 종합 접근법이 최고 품질을 보장합니다.",
        expD: "정확도 점수만으로는 번역의 유창성, 문화적 적절성, 사용자 만족도를 평가하지 못합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K4"
      },
      {
        id: 298,
        text: "실시간 금융 거래 모니터링 AI 시스템의 테스팅에서 가장 중요한 균형점은? 하나를 선택하세요.",
        options: [
          "속도만 최우선으로 고려",
          "정확도만 중요시하고 속도 무시",
          "거짓 양성 최소화에만 집중",
          "실시간 성능과 사기 탐지 정확도의 최적 균형"
        ],
        correct: 3,
        expA: "속도만 우선시하면 사기 탐지 정확도가 떨어져 금융 손실을 초래할 수 있습니다.",
        expB: "정확도만 중시하면 실시간 거래 처리에 필요한 응답 시간을 충족하지 못합니다.",
        expC: "거짓 양성만 최소화하면 실제 사기를 놓칠 수 있어 더 큰 손실을 초래합니다.",
        expD: "정확합니다! 금융 AI는 실시간 처리 요구사항과 정확한 사기 탐지 사이의 최적 균형이 핵심입니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K4"
      },
      {
        id: 299,
        text: "자율주행 차량의 AI 시스템 테스팅에서 안전성을 보장하는 가장 포괄적인 접근법은? 하나를 선택하세요.",
        options: [
          "시뮬레이션 테스팅에만 의존",
          "실제 도로 테스팅만 수행",
          "시뮬레이션, 폐쇄 코스, 실제 도로의 단계적 통합 테스팅",
          "기본적인 기능 테스팅만 실시"
        ],
        correct: 2,
        expA: "시뮬레이션만으로는 실제 환경의 예측 불가능한 상황과 복잡성을 완전히 재현하지 못합니다.",
        expB: "실제 도로만으로는 위험하고 제어된 조건에서 극한 시나리오를 안전하게 테스트할 수 없습니다.",
        expC: "완벽합니다! 단계적 통합 접근법은 안전성을 점진적으로 검증하면서 포괄적인 테스팅을 보장합니다.",
        expD: "기본 기능만으로는 자율주행의 복잡한 안전 임계적 시나리오를 다루지 못합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K4"
      },
      {
        id: 300,
        text: "멀티모달 AI 시스템(텍스트, 이미지, 오디오 처리)의 테스팅에서 가장 효과적인 전략은? 하나를 선택하세요.",
        options: [
          "각 모달리티를 완전히 독립적으로 테스트",
          "하나의 모달리티에만 집중",
          "모달리티별 테스팅과 크로스모달 상호작용 검증 결합",
          "무작위 테스팅으로 모든 조합 커버"
        ],
        correct: 2,
        expA: "독립적 테스팅만으로는 모달리티 간 중요한 상호작용과 시너지 효과를 검증하지 못합니다.",
        expB: "하나의 모달리티에만 집중하면 멀티모달 시스템의 통합적 장점을 평가할 수 없습니다.",
        expC: "탁월합니다! 이는 모달리티 전반에 걸친 체계적 커버리지를 보장하면서 중요한 크로스모달 상호작용을 검증합니다.",
        expD: "무작위 테스팅은 멀티모달 시스템 신뢰성에 필요한 체계적 커버리지가 부족합니다.",
        points: 3,
        chapter: "AI 기반 시스템 테스팅 방법과 기법",
        difficulty: "K4"
          }
  ]

// Export as fullQuestionPool for consistency
export const fullQuestionPool = examQuestionsKoreanBatch1;